export const Tag: { [key: string]: number } = {
    // command elements
    CommandGroupLength: 0x00000000,
    AffectedSOPClassUID: 0x00000002,
    RequestedSOPClassUID: 0x00000003,
    CommandField: 0x00000100,
    MessageID: 0x00000110,
    MessageIDBeingRespondedTo: 0x00000120,
    MoveDestination: 0x00000600,
    Priority: 0x00000700,
    CommandDataSetType: 0x00000800,
    Status: 0x00000900,
    OffendingElement: 0x00000901,
    ErrorComment: 0x00000902,
    ErrorID: 0x00000903,
    AffectedSOPInstanceUID: 0x00001000,
    RequestedSOPInstanceUID: 0x00001001,
    EventTypeID: 0x00001002,
    AttributeIdentifierList: 0x00001005,
    ActionTypeID: 0x00001008,
    NumberOfRemainingSuboperations: 0x00001020,
    NumberOfCompletedSuboperations: 0x00001021,
    NumberOfFailedSuboperations: 0x00001022,
    NumberOfWarningSuboperations: 0x00001023,
    MoveOriginatorApplicationEntityTitle: 0x00001030,
    MoveOriginatorMessageID: 0x00001031,

    // file meta elements
    FileMetaInformationGroupLength: 0x00020000,
    FileMetaInformationVersion: 0x00020001,
    MediaStorageSOPClassUID: 0x00020002,
    MediaStorageSOPInstanceUID: 0x00020003,
    TransferSyntaxUID: 0x00020010,
    ImplementationClassUID: 0x00020012,
    ImplementationVersionName: 0x00020013,
    SourceApplicationEntityTitle: 0x00020016,
    SendingApplicationEntityTitle: 0x00020017,
    ReceivingApplicationEntityTitle: 0x00020018,
    PrivateInformationCreatorUID: 0x00020100,
    PrivateInformation: 0x00020102,

    // directory elements
    FileSetID: 0x00041130,
    FileSetDescriptorFileID: 0x00041141,
    SpecificCharacterSetOfFileSetDescriptorFile: 0x00041142,
    OffsetOfTheFirstDirectoryRecordOfTheRootDirectoryEntity: 0x00041200,
    OffsetOfTheLastDirectoryRecordOfTheRootDirectoryEntity: 0x00041202,
    FileSetConsistencyFlag: 0x00041212,
    DirectoryRecordSequence: 0x00041220,
    OffsetOfTheNextDirectoryRecord: 0x00041400,
    RecordInUseFlag: 0x00041410,
    OffsetOfReferencedLowerLevelDirectoryEntity: 0x00041420,
    DirectoryRecordType: 0x00041430,
    PrivateRecordUID: 0x00041432,
    ReferencedFileID: 0x00041500,
    MRDRDirectoryRecordOffset: 0x00041504, // retired
    ReferencedSOPClassUIDInFile: 0x00041510,
    ReferencedSOPInstanceUIDInFile: 0x00041511,
    ReferencedTransferSyntaxUIDInFile: 0x00041512,
    ReferencedRelatedGeneralSOPClassUIDInFile: 0x0004151a,
    NumberOfReferences: 0x00041600, // retired

    // data elements
    LengthToEnd: 0x00080001, // retired
    SpecificCharacterSet: 0x00080005,
    LanguageCodeSequence: 0x00080006,
    ImageType: 0x00080008,
    RecognitionCode: 0x00080010, // retired
    InstanceCreationDate: 0x00080012,
    InstanceCreationTime: 0x00080013,
    InstanceCreatorUID: 0x00080014,
    InstanceCoercionDateTime: 0x00080015,
    SOPClassUID: 0x00080016,
    SOPInstanceUID: 0x00080018,
    RelatedGeneralSOPClassUID: 0x0008001a,
    OriginalSpecializedSOPClassUID: 0x0008001b,
    StudyDate: 0x00080020,
    SeriesDate: 0x00080021,
    AcquisitionDate: 0x00080022,
    ContentDate: 0x00080023,
    OverlayDate: 0x00080024, // retired
    CurveDate: 0x00080025, // retired
    AcquisitionDateTime: 0x0008002a,
    StudyTime: 0x00080030,
    SeriesTime: 0x00080031,
    AcquisitionTime: 0x00080032,
    ContentTime: 0x00080033,
    OverlayTime: 0x00080034, // retired
    CurveTime: 0x00080035, // retired
    DataSetType: 0x00080040, // retired
    DataSetSubtype: 0x00080041, // retired
    NuclearMedicineSeriesType: 0x00080042, // retired
    AccessionNumber: 0x00080050,
    IssuerOfAccessionNumberSequence: 0x00080051,
    QueryRetrieveLevel: 0x00080052,
    QueryRetrieveView: 0x00080053,
    RetrieveAETitle: 0x00080054,
    StationAETitle: 0x00080055,
    InstanceAvailability: 0x00080056,
    FailedSOPInstanceUIDList: 0x00080058,
    Modality: 0x00080060,
    ModalitiesInStudy: 0x00080061,
    SOPClassesInStudy: 0x00080062,
    AnatomicRegionsInStudyCodeSequence: 0x00080063,
    ConversionType: 0x00080064,
    PresentationIntentType: 0x00080068,
    Manufacturer: 0x00080070,
    InstitutionName: 0x00080080,
    InstitutionAddress: 0x00080081,
    InstitutionCodeSequence: 0x00080082,
    ReferringPhysicianName: 0x00080090,
    ReferringPhysicianAddress: 0x00080092,
    ReferringPhysicianTelephoneNumbers: 0x00080094,
    ReferringPhysicianIdentificationSequence: 0x00080096,
    ConsultingPhysicianName: 0x0008009c,
    ConsultingPhysicianIdentificationSequence: 0x0008009d,
    CodeValue: 0x00080100,
    ExtendedCodeValue: 0x00080101,
    CodingSchemeDesignator: 0x00080102,
    CodingSchemeVersion: 0x00080103,
    CodeMeaning: 0x00080104,
    MappingResource: 0x00080105,
    ContextGroupVersion: 0x00080106,
    ContextGroupLocalVersion: 0x00080107,
    ExtendedCodeMeaning: 0x00080108,
    CodingSchemeResourcesSequence: 0x00080109,
    CodingSchemeURLType: 0x0008010a,
    ContextGroupExtensionFlag: 0x0008010b,
    CodingSchemeUID: 0x0008010c,
    ContextGroupExtensionCreatorUID: 0x0008010d,
    CodingSchemeURL: 0x0008010e,
    ContextIdentifier: 0x0008010f,
    CodingSchemeIdentificationSequence: 0x00080110,
    CodingSchemeRegistry: 0x00080112,
    CodingSchemeExternalID: 0x00080114,
    CodingSchemeName: 0x00080115,
    CodingSchemeResponsibleOrganization: 0x00080116,
    ContextUID: 0x00080117,
    MappingResourceUID: 0x00080118,
    LongCodeValue: 0x00080119,
    URNCodeValue: 0x00080120,
    EquivalentCodeSequence: 0x00080121,
    MappingResourceName: 0x00080122,
    ContextGroupIdentificationSequence: 0x00080123,
    MappingResourceIdentificationSequence: 0x00080124,
    TimezoneOffsetFromUTC: 0x00080201,
    ResponsibleGroupCodeSequence: 0x00080220,
    EquipmentModality: 0x00080221,
    ManufacturerRelatedModelGroup: 0x00080222,
    PrivateDataElementCharacteristicsSequence: 0x00080300,
    PrivateGroupReference: 0x00080301,
    PrivateCreatorReference: 0x00080302,
    BlockIdentifyingInformationStatus: 0x00080303,
    NonidentifyingPrivateElements: 0x00080304,
    IdentifyingPrivateElements: 0x00080306,
    DeidentificationActionSequence: 0x00080305,
    DeidentificationAction: 0x00080307,
    PrivateDataElement: 0x00080308,
    PrivateDataElementValueMultiplicity: 0x00080309,
    PrivateDataElementValueRepresentation: 0x0008030a,
    PrivateDataElementNumberOfItems: 0x0008030b,
    PrivateDataElementName: 0x0008030c,
    PrivateDataElementKeyword: 0x0008030d,
    PrivateDataElementDescription: 0x0008030e,
    PrivateDataElementEncoding: 0x0008030f,
    PrivateDataElementDefinitionSequence: 0x00080310,
    NetworkID: 0x00081000, // retired
    StationName: 0x00081010,
    StudyDescription: 0x00081030,
    ProcedureCodeSequence: 0x00081032,
    SeriesDescription: 0x0008103e,
    SeriesDescriptionCodeSequence: 0x0008103f,
    InstitutionalDepartmentName: 0x00081040,
    PhysiciansOfRecord: 0x00081048,
    PhysiciansOfRecordIdentificationSequence: 0x00081049,
    PerformingPhysicianName: 0x00081050,
    PerformingPhysicianIdentificationSequence: 0x00081052,
    NameOfPhysiciansReadingStudy: 0x00081060,
    PhysiciansReadingStudyIdentificationSequence: 0x00081062,
    OperatorsName: 0x00081070,
    OperatorIdentificationSequence: 0x00081072,
    AdmittingDiagnosesDescription: 0x00081080,
    AdmittingDiagnosesCodeSequence: 0x00081084,
    ManufacturerModelName: 0x00081090,
    ReferencedResultsSequence: 0x00081100, // retired
    ReferencedStudySequence: 0x00081110,
    ReferencedPerformedProcedureStepSequence: 0x00081111,
    ReferencedSeriesSequence: 0x00081115,
    ReferencedPatientSequence: 0x00081120,
    ReferencedVisitSequence: 0x00081125,
    ReferencedOverlaySequence: 0x00081130, // retired
    ReferencedStereometricInstanceSequence: 0x00081134,
    ReferencedWaveformSequence: 0x0008113a,
    ReferencedImageSequence: 0x00081140,
    ReferencedCurveSequence: 0x00081145, // retired
    ReferencedInstanceSequence: 0x0008114a,
    ReferencedRealWorldValueMappingInstanceSequence: 0x0008114b,
    ReferencedSOPClassUID: 0x00081150,
    ReferencedSOPInstanceUID: 0x00081155,
    DefinitionSourceSequence: 0x00081156,
    SOPClassesSupported: 0x0008115a,
    ReferencedFrameNumber: 0x00081160,
    SimpleFrameList: 0x00081161,
    CalculatedFrameList: 0x00081162,
    TimeRange: 0x00081163,
    FrameExtractionSequence: 0x00081164,
    MultiFrameSourceSOPInstanceUID: 0x00081167,
    RetrieveURL: 0x00081190,
    TransactionUID: 0x00081195,
    WarningReason: 0x00081196,
    FailureReason: 0x00081197,
    FailedSOPSequence: 0x00081198,
    ReferencedSOPSequence: 0x00081199,
    OtherFailuresSequence: 0x0008119a,
    StudiesContainingOtherReferencedInstancesSequence: 0x00081200,
    RelatedSeriesSequence: 0x00081250,
    LossyImageCompressionRetired: 0x00082110, // retired
    DerivationDescription: 0x00082111,
    SourceImageSequence: 0x00082112,
    StageName: 0x00082120,
    StageNumber: 0x00082122,
    NumberOfStages: 0x00082124,
    ViewName: 0x00082127,
    ViewNumber: 0x00082128,
    NumberOfEventTimers: 0x00082129,
    NumberOfViewsInStage: 0x0008212a,
    EventElapsedTimes: 0x00082130,
    EventTimerNames: 0x00082132,
    EventTimerSequence: 0x00082133,
    EventTimeOffset: 0x00082134,
    EventCodeSequence: 0x00082135,
    StartTrim: 0x00082142,
    StopTrim: 0x00082143,
    RecommendedDisplayFrameRate: 0x00082144,
    TransducerPosition: 0x00082200, // retired
    TransducerOrientation: 0x00082204, // retired
    AnatomicStructure: 0x00082208, // retired
    AnatomicRegionSequence: 0x00082218,
    AnatomicRegionModifierSequence: 0x00082220,
    PrimaryAnatomicStructureSequence: 0x00082228,
    AnatomicStructureSpaceOrRegionSequence: 0x00082229, // retired
    PrimaryAnatomicStructureModifierSequence: 0x00082230,
    TransducerPositionSequence: 0x00082240, // retired
    TransducerPositionModifierSequence: 0x00082242, // retired
    TransducerOrientationSequence: 0x00082244, // retired
    TransducerOrientationModifierSequence: 0x00082246, // retired
    AnatomicStructureSpaceOrRegionCodeSequenceTrial: 0x00082251, // retired
    AnatomicPortalOfEntranceCodeSequenceTrial: 0x00082253, // retired
    AnatomicApproachDirectionCodeSequenceTrial: 0x00082255, // retired
    AnatomicPerspectiveDescriptionTrial: 0x00082256, // retired
    AnatomicPerspectiveCodeSequenceTrial: 0x00082257, // retired
    AnatomicLocationOfExaminingInstrumentDescriptionTrial: 0x00082258, // retired
    AnatomicLocationOfExaminingInstrumentCodeSequenceTrial: 0x00082259, // retired
    AnatomicStructureSpaceOrRegionModifierCodeSequenceTrial: 0x0008225a, // retired
    OnAxisBackgroundAnatomicStructureCodeSequenceTrial: 0x0008225c, // retired
    AlternateRepresentationSequence: 0x00083001,
    IrradiationEventUID: 0x00083010,
    SourceIrradiationEventSequence: 0x00083011,
    RadiopharmaceuticalAdministrationEventUID: 0x00083012,
    IdentifyingComments: 0x00084000, // retired
    FrameType: 0x00089007,
    ReferencedImageEvidenceSequence: 0x00089092,
    ReferencedRawDataSequence: 0x00089121,
    CreatorVersionUID: 0x00089123,
    DerivationImageSequence: 0x00089124,
    SourceImageEvidenceSequence: 0x00089154,
    PixelPresentation: 0x00089205,
    VolumetricProperties: 0x00089206,
    VolumeBasedCalculationTechnique: 0x00089207,
    ComplexImageComponent: 0x00089208,
    AcquisitionContrast: 0x00089209,
    DerivationCodeSequence: 0x00089215,
    ReferencedPresentationStateSequence: 0x00089237,
    ReferencedOtherPlaneSequence: 0x00089410,
    FrameDisplaySequence: 0x00089458,
    RecommendedDisplayFrameRateInFloat: 0x00089459,
    SkipFrameRangeFlag: 0x00089460,
    PatientName: 0x00100010,
    PatientID: 0x00100020,
    IssuerOfPatientID: 0x00100021,
    TypeOfPatientID: 0x00100022,
    IssuerOfPatientIDQualifiersSequence: 0x00100024,
    SourcePatientGroupIdentificationSequence: 0x00100026,
    GroupOfPatientsIdentificationSequence: 0x00100027,
    SubjectRelativePositionInImage: 0x00100028,
    PatientBirthDate: 0x00100030,
    PatientBirthTime: 0x00100032,
    PatientBirthDateInAlternativeCalendar: 0x00100033,
    PatientDeathDateInAlternativeCalendar: 0x00100034,
    PatientAlternativeCalendar: 0x00100035,
    PatientSex: 0x00100040,
    PatientInsurancePlanCodeSequence: 0x00100050,
    PatientPrimaryLanguageCodeSequence: 0x00100101,
    PatientPrimaryLanguageModifierCodeSequence: 0x00100102,
    QualityControlSubject: 0x00100200,
    QualityControlSubjectTypeCodeSequence: 0x00100201,
    StrainDescription: 0x00100212,
    StrainNomenclature: 0x00100213,
    StrainStockNumber: 0x00100214,
    StrainSourceRegistryCodeSequence: 0x00100215,
    StrainStockSequence: 0x00100216,
    StrainSource: 0x00100217,
    StrainAdditionalInformation: 0x00100218,
    StrainCodeSequence: 0x00100219,
    GeneticModificationsSequence: 0x00100221,
    GeneticModificationsDescription: 0x00100222,
    GeneticModificationsNomenclature: 0x00100223,
    GeneticModificationsCodeSequence: 0x00100229,
    OtherPatientIDs: 0x00101000, // retired
    OtherPatientNames: 0x00101001,
    OtherPatientIDsSequence: 0x00101002,
    PatientBirthName: 0x00101005,
    PatientAge: 0x00101010,
    PatientSize: 0x00101020,
    PatientSizeCodeSequence: 0x00101021,
    PatientBodyMassIndex: 0x00101022,
    MeasuredAPDimension: 0x00101023,
    MeasuredLateralDimension: 0x00101024,
    PatientWeight: 0x00101030,
    PatientAddress: 0x00101040,
    InsurancePlanIdentification: 0x00101050, // retired
    PatientMotherBirthName: 0x00101060,
    MilitaryRank: 0x00101080,
    BranchOfService: 0x00101081,
    MedicalRecordLocator: 0x00101090, // retired
    ReferencedPatientPhotoSequence: 0x00101100,
    MedicalAlerts: 0x00102000,
    Allergies: 0x00102110,
    CountryOfResidence: 0x00102150,
    RegionOfResidence: 0x00102152,
    PatientTelephoneNumbers: 0x00102154,
    PatientTelecomInformation: 0x00102155,
    EthnicGroup: 0x00102160,
    Occupation: 0x00102180,
    SmokingStatus: 0x001021a0,
    AdditionalPatientHistory: 0x001021b0,
    PregnancyStatus: 0x001021c0,
    LastMenstrualDate: 0x001021d0,
    PatientReligiousPreference: 0x001021f0,
    PatientSpeciesDescription: 0x00102201,
    PatientSpeciesCodeSequence: 0x00102202,
    PatientSexNeutered: 0x00102203,
    AnatomicalOrientationType: 0x00102210,
    PatientBreedDescription: 0x00102292,
    PatientBreedCodeSequence: 0x00102293,
    BreedRegistrationSequence: 0x00102294,
    BreedRegistrationNumber: 0x00102295,
    BreedRegistryCodeSequence: 0x00102296,
    ResponsiblePerson: 0x00102297,
    ResponsiblePersonRole: 0x00102298,
    ResponsibleOrganization: 0x00102299,
    PatientComments: 0x00104000,
    ExaminedBodyThickness: 0x00109431,
    ClinicalTrialSponsorName: 0x00120010,
    ClinicalTrialProtocolID: 0x00120020,
    ClinicalTrialProtocolName: 0x00120021,
    ClinicalTrialSiteID: 0x00120030,
    ClinicalTrialSiteName: 0x00120031,
    ClinicalTrialSubjectID: 0x00120040,
    ClinicalTrialSubjectReadingID: 0x00120042,
    ClinicalTrialTimePointID: 0x00120050,
    ClinicalTrialTimePointDescription: 0x00120051,
    LongitudinalTemporalOffsetFromEvent: 0x00120052,
    LongitudinalTemporalEventType: 0x00120053,
    ClinicalTrialCoordinatingCenterName: 0x00120060,
    PatientIdentityRemoved: 0x00120062,
    DeidentificationMethod: 0x00120063,
    DeidentificationMethodCodeSequence: 0x00120064,
    ClinicalTrialSeriesID: 0x00120071,
    ClinicalTrialSeriesDescription: 0x00120072,
    ClinicalTrialProtocolEthicsCommitteeName: 0x00120081,
    ClinicalTrialProtocolEthicsCommitteeApprovalNumber: 0x00120082,
    ConsentForClinicalTrialUseSequence: 0x00120083,
    DistributionType: 0x00120084,
    ConsentForDistributionFlag: 0x00120085,
    EthicsCommitteeApprovalEffectivenessStartDate: 0x00120086,
    EthicsCommitteeApprovalEffectivenessEndDate: 0x00120087,
    CADFileFormat: 0x00140023, // retired
    ComponentReferenceSystem: 0x00140024, // retired
    ComponentManufacturingProcedure: 0x00140025,
    ComponentManufacturer: 0x00140028,
    MaterialThickness: 0x00140030,
    MaterialPipeDiameter: 0x00140032,
    MaterialIsolationDiameter: 0x00140034,
    MaterialGrade: 0x00140042,
    MaterialPropertiesDescription: 0x00140044,
    MaterialPropertiesFileFormatRetired: 0x00140045, // retired
    MaterialNotes: 0x00140046,
    ComponentShape: 0x00140050,
    CurvatureType: 0x00140052,
    OuterDiameter: 0x00140054,
    InnerDiameter: 0x00140056,
    ComponentWelderIDs: 0x00140100,
    SecondaryApprovalStatus: 0x00140101,
    SecondaryReviewDate: 0x00140102,
    SecondaryReviewTime: 0x00140103,
    SecondaryReviewerName: 0x00140104,
    RepairID: 0x00140105,
    MultipleComponentApprovalSequence: 0x00140106,
    OtherApprovalStatus: 0x00140107,
    OtherSecondaryApprovalStatus: 0x00140108,
    ActualEnvironmentalConditions: 0x00141010,
    ExpiryDate: 0x00141020,
    EnvironmentalConditions: 0x00141040,
    EvaluatorSequence: 0x00142002,
    EvaluatorNumber: 0x00142004,
    EvaluatorName: 0x00142006,
    EvaluationAttempt: 0x00142008,
    IndicationSequence: 0x00142012,
    IndicationNumber: 0x00142014,
    IndicationLabel: 0x00142016,
    IndicationDescription: 0x00142018,
    IndicationType: 0x0014201a,
    IndicationDisposition: 0x0014201c,
    IndicationROISequence: 0x0014201e,
    IndicationPhysicalPropertySequence: 0x00142030,
    PropertyLabel: 0x00142032,
    CoordinateSystemNumberOfAxes: 0x00142202,
    CoordinateSystemAxesSequence: 0x00142204,
    CoordinateSystemAxisDescription: 0x00142206,
    CoordinateSystemDataSetMapping: 0x00142208,
    CoordinateSystemAxisNumber: 0x0014220a,
    CoordinateSystemAxisType: 0x0014220c,
    CoordinateSystemAxisUnits: 0x0014220e,
    CoordinateSystemAxisValues: 0x00142210,
    CoordinateSystemTransformSequence: 0x00142220,
    TransformDescription: 0x00142222,
    TransformNumberOfAxes: 0x00142224,
    TransformOrderOfAxes: 0x00142226,
    TransformedAxisUnits: 0x00142228,
    CoordinateSystemTransformRotationAndScaleMatrix: 0x0014222a,
    CoordinateSystemTransformTranslationMatrix: 0x0014222c,
    InternalDetectorFrameTime: 0x00143011,
    NumberOfFramesIntegrated: 0x00143012,
    DetectorTemperatureSequence: 0x00143020,
    SensorName: 0x00143022,
    HorizontalOffsetOfSensor: 0x00143024,
    VerticalOffsetOfSensor: 0x00143026,
    SensorTemperature: 0x00143028,
    DarkCurrentSequence: 0x00143040,
    DarkCurrentCounts: 0x00143050,
    GainCorrectionReferenceSequence: 0x00143060,
    AirCounts: 0x00143070,
    KVUsedInGainCalibration: 0x00143071,
    MAUsedInGainCalibration: 0x00143072,
    NumberOfFramesUsedForIntegration: 0x00143073,
    FilterMaterialUsedInGainCalibration: 0x00143074,
    FilterThicknessUsedInGainCalibration: 0x00143075,
    DateOfGainCalibration: 0x00143076,
    TimeOfGainCalibration: 0x00143077,
    BadPixelImage: 0x00143080,
    CalibrationNotes: 0x00143099,
    PulserEquipmentSequence: 0x00144002,
    PulserType: 0x00144004,
    PulserNotes: 0x00144006,
    ReceiverEquipmentSequence: 0x00144008,
    AmplifierType: 0x0014400a,
    ReceiverNotes: 0x0014400c,
    PreAmplifierEquipmentSequence: 0x0014400e,
    PreAmplifierNotes: 0x0014400f,
    TransmitTransducerSequence: 0x00144010,
    ReceiveTransducerSequence: 0x00144011,
    NumberOfElements: 0x00144012,
    ElementShape: 0x00144013,
    ElementDimensionA: 0x00144014,
    ElementDimensionB: 0x00144015,
    ElementPitchA: 0x00144016,
    MeasuredBeamDimensionA: 0x00144017,
    MeasuredBeamDimensionB: 0x00144018,
    LocationOfMeasuredBeamDiameter: 0x00144019,
    NominalFrequency: 0x0014401a,
    MeasuredCenterFrequency: 0x0014401b,
    MeasuredBandwidth: 0x0014401c,
    ElementPitchB: 0x0014401d,
    PulserSettingsSequence: 0x00144020,
    PulseWidth: 0x00144022,
    ExcitationFrequency: 0x00144024,
    ModulationType: 0x00144026,
    Damping: 0x00144028,
    ReceiverSettingsSequence: 0x00144030,
    AcquiredSoundpathLength: 0x00144031,
    AcquisitionCompressionType: 0x00144032,
    AcquisitionSampleSize: 0x00144033,
    RectifierSmoothing: 0x00144034,
    DACSequence: 0x00144035,
    DACType: 0x00144036,
    DACGainPoints: 0x00144038,
    DACTimePoints: 0x0014403a,
    DACAmplitude: 0x0014403c,
    PreAmplifierSettingsSequence: 0x00144040,
    TransmitTransducerSettingsSequence: 0x00144050,
    ReceiveTransducerSettingsSequence: 0x00144051,
    IncidentAngle: 0x00144052,
    CouplingTechnique: 0x00144054,
    CouplingMedium: 0x00144056,
    CouplingVelocity: 0x00144057,
    ProbeCenterLocationX: 0x00144058,
    ProbeCenterLocationZ: 0x00144059,
    SoundPathLength: 0x0014405a,
    DelayLawIdentifier: 0x0014405c,
    GateSettingsSequence: 0x00144060,
    GateThreshold: 0x00144062,
    VelocityOfSound: 0x00144064,
    CalibrationSettingsSequence: 0x00144070,
    CalibrationProcedure: 0x00144072,
    ProcedureVersion: 0x00144074,
    ProcedureCreationDate: 0x00144076,
    ProcedureExpirationDate: 0x00144078,
    ProcedureLastModifiedDate: 0x0014407a,
    CalibrationTime: 0x0014407c,
    CalibrationDate: 0x0014407e,
    ProbeDriveEquipmentSequence: 0x00144080,
    DriveType: 0x00144081,
    ProbeDriveNotes: 0x00144082,
    DriveProbeSequence: 0x00144083,
    ProbeInductance: 0x00144084,
    ProbeResistance: 0x00144085,
    ReceiveProbeSequence: 0x00144086,
    ProbeDriveSettingsSequence: 0x00144087,
    BridgeResistors: 0x00144088,
    ProbeOrientationAngle: 0x00144089,
    UserSelectedGainY: 0x0014408b,
    UserSelectedPhase: 0x0014408c,
    UserSelectedOffsetX: 0x0014408d,
    UserSelectedOffsetY: 0x0014408e,
    ChannelSettingsSequence: 0x00144091,
    ChannelThreshold: 0x00144092,
    ScannerSettingsSequence: 0x0014409a,
    ScanProcedure: 0x0014409b,
    TranslationRateX: 0x0014409c,
    TranslationRateY: 0x0014409d,
    ChannelOverlap: 0x0014409f,
    ImageQualityIndicatorType: 0x001440a0,
    ImageQualityIndicatorMaterial: 0x001440a1,
    ImageQualityIndicatorSize: 0x001440a2,
    LINACEnergy: 0x00145002,
    LINACOutput: 0x00145004,
    ActiveAperture: 0x00145100,
    TotalAperture: 0x00145101,
    ApertureElevation: 0x00145102,
    MainLobeAngle: 0x00145103,
    MainRoofAngle: 0x00145104,
    ConnectorType: 0x00145105,
    WedgeModelNumber: 0x00145106,
    WedgeAngleFloat: 0x00145107,
    WedgeRoofAngle: 0x00145108,
    WedgeElement1Position: 0x00145109,
    WedgeMaterialVelocity: 0x0014510a,
    WedgeMaterial: 0x0014510b,
    WedgeOffsetZ: 0x0014510c,
    WedgeOriginOffsetX: 0x0014510d,
    WedgeTimeDelay: 0x0014510e,
    WedgeName: 0x0014510f,
    WedgeManufacturerName: 0x00145110,
    WedgeDescription: 0x00145111,
    NominalBeamAngle: 0x00145112,
    WedgeOffsetX: 0x00145113,
    WedgeOffsetY: 0x00145114,
    WedgeTotalLength: 0x00145115,
    WedgeInContactLength: 0x00145116,
    WedgeFrontGap: 0x00145117,
    WedgeTotalHeight: 0x00145118,
    WedgeFrontHeight: 0x00145119,
    WedgeRearHeight: 0x0014511a,
    WedgeTotalWidth: 0x0014511b,
    WedgeInContactWidth: 0x0014511c,
    WedgeChamferHeight: 0x0014511d,
    WedgeCurve: 0x0014511e,
    RadiusAlongWedge: 0x0014511f,
    ContrastBolusAgent: 0x00180010,
    ContrastBolusAgentSequence: 0x00180012,
    ContrastBolusT1Relaxivity: 0x00180013,
    ContrastBolusAdministrationRouteSequence: 0x00180014,
    BodyPartExamined: 0x00180015,
    ScanningSequence: 0x00180020,
    SequenceVariant: 0x00180021,
    ScanOptions: 0x00180022,
    MRAcquisitionType: 0x00180023,
    SequenceName: 0x00180024,
    AngioFlag: 0x00180025,
    InterventionDrugInformationSequence: 0x00180026,
    InterventionDrugStopTime: 0x00180027,
    InterventionDrugDose: 0x00180028,
    InterventionDrugCodeSequence: 0x00180029,
    AdditionalDrugSequence: 0x0018002a,
    Radionuclide: 0x00180030, // retired
    Radiopharmaceutical: 0x00180031,
    EnergyWindowCenterline: 0x00180032, // retired
    EnergyWindowTotalWidth: 0x00180033, // retired
    InterventionDrugName: 0x00180034,
    InterventionDrugStartTime: 0x00180035,
    InterventionSequence: 0x00180036,
    TherapyType: 0x00180037, // retired
    InterventionStatus: 0x00180038,
    TherapyDescription: 0x00180039, // retired
    InterventionDescription: 0x0018003a,
    CineRate: 0x00180040,
    InitialCineRunState: 0x00180042,
    SliceThickness: 0x00180050,
    KVP: 0x00180060,
    CountsAccumulated: 0x00180070,
    AcquisitionTerminationCondition: 0x00180071,
    EffectiveDuration: 0x00180072,
    AcquisitionStartCondition: 0x00180073,
    AcquisitionStartConditionData: 0x00180074,
    AcquisitionTerminationConditionData: 0x00180075,
    RepetitionTime: 0x00180080,
    EchoTime: 0x00180081,
    InversionTime: 0x00180082,
    NumberOfAverages: 0x00180083,
    ImagingFrequency: 0x00180084,
    ImagedNucleus: 0x00180085,
    EchoNumbers: 0x00180086,
    MagneticFieldStrength: 0x00180087,
    SpacingBetweenSlices: 0x00180088,
    NumberOfPhaseEncodingSteps: 0x00180089,
    DataCollectionDiameter: 0x00180090,
    EchoTrainLength: 0x00180091,
    PercentSampling: 0x00180093,
    PercentPhaseFieldOfView: 0x00180094,
    PixelBandwidth: 0x00180095,
    DeviceSerialNumber: 0x00181000,
    DeviceUID: 0x00181002,
    DeviceID: 0x00181003,
    PlateID: 0x00181004,
    GeneratorID: 0x00181005,
    GridID: 0x00181006,
    CassetteID: 0x00181007,
    GantryID: 0x00181008,
    UniqueDeviceIdentifier: 0x00181009,
    UDISequence: 0x0018100a,
    SecondaryCaptureDeviceID: 0x00181010,
    HardcopyCreationDeviceID: 0x00181011, // retired
    DateOfSecondaryCapture: 0x00181012,
    TimeOfSecondaryCapture: 0x00181014,
    SecondaryCaptureDeviceManufacturer: 0x00181016,
    HardcopyDeviceManufacturer: 0x00181017, // retired
    SecondaryCaptureDeviceManufacturerModelName: 0x00181018,
    SecondaryCaptureDeviceSoftwareVersions: 0x00181019,
    HardcopyDeviceSoftwareVersion: 0x0018101a, // retired
    HardcopyDeviceManufacturerModelName: 0x0018101b, // retired
    SoftwareVersions: 0x00181020,
    VideoImageFormatAcquired: 0x00181022,
    DigitalImageFormatAcquired: 0x00181023,
    ProtocolName: 0x00181030,
    ContrastBolusRoute: 0x00181040,
    ContrastBolusVolume: 0x00181041,
    ContrastBolusStartTime: 0x00181042,
    ContrastBolusStopTime: 0x00181043,
    ContrastBolusTotalDose: 0x00181044,
    SyringeCounts: 0x00181045,
    ContrastFlowRate: 0x00181046,
    ContrastFlowDuration: 0x00181047,
    ContrastBolusIngredient: 0x00181048,
    ContrastBolusIngredientConcentration: 0x00181049,
    SpatialResolution: 0x00181050,
    TriggerTime: 0x00181060,
    TriggerSourceOrType: 0x00181061,
    NominalInterval: 0x00181062,
    FrameTime: 0x00181063,
    CardiacFramingType: 0x00181064,
    FrameTimeVector: 0x00181065,
    FrameDelay: 0x00181066,
    ImageTriggerDelay: 0x00181067,
    MultiplexGroupTimeOffset: 0x00181068,
    TriggerTimeOffset: 0x00181069,
    SynchronizationTrigger: 0x0018106a,
    SynchronizationChannel: 0x0018106c,
    TriggerSamplePosition: 0x0018106e,
    RadiopharmaceuticalRoute: 0x00181070,
    RadiopharmaceuticalVolume: 0x00181071,
    RadiopharmaceuticalStartTime: 0x00181072,
    RadiopharmaceuticalStopTime: 0x00181073,
    RadionuclideTotalDose: 0x00181074,
    RadionuclideHalfLife: 0x00181075,
    RadionuclidePositronFraction: 0x00181076,
    RadiopharmaceuticalSpecificActivity: 0x00181077,
    RadiopharmaceuticalStartDateTime: 0x00181078,
    RadiopharmaceuticalStopDateTime: 0x00181079,
    BeatRejectionFlag: 0x00181080,
    LowRRValue: 0x00181081,
    HighRRValue: 0x00181082,
    IntervalsAcquired: 0x00181083,
    IntervalsRejected: 0x00181084,
    PVCRejection: 0x00181085,
    SkipBeats: 0x00181086,
    HeartRate: 0x00181088,
    CardiacNumberOfImages: 0x00181090,
    TriggerWindow: 0x00181094,
    ReconstructionDiameter: 0x00181100,
    DistanceSourceToDetector: 0x00181110,
    DistanceSourceToPatient: 0x00181111,
    EstimatedRadiographicMagnificationFactor: 0x00181114,
    GantryDetectorTilt: 0x00181120,
    GantryDetectorSlew: 0x00181121,
    TableHeight: 0x00181130,
    TableTraverse: 0x00181131,
    TableMotion: 0x00181134,
    TableVerticalIncrement: 0x00181135,
    TableLateralIncrement: 0x00181136,
    TableLongitudinalIncrement: 0x00181137,
    TableAngle: 0x00181138,
    TableType: 0x0018113a,
    RotationDirection: 0x00181140,
    AngularPosition: 0x00181141, // retired
    RadialPosition: 0x00181142,
    ScanArc: 0x00181143,
    AngularStep: 0x00181144,
    CenterOfRotationOffset: 0x00181145,
    RotationOffset: 0x00181146, // retired
    FieldOfViewShape: 0x00181147,
    FieldOfViewDimensions: 0x00181149,
    ExposureTime: 0x00181150,
    XRayTubeCurrent: 0x00181151,
    Exposure: 0x00181152,
    ExposureInuAs: 0x00181153,
    AveragePulseWidth: 0x00181154,
    RadiationSetting: 0x00181155,
    RectificationType: 0x00181156,
    RadiationMode: 0x0018115a,
    ImageAndFluoroscopyAreaDoseProduct: 0x0018115e,
    FilterType: 0x00181160,
    TypeOfFilters: 0x00181161,
    IntensifierSize: 0x00181162,
    ImagerPixelSpacing: 0x00181164,
    Grid: 0x00181166,
    GeneratorPower: 0x00181170,
    CollimatorGridName: 0x00181180,
    CollimatorType: 0x00181181,
    FocalDistance: 0x00181182,
    XFocusCenter: 0x00181183,
    YFocusCenter: 0x00181184,
    FocalSpots: 0x00181190,
    AnodeTargetMaterial: 0x00181191,
    BodyPartThickness: 0x001811a0,
    CompressionForce: 0x001811a2,
    CompressionPressure: 0x001811a3,
    PaddleDescription: 0x001811a4,
    CompressionContactArea: 0x001811a5,
    DateOfLastCalibration: 0x00181200,
    TimeOfLastCalibration: 0x00181201,
    DateTimeOfLastCalibration: 0x00181202,
    ConvolutionKernel: 0x00181210,
    UpperLowerPixelValues: 0x00181240, // retired
    ActualFrameDuration: 0x00181242,
    CountRate: 0x00181243,
    PreferredPlaybackSequencing: 0x00181244,
    ReceiveCoilName: 0x00181250,
    TransmitCoilName: 0x00181251,
    PlateType: 0x00181260,
    PhosphorType: 0x00181261,
    WaterEquivalentDiameter: 0x00181271,
    WaterEquivalentDiameterCalculationMethodCodeSequence: 0x00181272,
    ScanVelocity: 0x00181300,
    WholeBodyTechnique: 0x00181301,
    ScanLength: 0x00181302,
    AcquisitionMatrix: 0x00181310,
    InPlanePhaseEncodingDirection: 0x00181312,
    FlipAngle: 0x00181314,
    VariableFlipAngleFlag: 0x00181315,
    SAR: 0x00181316,
    dBdt: 0x00181318,
    B1rms: 0x00181320,
    AcquisitionDeviceProcessingDescription: 0x00181400,
    AcquisitionDeviceProcessingCode: 0x00181401,
    CassetteOrientation: 0x00181402,
    CassetteSize: 0x00181403,
    ExposuresOnPlate: 0x00181404,
    RelativeXRayExposure: 0x00181405,
    ExposureIndex: 0x00181411,
    TargetExposureIndex: 0x00181412,
    DeviationIndex: 0x00181413,
    ColumnAngulation: 0x00181450,
    TomoLayerHeight: 0x00181460,
    TomoAngle: 0x00181470,
    TomoTime: 0x00181480,
    TomoType: 0x00181490,
    TomoClass: 0x00181491,
    NumberOfTomosynthesisSourceImages: 0x00181495,
    PositionerMotion: 0x00181500,
    PositionerType: 0x00181508,
    PositionerPrimaryAngle: 0x00181510,
    PositionerSecondaryAngle: 0x00181511,
    PositionerPrimaryAngleIncrement: 0x00181520,
    PositionerSecondaryAngleIncrement: 0x00181521,
    DetectorPrimaryAngle: 0x00181530,
    DetectorSecondaryAngle: 0x00181531,
    ShutterShape: 0x00181600,
    ShutterLeftVerticalEdge: 0x00181602,
    ShutterRightVerticalEdge: 0x00181604,
    ShutterUpperHorizontalEdge: 0x00181606,
    ShutterLowerHorizontalEdge: 0x00181608,
    CenterOfCircularShutter: 0x00181610,
    RadiusOfCircularShutter: 0x00181612,
    VerticesOfThePolygonalShutter: 0x00181620,
    ShutterPresentationValue: 0x00181622,
    ShutterOverlayGroup: 0x00181623,
    ShutterPresentationColorCIELabValue: 0x00181624,
    CollimatorShape: 0x00181700,
    CollimatorLeftVerticalEdge: 0x00181702,
    CollimatorRightVerticalEdge: 0x00181704,
    CollimatorUpperHorizontalEdge: 0x00181706,
    CollimatorLowerHorizontalEdge: 0x00181708,
    CenterOfCircularCollimator: 0x00181710,
    RadiusOfCircularCollimator: 0x00181712,
    VerticesOfThePolygonalCollimator: 0x00181720,
    AcquisitionTimeSynchronized: 0x00181800,
    TimeSource: 0x00181801,
    TimeDistributionProtocol: 0x00181802,
    NTPSourceAddress: 0x00181803,
    PageNumberVector: 0x00182001,
    FrameLabelVector: 0x00182002,
    FramePrimaryAngleVector: 0x00182003,
    FrameSecondaryAngleVector: 0x00182004,
    SliceLocationVector: 0x00182005,
    DisplayWindowLabelVector: 0x00182006,
    NominalScannedPixelSpacing: 0x00182010,
    DigitizingDeviceTransportDirection: 0x00182020,
    RotationOfScannedFilm: 0x00182030,
    BiopsyTargetSequence: 0x00182041,
    TargetUID: 0x00182042,
    LocalizingCursorPosition: 0x00182043,
    CalculatedTargetPosition: 0x00182044,
    TargetLabel: 0x00182045,
    DisplayedZValue: 0x00182046,
    IVUSAcquisition: 0x00183100,
    IVUSPullbackRate: 0x00183101,
    IVUSGatedRate: 0x00183102,
    IVUSPullbackStartFrameNumber: 0x00183103,
    IVUSPullbackStopFrameNumber: 0x00183104,
    LesionNumber: 0x00183105,
    AcquisitionComments: 0x00184000, // retired
    OutputPower: 0x00185000,
    TransducerData: 0x00185010,
    FocusDepth: 0x00185012,
    ProcessingFunction: 0x00185020,
    PostprocessingFunction: 0x00185021, // retired
    MechanicalIndex: 0x00185022,
    BoneThermalIndex: 0x00185024,
    CranialThermalIndex: 0x00185026,
    SoftTissueThermalIndex: 0x00185027,
    SoftTissueFocusThermalIndex: 0x00185028,
    SoftTissueSurfaceThermalIndex: 0x00185029,
    DynamicRange: 0x00185030, // retired
    TotalGain: 0x00185040, // retired
    DepthOfScanField: 0x00185050,
    PatientPosition: 0x00185100,
    ViewPosition: 0x00185101,
    ProjectionEponymousNameCodeSequence: 0x00185104,
    ImageTransformationMatrix: 0x00185210, // retired
    ImageTranslationVector: 0x00185212, // retired
    Sensitivity: 0x00186000,
    SequenceOfUltrasoundRegions: 0x00186011,
    RegionSpatialFormat: 0x00186012,
    RegionDataType: 0x00186014,
    RegionFlags: 0x00186016,
    RegionLocationMinX0: 0x00186018,
    RegionLocationMinY0: 0x0018601a,
    RegionLocationMaxX1: 0x0018601c,
    RegionLocationMaxY1: 0x0018601e,
    ReferencePixelX0: 0x00186020,
    ReferencePixelY0: 0x00186022,
    PhysicalUnitsXDirection: 0x00186024,
    PhysicalUnitsYDirection: 0x00186026,
    ReferencePixelPhysicalValueX: 0x00186028,
    ReferencePixelPhysicalValueY: 0x0018602a,
    PhysicalDeltaX: 0x0018602c,
    PhysicalDeltaY: 0x0018602e,
    TransducerFrequency: 0x00186030,
    TransducerType: 0x00186031,
    PulseRepetitionFrequency: 0x00186032,
    DopplerCorrectionAngle: 0x00186034,
    SteeringAngle: 0x00186036,
    DopplerSampleVolumeXPositionRetired: 0x00186038, // retired
    DopplerSampleVolumeXPosition: 0x00186039,
    DopplerSampleVolumeYPositionRetired: 0x0018603a, // retired
    DopplerSampleVolumeYPosition: 0x0018603b,
    TMLinePositionX0Retired: 0x0018603c, // retired
    TMLinePositionX0: 0x0018603d,
    TMLinePositionY0Retired: 0x0018603e, // retired
    TMLinePositionY0: 0x0018603f,
    TMLinePositionX1Retired: 0x00186040, // retired
    TMLinePositionX1: 0x00186041,
    TMLinePositionY1Retired: 0x00186042, // retired
    TMLinePositionY1: 0x00186043,
    PixelComponentOrganization: 0x00186044,
    PixelComponentMask: 0x00186046,
    PixelComponentRangeStart: 0x00186048,
    PixelComponentRangeStop: 0x0018604a,
    PixelComponentPhysicalUnits: 0x0018604c,
    PixelComponentDataType: 0x0018604e,
    NumberOfTableBreakPoints: 0x00186050,
    TableOfXBreakPoints: 0x00186052,
    TableOfYBreakPoints: 0x00186054,
    NumberOfTableEntries: 0x00186056,
    TableOfPixelValues: 0x00186058,
    TableOfParameterValues: 0x0018605a,
    RWaveTimeVector: 0x00186060,
    DetectorConditionsNominalFlag: 0x00187000,
    DetectorTemperature: 0x00187001,
    DetectorType: 0x00187004,
    DetectorConfiguration: 0x00187005,
    DetectorDescription: 0x00187006,
    DetectorMode: 0x00187008,
    DetectorID: 0x0018700a,
    DateOfLastDetectorCalibration: 0x0018700c,
    TimeOfLastDetectorCalibration: 0x0018700e,
    ExposuresOnDetectorSinceLastCalibration: 0x00187010,
    ExposuresOnDetectorSinceManufactured: 0x00187011,
    DetectorTimeSinceLastExposure: 0x00187012,
    DetectorActiveTime: 0x00187014,
    DetectorActivationOffsetFromExposure: 0x00187016,
    DetectorBinning: 0x0018701a,
    DetectorElementPhysicalSize: 0x00187020,
    DetectorElementSpacing: 0x00187022,
    DetectorActiveShape: 0x00187024,
    DetectorActiveDimensions: 0x00187026,
    DetectorActiveOrigin: 0x00187028,
    DetectorManufacturerName: 0x0018702a,
    DetectorManufacturerModelName: 0x0018702b,
    FieldOfViewOrigin: 0x00187030,
    FieldOfViewRotation: 0x00187032,
    FieldOfViewHorizontalFlip: 0x00187034,
    PixelDataAreaOriginRelativeToFOV: 0x00187036,
    PixelDataAreaRotationAngleRelativeToFOV: 0x00187038,
    GridAbsorbingMaterial: 0x00187040,
    GridSpacingMaterial: 0x00187041,
    GridThickness: 0x00187042,
    GridPitch: 0x00187044,
    GridAspectRatio: 0x00187046,
    GridPeriod: 0x00187048,
    GridFocalDistance: 0x0018704c,
    FilterMaterial: 0x00187050,
    FilterThicknessMinimum: 0x00187052,
    FilterThicknessMaximum: 0x00187054,
    FilterBeamPathLengthMinimum: 0x00187056,
    FilterBeamPathLengthMaximum: 0x00187058,
    ExposureControlMode: 0x00187060,
    ExposureControlModeDescription: 0x00187062,
    ExposureStatus: 0x00187064,
    PhototimerSetting: 0x00187065,
    ExposureTimeInuS: 0x00188150,
    XRayTubeCurrentInuA: 0x00188151,
    ContentQualification: 0x00189004,
    PulseSequenceName: 0x00189005,
    MRImagingModifierSequence: 0x00189006,
    EchoPulseSequence: 0x00189008,
    InversionRecovery: 0x00189009,
    FlowCompensation: 0x00189010,
    MultipleSpinEcho: 0x00189011,
    MultiPlanarExcitation: 0x00189012,
    PhaseContrast: 0x00189014,
    TimeOfFlightContrast: 0x00189015,
    Spoiling: 0x00189016,
    SteadyStatePulseSequence: 0x00189017,
    EchoPlanarPulseSequence: 0x00189018,
    TagAngleFirstAxis: 0x00189019,
    MagnetizationTransfer: 0x00189020,
    T2Preparation: 0x00189021,
    BloodSignalNulling: 0x00189022,
    SaturationRecovery: 0x00189024,
    SpectrallySelectedSuppression: 0x00189025,
    SpectrallySelectedExcitation: 0x00189026,
    SpatialPresaturation: 0x00189027,
    Tagging: 0x00189028,
    OversamplingPhase: 0x00189029,
    TagSpacingFirstDimension: 0x00189030,
    GeometryOfKSpaceTraversal: 0x00189032,
    SegmentedKSpaceTraversal: 0x00189033,
    RectilinearPhaseEncodeReordering: 0x00189034,
    TagThickness: 0x00189035,
    PartialFourierDirection: 0x00189036,
    CardiacSynchronizationTechnique: 0x00189037,
    ReceiveCoilManufacturerName: 0x00189041,
    MRReceiveCoilSequence: 0x00189042,
    ReceiveCoilType: 0x00189043,
    QuadratureReceiveCoil: 0x00189044,
    MultiCoilDefinitionSequence: 0x00189045,
    MultiCoilConfiguration: 0x00189046,
    MultiCoilElementName: 0x00189047,
    MultiCoilElementUsed: 0x00189048,
    MRTransmitCoilSequence: 0x00189049,
    TransmitCoilManufacturerName: 0x00189050,
    TransmitCoilType: 0x00189051,
    SpectralWidth: 0x00189052,
    ChemicalShiftReference: 0x00189053,
    VolumeLocalizationTechnique: 0x00189054,
    MRAcquisitionFrequencyEncodingSteps: 0x00189058,
    Decoupling: 0x00189059,
    DecoupledNucleus: 0x00189060,
    DecouplingFrequency: 0x00189061,
    DecouplingMethod: 0x00189062,
    DecouplingChemicalShiftReference: 0x00189063,
    KSpaceFiltering: 0x00189064,
    TimeDomainFiltering: 0x00189065,
    NumberOfZeroFills: 0x00189066,
    BaselineCorrection: 0x00189067,
    ParallelReductionFactorInPlane: 0x00189069,
    CardiacRRIntervalSpecified: 0x00189070,
    AcquisitionDuration: 0x00189073,
    FrameAcquisitionDateTime: 0x00189074,
    DiffusionDirectionality: 0x00189075,
    DiffusionGradientDirectionSequence: 0x00189076,
    ParallelAcquisition: 0x00189077,
    ParallelAcquisitionTechnique: 0x00189078,
    InversionTimes: 0x00189079,
    MetaboliteMapDescription: 0x00189080,
    PartialFourier: 0x00189081,
    EffectiveEchoTime: 0x00189082,
    MetaboliteMapCodeSequence: 0x00189083,
    ChemicalShiftSequence: 0x00189084,
    CardiacSignalSource: 0x00189085,
    DiffusionBValue: 0x00189087,
    DiffusionGradientOrientation: 0x00189089,
    VelocityEncodingDirection: 0x00189090,
    VelocityEncodingMinimumValue: 0x00189091,
    VelocityEncodingAcquisitionSequence: 0x00189092,
    NumberOfKSpaceTrajectories: 0x00189093,
    CoverageOfKSpace: 0x00189094,
    SpectroscopyAcquisitionPhaseRows: 0x00189095,
    ParallelReductionFactorInPlaneRetired: 0x00189096, // retired
    TransmitterFrequency: 0x00189098,
    ResonantNucleus: 0x00189100,
    FrequencyCorrection: 0x00189101,
    MRSpectroscopyFOVGeometrySequence: 0x00189103,
    SlabThickness: 0x00189104,
    SlabOrientation: 0x00189105,
    MidSlabPosition: 0x00189106,
    MRSpatialSaturationSequence: 0x00189107,
    MRTimingAndRelatedParametersSequence: 0x00189112,
    MREchoSequence: 0x00189114,
    MRModifierSequence: 0x00189115,
    MRDiffusionSequence: 0x00189117,
    CardiacSynchronizationSequence: 0x00189118,
    MRAveragesSequence: 0x00189119,
    MRFOVGeometrySequence: 0x00189125,
    VolumeLocalizationSequence: 0x00189126,
    SpectroscopyAcquisitionDataColumns: 0x00189127,
    DiffusionAnisotropyType: 0x00189147,
    FrameReferenceDateTime: 0x00189151,
    MRMetaboliteMapSequence: 0x00189152,
    ParallelReductionFactorOutOfPlane: 0x00189155,
    SpectroscopyAcquisitionOutOfPlanePhaseSteps: 0x00189159,
    BulkMotionStatus: 0x00189166, // retired
    ParallelReductionFactorSecondInPlane: 0x00189168,
    CardiacBeatRejectionTechnique: 0x00189169,
    RespiratoryMotionCompensationTechnique: 0x00189170,
    RespiratorySignalSource: 0x00189171,
    BulkMotionCompensationTechnique: 0x00189172,
    BulkMotionSignalSource: 0x00189173,
    ApplicableSafetyStandardAgency: 0x00189174,
    ApplicableSafetyStandardDescription: 0x00189175,
    OperatingModeSequence: 0x00189176,
    OperatingModeType: 0x00189177,
    OperatingMode: 0x00189178,
    SpecificAbsorptionRateDefinition: 0x00189179,
    GradientOutputType: 0x00189180,
    SpecificAbsorptionRateValue: 0x00189181,
    GradientOutput: 0x00189182,
    FlowCompensationDirection: 0x00189183,
    TaggingDelay: 0x00189184,
    RespiratoryMotionCompensationTechniqueDescription: 0x00189185,
    RespiratorySignalSourceID: 0x00189186,
    ChemicalShiftMinimumIntegrationLimitInHz: 0x00189195, // retired
    ChemicalShiftMaximumIntegrationLimitInHz: 0x00189196, // retired
    MRVelocityEncodingSequence: 0x00189197,
    FirstOrderPhaseCorrection: 0x00189198,
    WaterReferencedPhaseCorrection: 0x00189199,
    MRSpectroscopyAcquisitionType: 0x00189200,
    RespiratoryCyclePosition: 0x00189214,
    VelocityEncodingMaximumValue: 0x00189217,
    TagSpacingSecondDimension: 0x00189218,
    TagAngleSecondAxis: 0x00189219,
    FrameAcquisitionDuration: 0x00189220,
    MRImageFrameTypeSequence: 0x00189226,
    MRSpectroscopyFrameTypeSequence: 0x00189227,
    MRAcquisitionPhaseEncodingStepsInPlane: 0x00189231,
    MRAcquisitionPhaseEncodingStepsOutOfPlane: 0x00189232,
    SpectroscopyAcquisitionPhaseColumns: 0x00189234,
    CardiacCyclePosition: 0x00189236,
    SpecificAbsorptionRateSequence: 0x00189239,
    RFEchoTrainLength: 0x00189240,
    GradientEchoTrainLength: 0x00189241,
    ArterialSpinLabelingContrast: 0x00189250,
    MRArterialSpinLabelingSequence: 0x00189251,
    ASLTechniqueDescription: 0x00189252,
    ASLSlabNumber: 0x00189253,
    ASLSlabThickness: 0x00189254,
    ASLSlabOrientation: 0x00189255,
    ASLMidSlabPosition: 0x00189256,
    ASLContext: 0x00189257,
    ASLPulseTrainDuration: 0x00189258,
    ASLCrusherFlag: 0x00189259,
    ASLCrusherFlowLimit: 0x0018925a,
    ASLCrusherDescription: 0x0018925b,
    ASLBolusCutoffFlag: 0x0018925c,
    ASLBolusCutoffTimingSequence: 0x0018925d,
    ASLBolusCutoffTechnique: 0x0018925e,
    ASLBolusCutoffDelayTime: 0x0018925f,
    ASLSlabSequence: 0x00189260,
    ChemicalShiftMinimumIntegrationLimitInppm: 0x00189295,
    ChemicalShiftMaximumIntegrationLimitInppm: 0x00189296,
    WaterReferenceAcquisition: 0x00189297,
    EchoPeakPosition: 0x00189298,
    CTAcquisitionTypeSequence: 0x00189301,
    AcquisitionType: 0x00189302,
    TubeAngle: 0x00189303,
    CTAcquisitionDetailsSequence: 0x00189304,
    RevolutionTime: 0x00189305,
    SingleCollimationWidth: 0x00189306,
    TotalCollimationWidth: 0x00189307,
    CTTableDynamicsSequence: 0x00189308,
    TableSpeed: 0x00189309,
    TableFeedPerRotation: 0x00189310,
    SpiralPitchFactor: 0x00189311,
    CTGeometrySequence: 0x00189312,
    DataCollectionCenterPatient: 0x00189313,
    CTReconstructionSequence: 0x00189314,
    ReconstructionAlgorithm: 0x00189315,
    ConvolutionKernelGroup: 0x00189316,
    ReconstructionFieldOfView: 0x00189317,
    ReconstructionTargetCenterPatient: 0x00189318,
    ReconstructionAngle: 0x00189319,
    ImageFilter: 0x00189320,
    CTExposureSequence: 0x00189321,
    ReconstructionPixelSpacing: 0x00189322,
    ExposureModulationType: 0x00189323,
    EstimatedDoseSaving: 0x00189324,
    CTXRayDetailsSequence: 0x00189325,
    CTPositionSequence: 0x00189326,
    TablePosition: 0x00189327,
    ExposureTimeInms: 0x00189328,
    CTImageFrameTypeSequence: 0x00189329,
    XRayTubeCurrentInmA: 0x00189330,
    ExposureInmAs: 0x00189332,
    ConstantVolumeFlag: 0x00189333,
    FluoroscopyFlag: 0x00189334,
    DistanceSourceToDataCollectionCenter: 0x00189335,
    ContrastBolusAgentNumber: 0x00189337,
    ContrastBolusIngredientCodeSequence: 0x00189338,
    ContrastAdministrationProfileSequence: 0x00189340,
    ContrastBolusUsageSequence: 0x00189341,
    ContrastBolusAgentAdministered: 0x00189342,
    ContrastBolusAgentDetected: 0x00189343,
    ContrastBolusAgentPhase: 0x00189344,
    CTDIvol: 0x00189345,
    CTDIPhantomTypeCodeSequence: 0x00189346,
    CalciumScoringMassFactorPatient: 0x00189351,
    CalciumScoringMassFactorDevice: 0x00189352,
    EnergyWeightingFactor: 0x00189353,
    CTAdditionalXRaySourceSequence: 0x00189360,
    ProjectionPixelCalibrationSequence: 0x00189401,
    DistanceSourceToIsocenter: 0x00189402,
    DistanceObjectToTableTop: 0x00189403,
    ObjectPixelSpacingInCenterOfBeam: 0x00189404,
    PositionerPositionSequence: 0x00189405,
    TablePositionSequence: 0x00189406,
    CollimatorShapeSequence: 0x00189407,
    PlanesInAcquisition: 0x00189410,
    XAXRFFrameCharacteristicsSequence: 0x00189412,
    FrameAcquisitionSequence: 0x00189417,
    XRayReceptorType: 0x00189420,
    AcquisitionProtocolName: 0x00189423,
    AcquisitionProtocolDescription: 0x00189424,
    ContrastBolusIngredientOpaque: 0x00189425,
    DistanceReceptorPlaneToDetectorHousing: 0x00189426,
    IntensifierActiveShape: 0x00189427,
    IntensifierActiveDimensions: 0x00189428,
    PhysicalDetectorSize: 0x00189429,
    PositionOfIsocenterProjection: 0x00189430,
    FieldOfViewSequence: 0x00189432,
    FieldOfViewDescription: 0x00189433,
    ExposureControlSensingRegionsSequence: 0x00189434,
    ExposureControlSensingRegionShape: 0x00189435,
    ExposureControlSensingRegionLeftVerticalEdge: 0x00189436,
    ExposureControlSensingRegionRightVerticalEdge: 0x00189437,
    ExposureControlSensingRegionUpperHorizontalEdge: 0x00189438,
    ExposureControlSensingRegionLowerHorizontalEdge: 0x00189439,
    CenterOfCircularExposureControlSensingRegion: 0x00189440,
    RadiusOfCircularExposureControlSensingRegion: 0x00189441,
    VerticesOfThePolygonalExposureControlSensingRegion: 0x00189442,
    ColumnAngulationPatient: 0x00189447,
    BeamAngle: 0x00189449,
    FrameDetectorParametersSequence: 0x00189451,
    CalculatedAnatomyThickness: 0x00189452,
    CalibrationSequence: 0x00189455,
    ObjectThicknessSequence: 0x00189456,
    PlaneIdentification: 0x00189457,
    FieldOfViewDimensionsInFloat: 0x00189461,
    IsocenterReferenceSystemSequence: 0x00189462,
    PositionerIsocenterPrimaryAngle: 0x00189463,
    PositionerIsocenterSecondaryAngle: 0x00189464,
    PositionerIsocenterDetectorRotationAngle: 0x00189465,
    TableXPositionToIsocenter: 0x00189466,
    TableYPositionToIsocenter: 0x00189467,
    TableZPositionToIsocenter: 0x00189468,
    TableHorizontalRotationAngle: 0x00189469,
    TableHeadTiltAngle: 0x00189470,
    TableCradleTiltAngle: 0x00189471,
    FrameDisplayShutterSequence: 0x00189472,
    AcquiredImageAreaDoseProduct: 0x00189473,
    CArmPositionerTabletopRelationship: 0x00189474,
    XRayGeometrySequence: 0x00189476,
    IrradiationEventIdentificationSequence: 0x00189477,
    XRay3DFrameTypeSequence: 0x00189504,
    ContributingSourcesSequence: 0x00189506,
    XRay3DAcquisitionSequence: 0x00189507,
    PrimaryPositionerScanArc: 0x00189508,
    SecondaryPositionerScanArc: 0x00189509,
    PrimaryPositionerScanStartAngle: 0x00189510,
    SecondaryPositionerScanStartAngle: 0x00189511,
    PrimaryPositionerIncrement: 0x00189514,
    SecondaryPositionerIncrement: 0x00189515,
    StartAcquisitionDateTime: 0x00189516,
    EndAcquisitionDateTime: 0x00189517,
    PrimaryPositionerIncrementSign: 0x00189518,
    SecondaryPositionerIncrementSign: 0x00189519,
    ApplicationName: 0x00189524,
    ApplicationVersion: 0x00189525,
    ApplicationManufacturer: 0x00189526,
    AlgorithmType: 0x00189527,
    AlgorithmDescription: 0x00189528,
    XRay3DReconstructionSequence: 0x00189530,
    ReconstructionDescription: 0x00189531,
    PerProjectionAcquisitionSequence: 0x00189538,
    DetectorPositionSequence: 0x00189541,
    XRayAcquisitionDoseSequence: 0x00189542,
    XRaySourceIsocenterPrimaryAngle: 0x00189543,
    XRaySourceIsocenterSecondaryAngle: 0x00189544,
    BreastSupportIsocenterPrimaryAngle: 0x00189545,
    BreastSupportIsocenterSecondaryAngle: 0x00189546,
    BreastSupportXPositionToIsocenter: 0x00189547,
    BreastSupportYPositionToIsocenter: 0x00189548,
    BreastSupportZPositionToIsocenter: 0x00189549,
    DetectorIsocenterPrimaryAngle: 0x00189550,
    DetectorIsocenterSecondaryAngle: 0x00189551,
    DetectorXPositionToIsocenter: 0x00189552,
    DetectorYPositionToIsocenter: 0x00189553,
    DetectorZPositionToIsocenter: 0x00189554,
    XRayGridSequence: 0x00189555,
    XRayFilterSequence: 0x00189556,
    DetectorActiveAreaTLHCPosition: 0x00189557,
    DetectorActiveAreaOrientation: 0x00189558,
    PositionerPrimaryAngleDirection: 0x00189559,
    DiffusionBMatrixSequence: 0x00189601,
    DiffusionBValueXX: 0x00189602,
    DiffusionBValueXY: 0x00189603,
    DiffusionBValueXZ: 0x00189604,
    DiffusionBValueYY: 0x00189605,
    DiffusionBValueYZ: 0x00189606,
    DiffusionBValueZZ: 0x00189607,
    FunctionalMRSequence: 0x00189621,
    FunctionalSettlingPhaseFramesPresent: 0x00189622,
    FunctionalSyncPulse: 0x00189623,
    SettlingPhaseFrame: 0x00189624,
    DecayCorrectionDateTime: 0x00189701,
    StartDensityThreshold: 0x00189715,
    StartRelativeDensityDifferenceThreshold: 0x00189716,
    StartCardiacTriggerCountThreshold: 0x00189717,
    StartRespiratoryTriggerCountThreshold: 0x00189718,
    TerminationCountsThreshold: 0x00189719,
    TerminationDensityThreshold: 0x00189720,
    TerminationRelativeDensityThreshold: 0x00189721,
    TerminationTimeThreshold: 0x00189722,
    TerminationCardiacTriggerCountThreshold: 0x00189723,
    TerminationRespiratoryTriggerCountThreshold: 0x00189724,
    DetectorGeometry: 0x00189725,
    TransverseDetectorSeparation: 0x00189726,
    AxialDetectorDimension: 0x00189727,
    RadiopharmaceuticalAgentNumber: 0x00189729,
    PETFrameAcquisitionSequence: 0x00189732,
    PETDetectorMotionDetailsSequence: 0x00189733,
    PETTableDynamicsSequence: 0x00189734,
    PETPositionSequence: 0x00189735,
    PETFrameCorrectionFactorsSequence: 0x00189736,
    RadiopharmaceuticalUsageSequence: 0x00189737,
    AttenuationCorrectionSource: 0x00189738,
    NumberOfIterations: 0x00189739,
    NumberOfSubsets: 0x00189740,
    PETReconstructionSequence: 0x00189749,
    PETFrameTypeSequence: 0x00189751,
    TimeOfFlightInformationUsed: 0x00189755,
    ReconstructionType: 0x00189756,
    DecayCorrected: 0x00189758,
    AttenuationCorrected: 0x00189759,
    ScatterCorrected: 0x00189760,
    DeadTimeCorrected: 0x00189761,
    GantryMotionCorrected: 0x00189762,
    PatientMotionCorrected: 0x00189763,
    CountLossNormalizationCorrected: 0x00189764,
    RandomsCorrected: 0x00189765,
    NonUniformRadialSamplingCorrected: 0x00189766,
    SensitivityCalibrated: 0x00189767,
    DetectorNormalizationCorrection: 0x00189768,
    IterativeReconstructionMethod: 0x00189769,
    AttenuationCorrectionTemporalRelationship: 0x00189770,
    PatientPhysiologicalStateSequence: 0x00189771,
    PatientPhysiologicalStateCodeSequence: 0x00189772,
    DepthsOfFocus: 0x00189801,
    ExcludedIntervalsSequence: 0x00189803,
    ExclusionStartDateTime: 0x00189804,
    ExclusionDuration: 0x00189805,
    USImageDescriptionSequence: 0x00189806,
    ImageDataTypeSequence: 0x00189807,
    DataType: 0x00189808,
    TransducerScanPatternCodeSequence: 0x00189809,
    AliasedDataType: 0x0018980b,
    PositionMeasuringDeviceUsed: 0x0018980c,
    TransducerGeometryCodeSequence: 0x0018980d,
    TransducerBeamSteeringCodeSequence: 0x0018980e,
    TransducerApplicationCodeSequence: 0x0018980f,
    ZeroVelocityPixelValue: 0x00189810,
    ReferenceLocationLabel: 0x00189900,
    ReferenceLocationDescription: 0x00189901,
    ReferenceBasisCodeSequence: 0x00189902,
    ReferenceGeometryCodeSequence: 0x00189903,
    OffsetDistance: 0x00189904,
    OffsetDirection: 0x00189905,
    PotentialScheduledProtocolCodeSequence: 0x00189906,
    PotentialRequestedProcedureCodeSequence: 0x00189907,
    PotentialReasonsForProcedure: 0x00189908,
    PotentialReasonsForProcedureCodeSequence: 0x00189909,
    PotentialDiagnosticTasks: 0x0018990a,
    ContraindicationsCodeSequence: 0x0018990b,
    ReferencedDefinedProtocolSequence: 0x0018990c,
    ReferencedPerformedProtocolSequence: 0x0018990d,
    PredecessorProtocolSequence: 0x0018990e,
    ProtocolPlanningInformation: 0x0018990f,
    ProtocolDesignRationale: 0x00189910,
    PatientSpecificationSequence: 0x00189911,
    ModelSpecificationSequence: 0x00189912,
    ParametersSpecificationSequence: 0x00189913,
    InstructionSequence: 0x00189914,
    InstructionIndex: 0x00189915,
    InstructionText: 0x00189916,
    InstructionDescription: 0x00189917,
    InstructionPerformedFlag: 0x00189918,
    InstructionPerformedDateTime: 0x00189919,
    InstructionPerformanceComment: 0x0018991a,
    PatientPositioningInstructionSequence: 0x0018991b,
    PositioningMethodCodeSequence: 0x0018991c,
    PositioningLandmarkSequence: 0x0018991d,
    TargetFrameOfReferenceUID: 0x0018991e,
    AcquisitionProtocolElementSpecificationSequence: 0x0018991f,
    AcquisitionProtocolElementSequence: 0x00189920,
    ProtocolElementNumber: 0x00189921,
    ProtocolElementName: 0x00189922,
    ProtocolElementCharacteristicsSummary: 0x00189923,
    ProtocolElementPurpose: 0x00189924,
    AcquisitionMotion: 0x00189930,
    AcquisitionStartLocationSequence: 0x00189931,
    AcquisitionEndLocationSequence: 0x00189932,
    ReconstructionProtocolElementSpecificationSequence: 0x00189933,
    ReconstructionProtocolElementSequence: 0x00189934,
    StorageProtocolElementSpecificationSequence: 0x00189935,
    StorageProtocolElementSequence: 0x00189936,
    RequestedSeriesDescription: 0x00189937,
    SourceAcquisitionProtocolElementNumber: 0x00189938,
    SourceAcquisitionBeamNumber: 0x00189939,
    SourceReconstructionProtocolElementNumber: 0x0018993a,
    ReconstructionStartLocationSequence: 0x0018993b,
    ReconstructionEndLocationSequence: 0x0018993c,
    ReconstructionAlgorithmSequence: 0x0018993d,
    ReconstructionTargetCenterLocationSequence: 0x0018993e,
    ImageFilterDescription: 0x00189941,
    CTDIvolNotificationTrigger: 0x00189942,
    DLPNotificationTrigger: 0x00189943,
    AutoKVPSelectionType: 0x00189944,
    AutoKVPUpperBound: 0x00189945,
    AutoKVPLowerBound: 0x00189946,
    ProtocolDefinedPatientPosition: 0x00189947,
    ContributingEquipmentSequence: 0x0018a001,
    ContributionDateTime: 0x0018a002,
    ContributionDescription: 0x0018a003,
    StudyInstanceUID: 0x0020000d,
    SeriesInstanceUID: 0x0020000e,
    StudyID: 0x00200010,
    SeriesNumber: 0x00200011,
    AcquisitionNumber: 0x00200012,
    InstanceNumber: 0x00200013,
    IsotopeNumber: 0x00200014, // retired
    PhaseNumber: 0x00200015, // retired
    IntervalNumber: 0x00200016, // retired
    TimeSlotNumber: 0x00200017, // retired
    AngleNumber: 0x00200018, // retired
    ItemNumber: 0x00200019,
    PatientOrientation: 0x00200020,
    OverlayNumber: 0x00200022, // retired
    CurveNumber: 0x00200024, // retired
    LUTNumber: 0x00200026, // retired
    ImagePosition: 0x00200030, // retired
    ImagePositionPatient: 0x00200032,
    ImageOrientation: 0x00200035, // retired
    ImageOrientationPatient: 0x00200037,
    Location: 0x00200050, // retired
    FrameOfReferenceUID: 0x00200052,
    Laterality: 0x00200060,
    ImageLaterality: 0x00200062,
    ImageGeometryType: 0x00200070, // retired
    MaskingImage: 0x00200080, // retired
    ReportNumber: 0x002000aa, // retired
    TemporalPositionIdentifier: 0x00200100,
    NumberOfTemporalPositions: 0x00200105,
    TemporalResolution: 0x00200110,
    SynchronizationFrameOfReferenceUID: 0x00200200,
    SOPInstanceUIDOfConcatenationSource: 0x00200242,
    SeriesInStudy: 0x00201000, // retired
    AcquisitionsInSeries: 0x00201001, // retired
    ImagesInAcquisition: 0x00201002,
    ImagesInSeries: 0x00201003, // retired
    AcquisitionsInStudy: 0x00201004, // retired
    ImagesInStudy: 0x00201005, // retired
    Reference: 0x00201020, // retired
    TargetPositionReferenceIndicator: 0x0020103f,
    PositionReferenceIndicator: 0x00201040,
    SliceLocation: 0x00201041,
    OtherStudyNumbers: 0x00201070, // retired
    NumberOfPatientRelatedStudies: 0x00201200,
    NumberOfPatientRelatedSeries: 0x00201202,
    NumberOfPatientRelatedInstances: 0x00201204,
    NumberOfStudyRelatedSeries: 0x00201206,
    NumberOfStudyRelatedInstances: 0x00201208,
    NumberOfSeriesRelatedInstances: 0x00201209,
    SourceImageIDs: 0x00203100, // retired
    ModifyingDeviceID: 0x00203401, // retired
    ModifiedImageID: 0x00203402, // retired
    ModifiedImageDate: 0x00203403, // retired
    ModifyingDeviceManufacturer: 0x00203404, // retired
    ModifiedImageTime: 0x00203405, // retired
    ModifiedImageDescription: 0x00203406, // retired
    ImageComments: 0x00204000,
    OriginalImageIdentification: 0x00205000, // retired
    OriginalImageIdentificationNomenclature: 0x00205002, // retired
    StackID: 0x00209056,
    InStackPositionNumber: 0x00209057,
    FrameAnatomySequence: 0x00209071,
    FrameLaterality: 0x00209072,
    FrameContentSequence: 0x00209111,
    PlanePositionSequence: 0x00209113,
    PlaneOrientationSequence: 0x00209116,
    TemporalPositionIndex: 0x00209128,
    NominalCardiacTriggerDelayTime: 0x00209153,
    NominalCardiacTriggerTimePriorToRPeak: 0x00209154,
    ActualCardiacTriggerTimePriorToRPeak: 0x00209155,
    FrameAcquisitionNumber: 0x00209156,
    DimensionIndexValues: 0x00209157,
    FrameComments: 0x00209158,
    ConcatenationUID: 0x00209161,
    InConcatenationNumber: 0x00209162,
    InConcatenationTotalNumber: 0x00209163,
    DimensionOrganizationUID: 0x00209164,
    DimensionIndexPointer: 0x00209165,
    FunctionalGroupPointer: 0x00209167,
    UnassignedSharedConvertedAttributesSequence: 0x00209170,
    UnassignedPerFrameConvertedAttributesSequence: 0x00209171,
    ConversionSourceAttributesSequence: 0x00209172,
    DimensionIndexPrivateCreator: 0x00209213,
    DimensionOrganizationSequence: 0x00209221,
    DimensionIndexSequence: 0x00209222,
    ConcatenationFrameOffsetNumber: 0x00209228,
    FunctionalGroupPrivateCreator: 0x00209238,
    NominalPercentageOfCardiacPhase: 0x00209241,
    NominalPercentageOfRespiratoryPhase: 0x00209245,
    StartingRespiratoryAmplitude: 0x00209246,
    StartingRespiratoryPhase: 0x00209247,
    EndingRespiratoryAmplitude: 0x00209248,
    EndingRespiratoryPhase: 0x00209249,
    RespiratoryTriggerType: 0x00209250,
    RRIntervalTimeNominal: 0x00209251,
    ActualCardiacTriggerDelayTime: 0x00209252,
    RespiratorySynchronizationSequence: 0x00209253,
    RespiratoryIntervalTime: 0x00209254,
    NominalRespiratoryTriggerDelayTime: 0x00209255,
    RespiratoryTriggerDelayThreshold: 0x00209256,
    ActualRespiratoryTriggerDelayTime: 0x00209257,
    ImagePositionVolume: 0x00209301,
    ImageOrientationVolume: 0x00209302,
    UltrasoundAcquisitionGeometry: 0x00209307,
    ApexPosition: 0x00209308,
    VolumeToTransducerMappingMatrix: 0x00209309,
    VolumeToTableMappingMatrix: 0x0020930a,
    VolumeToTransducerRelationship: 0x0020930b,
    PatientFrameOfReferenceSource: 0x0020930c,
    TemporalPositionTimeOffset: 0x0020930d,
    PlanePositionVolumeSequence: 0x0020930e,
    PlaneOrientationVolumeSequence: 0x0020930f,
    TemporalPositionSequence: 0x00209310,
    DimensionOrganizationType: 0x00209311,
    VolumeFrameOfReferenceUID: 0x00209312,
    TableFrameOfReferenceUID: 0x00209313,
    DimensionDescriptionLabel: 0x00209421,
    PatientOrientationInFrameSequence: 0x00209450,
    FrameLabel: 0x00209453,
    AcquisitionIndex: 0x00209518,
    ContributingSOPInstancesReferenceSequence: 0x00209529,
    ReconstructionIndex: 0x00209536,
    LightPathFilterPassThroughWavelength: 0x00220001,
    LightPathFilterPassBand: 0x00220002,
    ImagePathFilterPassThroughWavelength: 0x00220003,
    ImagePathFilterPassBand: 0x00220004,
    PatientEyeMovementCommanded: 0x00220005,
    PatientEyeMovementCommandCodeSequence: 0x00220006,
    SphericalLensPower: 0x00220007,
    CylinderLensPower: 0x00220008,
    CylinderAxis: 0x00220009,
    EmmetropicMagnification: 0x0022000a,
    IntraOcularPressure: 0x0022000b,
    HorizontalFieldOfView: 0x0022000c,
    PupilDilated: 0x0022000d,
    DegreeOfDilation: 0x0022000e,
    StereoBaselineAngle: 0x00220010,
    StereoBaselineDisplacement: 0x00220011,
    StereoHorizontalPixelOffset: 0x00220012,
    StereoVerticalPixelOffset: 0x00220013,
    StereoRotation: 0x00220014,
    AcquisitionDeviceTypeCodeSequence: 0x00220015,
    IlluminationTypeCodeSequence: 0x00220016,
    LightPathFilterTypeStackCodeSequence: 0x00220017,
    ImagePathFilterTypeStackCodeSequence: 0x00220018,
    LensesCodeSequence: 0x00220019,
    ChannelDescriptionCodeSequence: 0x0022001a,
    RefractiveStateSequence: 0x0022001b,
    MydriaticAgentCodeSequence: 0x0022001c,
    RelativeImagePositionCodeSequence: 0x0022001d,
    CameraAngleOfView: 0x0022001e,
    StereoPairsSequence: 0x00220020,
    LeftImageSequence: 0x00220021,
    RightImageSequence: 0x00220022,
    StereoPairsPresent: 0x00220028,
    AxialLengthOfTheEye: 0x00220030,
    OphthalmicFrameLocationSequence: 0x00220031,
    ReferenceCoordinates: 0x00220032,
    DepthSpatialResolution: 0x00220035,
    MaximumDepthDistortion: 0x00220036,
    AlongScanSpatialResolution: 0x00220037,
    MaximumAlongScanDistortion: 0x00220038,
    OphthalmicImageOrientation: 0x00220039,
    DepthOfTransverseImage: 0x00220041,
    MydriaticAgentConcentrationUnitsSequence: 0x00220042,
    AcrossScanSpatialResolution: 0x00220048,
    MaximumAcrossScanDistortion: 0x00220049,
    MydriaticAgentConcentration: 0x0022004e,
    IlluminationWaveLength: 0x00220055,
    IlluminationPower: 0x00220056,
    IlluminationBandwidth: 0x00220057,
    MydriaticAgentSequence: 0x00220058,
    OphthalmicAxialMeasurementsRightEyeSequence: 0x00221007,
    OphthalmicAxialMeasurementsLeftEyeSequence: 0x00221008,
    OphthalmicAxialMeasurementsDeviceType: 0x00221009,
    OphthalmicAxialLengthMeasurementsType: 0x00221010,
    OphthalmicAxialLengthSequence: 0x00221012,
    OphthalmicAxialLength: 0x00221019,
    LensStatusCodeSequence: 0x00221024,
    VitreousStatusCodeSequence: 0x00221025,
    IOLFormulaCodeSequence: 0x00221028,
    IOLFormulaDetail: 0x00221029,
    KeratometerIndex: 0x00221033,
    SourceOfOphthalmicAxialLengthCodeSequence: 0x00221035,
    TargetRefraction: 0x00221037,
    RefractiveProcedureOccurred: 0x00221039,
    RefractiveSurgeryTypeCodeSequence: 0x00221040,
    OphthalmicUltrasoundMethodCodeSequence: 0x00221044,
    OphthalmicAxialLengthMeasurementsSequence: 0x00221050,
    IOLPower: 0x00221053,
    PredictedRefractiveError: 0x00221054,
    OphthalmicAxialLengthVelocity: 0x00221059,
    LensStatusDescription: 0x00221065,
    VitreousStatusDescription: 0x00221066,
    IOLPowerSequence: 0x00221090,
    LensConstantSequence: 0x00221092,
    IOLManufacturer: 0x00221093,
    LensConstantDescription: 0x00221094, // retired
    ImplantName: 0x00221095,
    KeratometryMeasurementTypeCodeSequence: 0x00221096,
    ImplantPartNumber: 0x00221097,
    ReferencedOphthalmicAxialMeasurementsSequence: 0x00221100,
    OphthalmicAxialLengthMeasurementsSegmentNameCodeSequence: 0x00221101,
    RefractiveErrorBeforeRefractiveSurgeryCodeSequence: 0x00221103,
    IOLPowerForExactEmmetropia: 0x00221121,
    IOLPowerForExactTargetRefraction: 0x00221122,
    AnteriorChamberDepthDefinitionCodeSequence: 0x00221125,
    LensThicknessSequence: 0x00221127,
    AnteriorChamberDepthSequence: 0x00221128,
    LensThickness: 0x00221130,
    AnteriorChamberDepth: 0x00221131,
    SourceOfLensThicknessDataCodeSequence: 0x00221132,
    SourceOfAnteriorChamberDepthDataCodeSequence: 0x00221133,
    SourceOfRefractiveMeasurementsSequence: 0x00221134,
    SourceOfRefractiveMeasurementsCodeSequence: 0x00221135,
    OphthalmicAxialLengthMeasurementModified: 0x00221140,
    OphthalmicAxialLengthDataSourceCodeSequence: 0x00221150,
    OphthalmicAxialLengthAcquisitionMethodCodeSequence: 0x00221153, // retired
    SignalToNoiseRatio: 0x00221155,
    OphthalmicAxialLengthDataSourceDescription: 0x00221159,
    OphthalmicAxialLengthMeasurementsTotalLengthSequence: 0x00221210,
    OphthalmicAxialLengthMeasurementsSegmentalLengthSequence: 0x00221211,
    OphthalmicAxialLengthMeasurementsLengthSummationSequence: 0x00221212,
    UltrasoundOphthalmicAxialLengthMeasurementsSequence: 0x00221220,
    OpticalOphthalmicAxialLengthMeasurementsSequence: 0x00221225,
    UltrasoundSelectedOphthalmicAxialLengthSequence: 0x00221230,
    OphthalmicAxialLengthSelectionMethodCodeSequence: 0x00221250,
    OpticalSelectedOphthalmicAxialLengthSequence: 0x00221255,
    SelectedSegmentalOphthalmicAxialLengthSequence: 0x00221257,
    SelectedTotalOphthalmicAxialLengthSequence: 0x00221260,
    OphthalmicAxialLengthQualityMetricSequence: 0x00221262,
    OphthalmicAxialLengthQualityMetricTypeCodeSequence: 0x00221265, // retired
    OphthalmicAxialLengthQualityMetricTypeDescription: 0x00221273, // retired
    IntraocularLensCalculationsRightEyeSequence: 0x00221300,
    IntraocularLensCalculationsLeftEyeSequence: 0x00221310,
    ReferencedOphthalmicAxialLengthMeasurementQCImageSequence: 0x00221330,
    OphthalmicMappingDeviceType: 0x00221415,
    AcquisitionMethodCodeSequence: 0x00221420,
    AcquisitionMethodAlgorithmSequence: 0x00221423,
    OphthalmicThicknessMapTypeCodeSequence: 0x00221436,
    OphthalmicThicknessMappingNormalsSequence: 0x00221443,
    RetinalThicknessDefinitionCodeSequence: 0x00221445,
    PixelValueMappingToCodedConceptSequence: 0x00221450,
    MappedPixelValue: 0x00221452,
    PixelValueMappingExplanation: 0x00221454,
    OphthalmicThicknessMapQualityThresholdSequence: 0x00221458,
    OphthalmicThicknessMapThresholdQualityRating: 0x00221460,
    AnatomicStructureReferencePoint: 0x00221463,
    RegistrationToLocalizerSequence: 0x00221465,
    RegisteredLocalizerUnits: 0x00221466,
    RegisteredLocalizerTopLeftHandCorner: 0x00221467,
    RegisteredLocalizerBottomRightHandCorner: 0x00221468,
    OphthalmicThicknessMapQualityRatingSequence: 0x00221470,
    RelevantOPTAttributesSequence: 0x00221472,
    TransformationMethodCodeSequence: 0x00221512,
    TransformationAlgorithmSequence: 0x00221513,
    OphthalmicAxialLengthMethod: 0x00221515,
    OphthalmicFOV: 0x00221517,
    TwoDimensionalToThreeDimensionalMapSequence: 0x00221518,
    WideFieldOphthalmicPhotographyQualityRatingSequence: 0x00221525,
    WideFieldOphthalmicPhotographyQualityThresholdSequence: 0x00221526,
    WideFieldOphthalmicPhotographyThresholdQualityRating: 0x00221527,
    XCoordinatesCenterPixelViewAngle: 0x00221528,
    YCoordinatesCenterPixelViewAngle: 0x00221529,
    NumberOfMapPoints: 0x00221530,
    TwoDimensionalToThreeDimensionalMapData: 0x00221531,
    DerivationAlgorithmSequence: 0x00221612,
    OphthalmicImageTypeCodeSequence: 0x00221615,
    OphthalmicImageTypeDescription: 0x00221616,
    ScanPatternTypeCodeSequence: 0x00221618,
    ReferencedSurfaceMeshIdentificationSequence: 0x00221620,
    OphthalmicVolumetricPropertiesFlag: 0x00221622,
    OphthalmicAnatomicReferencePointXCoordinate: 0x00221624,
    OphthalmicAnatomicReferencePointYCoordinate: 0x00221626,
    OphthalmicEnFaceImageQualityRatingSequence: 0x00221628,
    QualityThreshold: 0x00221630,
    OCTBscanAnalysisAcquisitionParametersSequence: 0x00221640,
    NumberofBscansPerFrame: 0x00221642,
    BscanSlabThickness: 0x00221643,
    DistanceBetweenBscanSlabs: 0x00221644,
    BscanCycleTime: 0x00221645,
    BscanCycleTimeVector: 0x00221646,
    AscanRate: 0x00221649,
    BscanRate: 0x00221650,
    SurfaceMeshZPixelOffset: 0x00221658,
    VisualFieldHorizontalExtent: 0x00240010,
    VisualFieldVerticalExtent: 0x00240011,
    VisualFieldShape: 0x00240012,
    ScreeningTestModeCodeSequence: 0x00240016,
    MaximumStimulusLuminance: 0x00240018,
    BackgroundLuminance: 0x00240020,
    StimulusColorCodeSequence: 0x00240021,
    BackgroundIlluminationColorCodeSequence: 0x00240024,
    StimulusArea: 0x00240025,
    StimulusPresentationTime: 0x00240028,
    FixationSequence: 0x00240032,
    FixationMonitoringCodeSequence: 0x00240033,
    VisualFieldCatchTrialSequence: 0x00240034,
    FixationCheckedQuantity: 0x00240035,
    PatientNotProperlyFixatedQuantity: 0x00240036,
    PresentedVisualStimuliDataFlag: 0x00240037,
    NumberOfVisualStimuli: 0x00240038,
    ExcessiveFixationLossesDataFlag: 0x00240039,
    ExcessiveFixationLosses: 0x00240040,
    StimuliRetestingQuantity: 0x00240042,
    CommentsOnPatientPerformanceOfVisualField: 0x00240044,
    FalseNegativesEstimateFlag: 0x00240045,
    FalseNegativesEstimate: 0x00240046,
    NegativeCatchTrialsQuantity: 0x00240048,
    FalseNegativesQuantity: 0x00240050,
    ExcessiveFalseNegativesDataFlag: 0x00240051,
    ExcessiveFalseNegatives: 0x00240052,
    FalsePositivesEstimateFlag: 0x00240053,
    FalsePositivesEstimate: 0x00240054,
    CatchTrialsDataFlag: 0x00240055,
    PositiveCatchTrialsQuantity: 0x00240056,
    TestPointNormalsDataFlag: 0x00240057,
    TestPointNormalsSequence: 0x00240058,
    GlobalDeviationProbabilityNormalsFlag: 0x00240059,
    FalsePositivesQuantity: 0x00240060,
    ExcessiveFalsePositivesDataFlag: 0x00240061,
    ExcessiveFalsePositives: 0x00240062,
    VisualFieldTestNormalsFlag: 0x00240063,
    ResultsNormalsSequence: 0x00240064,
    AgeCorrectedSensitivityDeviationAlgorithmSequence: 0x00240065,
    GlobalDeviationFromNormal: 0x00240066,
    GeneralizedDefectSensitivityDeviationAlgorithmSequence: 0x00240067,
    LocalizedDeviationFromNormal: 0x00240068,
    PatientReliabilityIndicator: 0x00240069,
    VisualFieldMeanSensitivity: 0x00240070,
    GlobalDeviationProbability: 0x00240071,
    LocalDeviationProbabilityNormalsFlag: 0x00240072,
    LocalizedDeviationProbability: 0x00240073,
    ShortTermFluctuationCalculated: 0x00240074,
    ShortTermFluctuation: 0x00240075,
    ShortTermFluctuationProbabilityCalculated: 0x00240076,
    ShortTermFluctuationProbability: 0x00240077,
    CorrectedLocalizedDeviationFromNormalCalculated: 0x00240078,
    CorrectedLocalizedDeviationFromNormal: 0x00240079,
    CorrectedLocalizedDeviationFromNormalProbabilityCalculated: 0x00240080,
    CorrectedLocalizedDeviationFromNormalProbability: 0x00240081,
    GlobalDeviationProbabilitySequence: 0x00240083,
    LocalizedDeviationProbabilitySequence: 0x00240085,
    FovealSensitivityMeasured: 0x00240086,
    FovealSensitivity: 0x00240087,
    VisualFieldTestDuration: 0x00240088,
    VisualFieldTestPointSequence: 0x00240089,
    VisualFieldTestPointXCoordinate: 0x00240090,
    VisualFieldTestPointYCoordinate: 0x00240091,
    AgeCorrectedSensitivityDeviationValue: 0x00240092,
    StimulusResults: 0x00240093,
    SensitivityValue: 0x00240094,
    RetestStimulusSeen: 0x00240095,
    RetestSensitivityValue: 0x00240096,
    VisualFieldTestPointNormalsSequence: 0x00240097,
    QuantifiedDefect: 0x00240098,
    AgeCorrectedSensitivityDeviationProbabilityValue: 0x00240100,
    GeneralizedDefectCorrectedSensitivityDeviationFlag: 0x00240102,
    GeneralizedDefectCorrectedSensitivityDeviationValue: 0x00240103,
    GeneralizedDefectCorrectedSensitivityDeviationProbabilityValue: 0x00240104,
    MinimumSensitivityValue: 0x00240105,
    BlindSpotLocalized: 0x00240106,
    BlindSpotXCoordinate: 0x00240107,
    BlindSpotYCoordinate: 0x00240108,
    VisualAcuityMeasurementSequence: 0x00240110,
    RefractiveParametersUsedOnPatientSequence: 0x00240112,
    MeasurementLaterality: 0x00240113,
    OphthalmicPatientClinicalInformationLeftEyeSequence: 0x00240114,
    OphthalmicPatientClinicalInformationRightEyeSequence: 0x00240115,
    FovealPointNormativeDataFlag: 0x00240117,
    FovealPointProbabilityValue: 0x00240118,
    ScreeningBaselineMeasured: 0x00240120,
    ScreeningBaselineMeasuredSequence: 0x00240122,
    ScreeningBaselineType: 0x00240124,
    ScreeningBaselineValue: 0x00240126,
    AlgorithmSource: 0x00240202,
    DataSetName: 0x00240306,
    DataSetVersion: 0x00240307,
    DataSetSource: 0x00240308,
    DataSetDescription: 0x00240309,
    VisualFieldTestReliabilityGlobalIndexSequence: 0x00240317,
    VisualFieldGlobalResultsIndexSequence: 0x00240320,
    DataObservationSequence: 0x00240325,
    IndexNormalsFlag: 0x00240338,
    IndexProbability: 0x00240341,
    IndexProbabilitySequence: 0x00240344,
    SamplesPerPixel: 0x00280002,
    SamplesPerPixelUsed: 0x00280003,
    PhotometricInterpretation: 0x00280004,
    ImageDimensions: 0x00280005, // retired
    PlanarConfiguration: 0x00280006,
    NumberOfFrames: 0x00280008,
    FrameIncrementPointer: 0x00280009,
    FrameDimensionPointer: 0x0028000a,
    Rows: 0x00280010,
    Columns: 0x00280011,
    Planes: 0x00280012, // retired
    UltrasoundColorDataPresent: 0x00280014,
    PixelSpacing: 0x00280030,
    ZoomFactor: 0x00280031,
    ZoomCenter: 0x00280032,
    PixelAspectRatio: 0x00280034,
    ImageFormat: 0x00280040, // retired
    ManipulatedImage: 0x00280050, // retired
    CorrectedImage: 0x00280051,
    CompressionRecognitionCode: 0x0028005f, // retired
    CompressionCode: 0x00280060, // retired
    CompressionOriginator: 0x00280061, // retired
    CompressionLabel: 0x00280062, // retired
    CompressionDescription: 0x00280063, // retired
    CompressionSequence: 0x00280065, // retired
    CompressionStepPointers: 0x00280066, // retired
    RepeatInterval: 0x00280068, // retired
    BitsGrouped: 0x00280069, // retired
    PerimeterTable: 0x00280070, // retired
    PerimeterValue: 0x00280071, // retired
    PredictorRows: 0x00280080, // retired
    PredictorColumns: 0x00280081, // retired
    PredictorConstants: 0x00280082, // retired
    BlockedPixels: 0x00280090, // retired
    BlockRows: 0x00280091, // retired
    BlockColumns: 0x00280092, // retired
    RowOverlap: 0x00280093, // retired
    ColumnOverlap: 0x00280094, // retired
    BitsAllocated: 0x00280100,
    BitsStored: 0x00280101,
    HighBit: 0x00280102,
    PixelRepresentation: 0x00280103,
    SmallestValidPixelValue: 0x00280104, // retired
    LargestValidPixelValue: 0x00280105, // retired
    SmallestImagePixelValue: 0x00280106,
    LargestImagePixelValue: 0x00280107,
    SmallestPixelValueInSeries: 0x00280108,
    LargestPixelValueInSeries: 0x00280109,
    SmallestImagePixelValueInPlane: 0x00280110, // retired
    LargestImagePixelValueInPlane: 0x00280111, // retired
    PixelPaddingValue: 0x00280120,
    PixelPaddingRangeLimit: 0x00280121,
    FloatPixelPaddingValue: 0x00280122,
    DoubleFloatPixelPaddingValue: 0x00280123,
    FloatPixelPaddingRangeLimit: 0x00280124,
    DoubleFloatPixelPaddingRangeLimit: 0x00280125,
    ImageLocation: 0x00280200, // retired
    QualityControlImage: 0x00280300,
    BurnedInAnnotation: 0x00280301,
    RecognizableVisualFeatures: 0x00280302,
    LongitudinalTemporalInformationModified: 0x00280303,
    ReferencedColorPaletteInstanceUID: 0x00280304,
    TransformLabel: 0x00280400, // retired
    TransformVersionNumber: 0x00280401, // retired
    NumberOfTransformSteps: 0x00280402, // retired
    SequenceOfCompressedData: 0x00280403, // retired
    DetailsOfCoefficients: 0x00280404, // retired
    RowsForNthOrderCoefficients: 0x00280400, // retired
    ColumnsForNthOrderCoefficients: 0x00280401, // retired
    CoefficientCoding: 0x00280402, // retired
    CoefficientCodingPointers: 0x00280403, // retired
    DCTLabel: 0x00280700, // retired
    DataBlockDescription: 0x00280701, // retired
    DataBlock: 0x00280702, // retired
    NormalizationFactorFormat: 0x00280710, // retired
    ZonalMapNumberFormat: 0x00280720, // retired
    ZonalMapLocation: 0x00280721, // retired
    ZonalMapFormat: 0x00280722, // retired
    AdaptiveMapFormat: 0x00280730, // retired
    CodeNumberFormat: 0x00280740, // retired
    CodeLabel: 0x00280800, // retired
    NumberOfTables: 0x00280802, // retired
    CodeTableLocation: 0x00280803, // retired
    BitsForCodeWord: 0x00280804, // retired
    ImageDataLocation: 0x00280808, // retired
    PixelSpacingCalibrationType: 0x00280a02,
    PixelSpacingCalibrationDescription: 0x00280a04,
    PixelIntensityRelationship: 0x00281040,
    PixelIntensityRelationshipSign: 0x00281041,
    WindowCenter: 0x00281050,
    WindowWidth: 0x00281051,
    RescaleIntercept: 0x00281052,
    RescaleSlope: 0x00281053,
    RescaleType: 0x00281054,
    WindowCenterWidthExplanation: 0x00281055,
    VOILUTFunction: 0x00281056,
    GrayScale: 0x00281080, // retired
    RecommendedViewingMode: 0x00281090,
    GrayLookupTableDescriptor: 0x00281100, // retired
    RedPaletteColorLookupTableDescriptor: 0x00281101,
    GreenPaletteColorLookupTableDescriptor: 0x00281102,
    BluePaletteColorLookupTableDescriptor: 0x00281103,
    AlphaPaletteColorLookupTableDescriptor: 0x00281104,
    LargeRedPaletteColorLookupTableDescriptor: 0x00281111, // retired
    LargeGreenPaletteColorLookupTableDescriptor: 0x00281112, // retired
    LargeBluePaletteColorLookupTableDescriptor: 0x00281113, // retired
    PaletteColorLookupTableUID: 0x00281199,
    GrayLookupTableData: 0x00281200, // retired
    RedPaletteColorLookupTableData: 0x00281201,
    GreenPaletteColorLookupTableData: 0x00281202,
    BluePaletteColorLookupTableData: 0x00281203,
    AlphaPaletteColorLookupTableData: 0x00281204,
    LargeRedPaletteColorLookupTableData: 0x00281211, // retired
    LargeGreenPaletteColorLookupTableData: 0x00281212, // retired
    LargeBluePaletteColorLookupTableData: 0x00281213, // retired
    LargePaletteColorLookupTableUID: 0x00281214, // retired
    SegmentedRedPaletteColorLookupTableData: 0x00281221,
    SegmentedGreenPaletteColorLookupTableData: 0x00281222,
    SegmentedBluePaletteColorLookupTableData: 0x00281223,
    SegmentedAlphaPaletteColorLookupTableData: 0x00281224,
    StoredValueColorRangeSequence: 0x00281230,
    MinimumStoredValueMapped: 0x00281231,
    MaximumStoredValueMapped: 0x00281232,
    BreastImplantPresent: 0x00281300,
    PartialView: 0x00281350,
    PartialViewDescription: 0x00281351,
    PartialViewCodeSequence: 0x00281352,
    SpatialLocationsPreserved: 0x0028135a,
    DataFrameAssignmentSequence: 0x00281401,
    DataPathAssignment: 0x00281402,
    BitsMappedToColorLookupTable: 0x00281403,
    BlendingLUT1Sequence: 0x00281404,
    BlendingLUT1TransferFunction: 0x00281405,
    BlendingWeightConstant: 0x00281406,
    BlendingLookupTableDescriptor: 0x00281407,
    BlendingLookupTableData: 0x00281408,
    EnhancedPaletteColorLookupTableSequence: 0x0028140b,
    BlendingLUT2Sequence: 0x0028140c,
    BlendingLUT2TransferFunction: 0x0028140d,
    DataPathID: 0x0028140e,
    RGBLUTTransferFunction: 0x0028140f,
    AlphaLUTTransferFunction: 0x00281410,
    ICCProfile: 0x00282000,
    ColorSpace: 0x00282002,
    LossyImageCompression: 0x00282110,
    LossyImageCompressionRatio: 0x00282112,
    LossyImageCompressionMethod: 0x00282114,
    ModalityLUTSequence: 0x00283000,
    LUTDescriptor: 0x00283002,
    LUTExplanation: 0x00283003,
    ModalityLUTType: 0x00283004,
    LUTData: 0x00283006,
    VOILUTSequence: 0x00283010,
    SoftcopyVOILUTSequence: 0x00283110,
    ImagePresentationComments: 0x00284000, // retired
    BiPlaneAcquisitionSequence: 0x00285000, // retired
    RepresentativeFrameNumber: 0x00286010,
    FrameNumbersOfInterest: 0x00286020,
    FrameOfInterestDescription: 0x00286022,
    FrameOfInterestType: 0x00286023,
    MaskPointers: 0x00286030, // retired
    RWavePointer: 0x00286040,
    MaskSubtractionSequence: 0x00286100,
    MaskOperation: 0x00286101,
    ApplicableFrameRange: 0x00286102,
    MaskFrameNumbers: 0x00286110,
    ContrastFrameAveraging: 0x00286112,
    MaskSubPixelShift: 0x00286114,
    TIDOffset: 0x00286120,
    MaskOperationExplanation: 0x00286190,
    EquipmentAdministratorSequence: 0x00287000,
    NumberOfDisplaySubsystems: 0x00287001,
    CurrentConfigurationID: 0x00287002,
    DisplaySubsystemID: 0x00287003,
    DisplaySubsystemName: 0x00287004,
    DisplaySubsystemDescription: 0x00287005,
    SystemStatus: 0x00287006,
    SystemStatusComment: 0x00287007,
    TargetLuminanceCharacteristicsSequence: 0x00287008,
    LuminanceCharacteristicsID: 0x00287009,
    DisplaySubsystemConfigurationSequence: 0x0028700a,
    ConfigurationID: 0x0028700b,
    ConfigurationName: 0x0028700c,
    ConfigurationDescription: 0x0028700d,
    ReferencedTargetLuminanceCharacteristicsID: 0x0028700e,
    QAResultsSequence: 0x0028700f,
    DisplaySubsystemQAResultsSequence: 0x00287010,
    ConfigurationQAResultsSequence: 0x00287011,
    MeasurementEquipmentSequence: 0x00287012,
    MeasurementFunctions: 0x00287013,
    MeasurementEquipmentType: 0x00287014,
    VisualEvaluationResultSequence: 0x00287015,
    DisplayCalibrationResultSequence: 0x00287016,
    DDLValue: 0x00287017,
    CIExyWhitePoint: 0x00287018,
    DisplayFunctionType: 0x00287019,
    GammaValue: 0x0028701a,
    NumberOfLuminancePoints: 0x0028701b,
    LuminanceResponseSequence: 0x0028701c,
    TargetMinimumLuminance: 0x0028701d,
    TargetMaximumLuminance: 0x0028701e,
    LuminanceValue: 0x0028701f,
    LuminanceResponseDescription: 0x00287020,
    WhitePointFlag: 0x00287021,
    DisplayDeviceTypeCodeSequence: 0x00287022,
    DisplaySubsystemSequence: 0x00287023,
    LuminanceResultSequence: 0x00287024,
    AmbientLightValueSource: 0x00287025,
    MeasuredCharacteristics: 0x00287026,
    LuminanceUniformityResultSequence: 0x00287027,
    VisualEvaluationTestSequence: 0x00287028,
    TestResult: 0x00287029,
    TestResultComment: 0x0028702a,
    TestImageValidation: 0x0028702b,
    TestPatternCodeSequence: 0x0028702c,
    MeasurementPatternCodeSequence: 0x0028702d,
    VisualEvaluationMethodCodeSequence: 0x0028702e,
    PixelDataProviderURL: 0x00287fe0,
    DataPointRows: 0x00289001,
    DataPointColumns: 0x00289002,
    SignalDomainColumns: 0x00289003,
    LargestMonochromePixelValue: 0x00289099, // retired
    DataRepresentation: 0x00289108,
    PixelMeasuresSequence: 0x00289110,
    FrameVOILUTSequence: 0x00289132,
    PixelValueTransformationSequence: 0x00289145,
    SignalDomainRows: 0x00289235,
    DisplayFilterPercentage: 0x00289411,
    FramePixelShiftSequence: 0x00289415,
    SubtractionItemID: 0x00289416,
    PixelIntensityRelationshipLUTSequence: 0x00289422,
    FramePixelDataPropertiesSequence: 0x00289443,
    GeometricalProperties: 0x00289444,
    GeometricMaximumDistortion: 0x00289445,
    ImageProcessingApplied: 0x00289446,
    MaskSelectionMode: 0x00289454,
    LUTFunction: 0x00289474,
    MaskVisibilityPercentage: 0x00289478,
    PixelShiftSequence: 0x00289501,
    RegionPixelShiftSequence: 0x00289502,
    VerticesOfTheRegion: 0x00289503,
    MultiFramePresentationSequence: 0x00289505,
    PixelShiftFrameRange: 0x00289506,
    LUTFrameRange: 0x00289507,
    ImageToEquipmentMappingMatrix: 0x00289520,
    EquipmentCoordinateSystemIdentification: 0x00289537,
    StudyStatusID: 0x0032000a, // retired
    StudyPriorityID: 0x0032000c, // retired
    StudyIDIssuer: 0x00320012, // retired
    StudyVerifiedDate: 0x00320032, // retired
    StudyVerifiedTime: 0x00320033, // retired
    StudyReadDate: 0x00320034, // retired
    StudyReadTime: 0x00320035, // retired
    ScheduledStudyStartDate: 0x00321000, // retired
    ScheduledStudyStartTime: 0x00321001, // retired
    ScheduledStudyStopDate: 0x00321010, // retired
    ScheduledStudyStopTime: 0x00321011, // retired
    ScheduledStudyLocation: 0x00321020, // retired
    ScheduledStudyLocationAETitle: 0x00321021, // retired
    ReasonForStudy: 0x00321030, // retired
    RequestingPhysicianIdentificationSequence: 0x00321031,
    RequestingPhysician: 0x00321032,
    RequestingService: 0x00321033,
    RequestingServiceCodeSequence: 0x00321034,
    StudyArrivalDate: 0x00321040, // retired
    StudyArrivalTime: 0x00321041, // retired
    StudyCompletionDate: 0x00321050, // retired
    StudyCompletionTime: 0x00321051, // retired
    StudyComponentStatusID: 0x00321055, // retired
    RequestedProcedureDescription: 0x00321060,
    RequestedProcedureCodeSequence: 0x00321064,
    RequestedContrastAgent: 0x00321070,
    StudyComments: 0x00324000, // retired
    ReferencedPatientAliasSequence: 0x00380004,
    VisitStatusID: 0x00380008,
    AdmissionID: 0x00380010,
    IssuerOfAdmissionID: 0x00380011, // retired
    IssuerOfAdmissionIDSequence: 0x00380014,
    RouteOfAdmissions: 0x00380016,
    ScheduledAdmissionDate: 0x0038001a, // retired
    ScheduledAdmissionTime: 0x0038001b, // retired
    ScheduledDischargeDate: 0x0038001c, // retired
    ScheduledDischargeTime: 0x0038001d, // retired
    ScheduledPatientInstitutionResidence: 0x0038001e, // retired
    AdmittingDate: 0x00380020,
    AdmittingTime: 0x00380021,
    DischargeDate: 0x00380030, // retired
    DischargeTime: 0x00380032, // retired
    DischargeDiagnosisDescription: 0x00380040, // retired
    DischargeDiagnosisCodeSequence: 0x00380044, // retired
    SpecialNeeds: 0x00380050,
    ServiceEpisodeID: 0x00380060,
    IssuerOfServiceEpisodeID: 0x00380061, // retired
    ServiceEpisodeDescription: 0x00380062,
    IssuerOfServiceEpisodeIDSequence: 0x00380064,
    PertinentDocumentsSequence: 0x00380100,
    PertinentResourcesSequence: 0x00380101,
    ResourceDescription: 0x00380102,
    CurrentPatientLocation: 0x00380300,
    PatientInstitutionResidence: 0x00380400,
    PatientState: 0x00380500,
    PatientClinicalTrialParticipationSequence: 0x00380502,
    VisitComments: 0x00384000,
    WaveformOriginality: 0x003a0004,
    NumberOfWaveformChannels: 0x003a0005,
    NumberOfWaveformSamples: 0x003a0010,
    SamplingFrequency: 0x003a001a,
    MultiplexGroupLabel: 0x003a0020,
    ChannelDefinitionSequence: 0x003a0200,
    WaveformChannelNumber: 0x003a0202,
    ChannelLabel: 0x003a0203,
    ChannelStatus: 0x003a0205,
    ChannelSourceSequence: 0x003a0208,
    ChannelSourceModifiersSequence: 0x003a0209,
    SourceWaveformSequence: 0x003a020a,
    ChannelDerivationDescription: 0x003a020c,
    ChannelSensitivity: 0x003a0210,
    ChannelSensitivityUnitsSequence: 0x003a0211,
    ChannelSensitivityCorrectionFactor: 0x003a0212,
    ChannelBaseline: 0x003a0213,
    ChannelTimeSkew: 0x003a0214,
    ChannelSampleSkew: 0x003a0215,
    ChannelOffset: 0x003a0218,
    WaveformBitsStored: 0x003a021a,
    FilterLowFrequency: 0x003a0220,
    FilterHighFrequency: 0x003a0221,
    NotchFilterFrequency: 0x003a0222,
    NotchFilterBandwidth: 0x003a0223,
    WaveformDataDisplayScale: 0x003a0230,
    WaveformDisplayBackgroundCIELabValue: 0x003a0231,
    WaveformPresentationGroupSequence: 0x003a0240,
    PresentationGroupNumber: 0x003a0241,
    ChannelDisplaySequence: 0x003a0242,
    ChannelRecommendedDisplayCIELabValue: 0x003a0244,
    ChannelPosition: 0x003a0245,
    DisplayShadingFlag: 0x003a0246,
    FractionalChannelDisplayScale: 0x003a0247,
    AbsoluteChannelDisplayScale: 0x003a0248,
    MultiplexedAudioChannelsDescriptionCodeSequence: 0x003a0300,
    ChannelIdentificationCode: 0x003a0301,
    ChannelMode: 0x003a0302,
    ScheduledStationAETitle: 0x00400001,
    ScheduledProcedureStepStartDate: 0x00400002,
    ScheduledProcedureStepStartTime: 0x00400003,
    ScheduledProcedureStepEndDate: 0x00400004,
    ScheduledProcedureStepEndTime: 0x00400005,
    ScheduledPerformingPhysicianName: 0x00400006,
    ScheduledProcedureStepDescription: 0x00400007,
    ScheduledProtocolCodeSequence: 0x00400008,
    ScheduledProcedureStepID: 0x00400009,
    StageCodeSequence: 0x0040000a,
    ScheduledPerformingPhysicianIdentificationSequence: 0x0040000b,
    ScheduledStationName: 0x00400010,
    ScheduledProcedureStepLocation: 0x00400011,
    PreMedication: 0x00400012,
    ScheduledProcedureStepStatus: 0x00400020,
    OrderPlacerIdentifierSequence: 0x00400026,
    OrderFillerIdentifierSequence: 0x00400027,
    LocalNamespaceEntityID: 0x00400031,
    UniversalEntityID: 0x00400032,
    UniversalEntityIDType: 0x00400033,
    IdentifierTypeCode: 0x00400035,
    AssigningFacilitySequence: 0x00400036,
    AssigningJurisdictionCodeSequence: 0x00400039,
    AssigningAgencyOrDepartmentCodeSequence: 0x0040003a,
    ScheduledProcedureStepSequence: 0x00400100,
    ReferencedNonImageCompositeSOPInstanceSequence: 0x00400220,
    PerformedStationAETitle: 0x00400241,
    PerformedStationName: 0x00400242,
    PerformedLocation: 0x00400243,
    PerformedProcedureStepStartDate: 0x00400244,
    PerformedProcedureStepStartTime: 0x00400245,
    PerformedProcedureStepEndDate: 0x00400250,
    PerformedProcedureStepEndTime: 0x00400251,
    PerformedProcedureStepStatus: 0x00400252,
    PerformedProcedureStepID: 0x00400253,
    PerformedProcedureStepDescription: 0x00400254,
    PerformedProcedureTypeDescription: 0x00400255,
    PerformedProtocolCodeSequence: 0x00400260,
    PerformedProtocolType: 0x00400261,
    ScheduledStepAttributesSequence: 0x00400270,
    RequestAttributesSequence: 0x00400275,
    CommentsOnThePerformedProcedureStep: 0x00400280,
    PerformedProcedureStepDiscontinuationReasonCodeSequence: 0x00400281,
    QuantitySequence: 0x00400293,
    Quantity: 0x00400294,
    MeasuringUnitsSequence: 0x00400295,
    BillingItemSequence: 0x00400296,
    TotalTimeOfFluoroscopy: 0x00400300, // retired
    TotalNumberOfExposures: 0x00400301, // retired
    EntranceDose: 0x00400302,
    ExposedArea: 0x00400303,
    DistanceSourceToEntrance: 0x00400306,
    DistanceSourceToSupport: 0x00400307, // retired
    ExposureDoseSequence: 0x0040030e, // retired
    CommentsOnRadiationDose: 0x00400310,
    XRayOutput: 0x00400312,
    HalfValueLayer: 0x00400314,
    OrganDose: 0x00400316,
    OrganExposed: 0x00400318,
    BillingProcedureStepSequence: 0x00400320,
    FilmConsumptionSequence: 0x00400321,
    BillingSuppliesAndDevicesSequence: 0x00400324,
    ReferencedProcedureStepSequence: 0x00400330, // retired
    PerformedSeriesSequence: 0x00400340,
    CommentsOnTheScheduledProcedureStep: 0x00400400,
    ProtocolContextSequence: 0x00400440,
    ContentItemModifierSequence: 0x00400441,
    ScheduledSpecimenSequence: 0x00400500,
    SpecimenAccessionNumber: 0x0040050a, // retired
    ContainerIdentifier: 0x00400512,
    IssuerOfTheContainerIdentifierSequence: 0x00400513,
    AlternateContainerIdentifierSequence: 0x00400515,
    ContainerTypeCodeSequence: 0x00400518,
    ContainerDescription: 0x0040051a,
    ContainerComponentSequence: 0x00400520,
    SpecimenSequence: 0x00400550, // retired
    SpecimenIdentifier: 0x00400551,
    SpecimenDescriptionSequenceTrial: 0x00400552, // retired
    SpecimenDescriptionTrial: 0x00400553, // retired
    SpecimenUID: 0x00400554,
    AcquisitionContextSequence: 0x00400555,
    AcquisitionContextDescription: 0x00400556,
    SpecimenTypeCodeSequence: 0x0040059a,
    SpecimenDescriptionSequence: 0x00400560,
    IssuerOfTheSpecimenIdentifierSequence: 0x00400562,
    SpecimenShortDescription: 0x00400600,
    SpecimenDetailedDescription: 0x00400602,
    SpecimenPreparationSequence: 0x00400610,
    SpecimenPreparationStepContentItemSequence: 0x00400612,
    SpecimenLocalizationContentItemSequence: 0x00400620,
    SlideIdentifier: 0x004006fa, // retired
    ImageCenterPointCoordinatesSequence: 0x0040071a,
    XOffsetInSlideCoordinateSystem: 0x0040072a,
    YOffsetInSlideCoordinateSystem: 0x0040073a,
    ZOffsetInSlideCoordinateSystem: 0x0040074a,
    PixelSpacingSequence: 0x004008d8, // retired
    CoordinateSystemAxisCodeSequence: 0x004008da, // retired
    MeasurementUnitsCodeSequence: 0x004008ea,
    VitalStainCodeSequenceTrial: 0x004009f8, // retired
    RequestedProcedureID: 0x00401001,
    ReasonForTheRequestedProcedure: 0x00401002,
    RequestedProcedurePriority: 0x00401003,
    PatientTransportArrangements: 0x00401004,
    RequestedProcedureLocation: 0x00401005,
    PlacerOrderNumberProcedure: 0x00401006, // retired
    FillerOrderNumberProcedure: 0x00401007, // retired
    ConfidentialityCode: 0x00401008,
    ReportingPriority: 0x00401009,
    ReasonForRequestedProcedureCodeSequence: 0x0040100a,
    NamesOfIntendedRecipientsOfResults: 0x00401010,
    IntendedRecipientsOfResultsIdentificationSequence: 0x00401011,
    ReasonForPerformedProcedureCodeSequence: 0x00401012,
    RequestedProcedureDescriptionTrial: 0x00401060, // retired
    PersonIdentificationCodeSequence: 0x00401101,
    PersonAddress: 0x00401102,
    PersonTelephoneNumbers: 0x00401103,
    PersonTelecomInformation: 0x00401104,
    RequestedProcedureComments: 0x00401400,
    ReasonForTheImagingServiceRequest: 0x00402001, // retired
    IssueDateOfImagingServiceRequest: 0x00402004,
    IssueTimeOfImagingServiceRequest: 0x00402005,
    PlacerOrderNumberImagingServiceRequestRetired: 0x00402006, // retired
    FillerOrderNumberImagingServiceRequestRetired: 0x00402007, // retired
    OrderEnteredBy: 0x00402008,
    OrderEntererLocation: 0x00402009,
    OrderCallbackPhoneNumber: 0x00402010,
    OrderCallbackTelecomInformation: 0x00402011,
    PlacerOrderNumberImagingServiceRequest: 0x00402016,
    FillerOrderNumberImagingServiceRequest: 0x00402017,
    ImagingServiceRequestComments: 0x00402400,
    ConfidentialityConstraintOnPatientDataDescription: 0x00403001,
    GeneralPurposeScheduledProcedureStepStatus: 0x00404001, // retired
    GeneralPurposePerformedProcedureStepStatus: 0x00404002, // retired
    GeneralPurposeScheduledProcedureStepPriority: 0x00404003, // retired
    ScheduledProcessingApplicationsCodeSequence: 0x00404004, // retired
    ScheduledProcedureStepStartDateTime: 0x00404005,
    MultipleCopiesFlag: 0x00404006, // retired
    PerformedProcessingApplicationsCodeSequence: 0x00404007, // retired
    HumanPerformerCodeSequence: 0x00404009,
    ScheduledProcedureStepModificationDateTime: 0x00404010,
    ExpectedCompletionDateTime: 0x00404011,
    ResultingGeneralPurposePerformedProcedureStepsSequence: 0x00404015, // retired
    ReferencedGeneralPurposeScheduledProcedureStepSequence: 0x00404016, // retired
    ScheduledWorkitemCodeSequence: 0x00404018,
    PerformedWorkitemCodeSequence: 0x00404019,
    InputAvailabilityFlag: 0x00404020, // retired
    InputInformationSequence: 0x00404021,
    RelevantInformationSequence: 0x00404022, // retired
    ReferencedGeneralPurposeScheduledProcedureStepTransactionUID: 0x00404023, // retired
    ScheduledStationNameCodeSequence: 0x00404025,
    ScheduledStationClassCodeSequence: 0x00404026,
    ScheduledStationGeographicLocationCodeSequence: 0x00404027,
    PerformedStationNameCodeSequence: 0x00404028,
    PerformedStationClassCodeSequence: 0x00404029,
    PerformedStationGeographicLocationCodeSequence: 0x00404030,
    RequestedSubsequentWorkitemCodeSequence: 0x00404031, // retired
    NonDICOMOutputCodeSequence: 0x00404032, // retired
    OutputInformationSequence: 0x00404033,
    ScheduledHumanPerformersSequence: 0x00404034,
    ActualHumanPerformersSequence: 0x00404035,
    HumanPerformerOrganization: 0x00404036,
    HumanPerformerName: 0x00404037,
    RawDataHandling: 0x00404040,
    InputReadinessState: 0x00404041,
    PerformedProcedureStepStartDateTime: 0x00404050,
    PerformedProcedureStepEndDateTime: 0x00404051,
    ProcedureStepCancellationDateTime: 0x00404052,
    OutputDestinationSequence: 0x00404070,
    DICOMStorageSequence: 0x00404071,
    STOWRSStorageSequence: 0x00404072,
    StorageURL: 0x00404073,
    XDSStorageSequence: 0x00404074,
    EntranceDoseInmGy: 0x00408302,
    EntranceDoseDerivation: 0x00408303,
    ParametricMapFrameTypeSequence: 0x00409092,
    ReferencedImageRealWorldValueMappingSequence: 0x00409094,
    RealWorldValueMappingSequence: 0x00409096,
    PixelValueMappingCodeSequence: 0x00409098,
    LUTLabel: 0x00409210,
    RealWorldValueLastValueMapped: 0x00409211,
    RealWorldValueLUTData: 0x00409212,
    DoubleFloatRealWorldValueLastValueMapped: 0x00409213,
    DoubleFloatRealWorldValueFirstValueMapped: 0x00409214,
    RealWorldValueFirstValueMapped: 0x00409216,
    QuantityDefinitionSequence: 0x00409220,
    RealWorldValueIntercept: 0x00409224,
    RealWorldValueSlope: 0x00409225,
    FindingsFlagTrial: 0x0040a007, // retired
    RelationshipType: 0x0040a010,
    FindingsSequenceTrial: 0x0040a020, // retired
    FindingsGroupUIDTrial: 0x0040a021, // retired
    ReferencedFindingsGroupUIDTrial: 0x0040a022, // retired
    FindingsGroupRecordingDateTrial: 0x0040a023, // retired
    FindingsGroupRecordingTimeTrial: 0x0040a024, // retired
    FindingsSourceCategoryCodeSequenceTrial: 0x0040a026, // retired
    VerifyingOrganization: 0x0040a027,
    DocumentingOrganizationIdentifierCodeSequenceTrial: 0x0040a028, // retired
    VerificationDateTime: 0x0040a030,
    ObservationDateTime: 0x0040a032,
    ValueType: 0x0040a040,
    ConceptNameCodeSequence: 0x0040a043,
    MeasurementPrecisionDescriptionTrial: 0x0040a047, // retired
    ContinuityOfContent: 0x0040a050,
    UrgencyOrPriorityAlertsTrial: 0x0040a057, // retired
    SequencingIndicatorTrial: 0x0040a060, // retired
    DocumentIdentifierCodeSequenceTrial: 0x0040a066, // retired
    DocumentAuthorTrial: 0x0040a067, // retired
    DocumentAuthorIdentifierCodeSequenceTrial: 0x0040a068, // retired
    IdentifierCodeSequenceTrial: 0x0040a070, // retired
    VerifyingObserverSequence: 0x0040a073,
    ObjectBinaryIdentifierTrial: 0x0040a074, // retired
    VerifyingObserverName: 0x0040a075,
    DocumentingObserverIdentifierCodeSequenceTrial: 0x0040a076, // retired
    AuthorObserverSequence: 0x0040a078,
    ParticipantSequence: 0x0040a07a,
    CustodialOrganizationSequence: 0x0040a07c,
    ParticipationType: 0x0040a080,
    ParticipationDateTime: 0x0040a082,
    ObserverType: 0x0040a084,
    ProcedureIdentifierCodeSequenceTrial: 0x0040a085, // retired
    VerifyingObserverIdentificationCodeSequence: 0x0040a088,
    ObjectDirectoryBinaryIdentifierTrial: 0x0040a089, // retired
    EquivalentCDADocumentSequence: 0x0040a090, // retired
    ReferencedWaveformChannels: 0x0040a0b0,
    DateOfDocumentOrVerbalTransactionTrial: 0x0040a110, // retired
    TimeOfDocumentCreationOrVerbalTransactionTrial: 0x0040a112, // retired
    DateTime: 0x0040a120,
    Date: 0x0040a121,
    Time: 0x0040a122,
    PersonName: 0x0040a123,
    UID: 0x0040a124,
    ReportStatusIDTrial: 0x0040a125, // retired
    TemporalRangeType: 0x0040a130,
    ReferencedSamplePositions: 0x0040a132,
    ReferencedFrameNumbers: 0x0040a136,
    ReferencedTimeOffsets: 0x0040a138,
    ReferencedDateTime: 0x0040a13a,
    TextValue: 0x0040a160,
    FloatingPointValue: 0x0040a161,
    RationalNumeratorValue: 0x0040a162,
    RationalDenominatorValue: 0x0040a163,
    ObservationCategoryCodeSequenceTrial: 0x0040a167, // retired
    ConceptCodeSequence: 0x0040a168,
    BibliographicCitationTrial: 0x0040a16a, // retired
    PurposeOfReferenceCodeSequence: 0x0040a170,
    ObservationUID: 0x0040a171,
    ReferencedObservationUIDTrial: 0x0040a172, // retired
    ReferencedObservationClassTrial: 0x0040a173, // retired
    ReferencedObjectObservationClassTrial: 0x0040a174, // retired
    AnnotationGroupNumber: 0x0040a180,
    ObservationDateTrial: 0x0040a192, // retired
    ObservationTimeTrial: 0x0040a193, // retired
    MeasurementAutomationTrial: 0x0040a194, // retired
    ModifierCodeSequence: 0x0040a195,
    IdentificationDescriptionTrial: 0x0040a224, // retired
    CoordinatesSetGeometricTypeTrial: 0x0040a290, // retired
    AlgorithmCodeSequenceTrial: 0x0040a296, // retired
    AlgorithmDescriptionTrial: 0x0040a297, // retired
    PixelCoordinatesSetTrial: 0x0040a29a, // retired
    MeasuredValueSequence: 0x0040a300,
    NumericValueQualifierCodeSequence: 0x0040a301,
    CurrentObserverTrial: 0x0040a307, // retired
    NumericValue: 0x0040a30a,
    ReferencedAccessionSequenceTrial: 0x0040a313, // retired
    ReportStatusCommentTrial: 0x0040a33a, // retired
    ProcedureContextSequenceTrial: 0x0040a340, // retired
    VerbalSourceTrial: 0x0040a352, // retired
    AddressTrial: 0x0040a353, // retired
    TelephoneNumberTrial: 0x0040a354, // retired
    VerbalSourceIdentifierCodeSequenceTrial: 0x0040a358, // retired
    PredecessorDocumentsSequence: 0x0040a360,
    ReferencedRequestSequence: 0x0040a370,
    PerformedProcedureCodeSequence: 0x0040a372,
    CurrentRequestedProcedureEvidenceSequence: 0x0040a375,
    ReportDetailSequenceTrial: 0x0040a380, // retired
    PertinentOtherEvidenceSequence: 0x0040a385,
    HL7StructuredDocumentReferenceSequence: 0x0040a390,
    ObservationSubjectUIDTrial: 0x0040a402, // retired
    ObservationSubjectClassTrial: 0x0040a403, // retired
    ObservationSubjectTypeCodeSequenceTrial: 0x0040a404, // retired
    CompletionFlag: 0x0040a491,
    CompletionFlagDescription: 0x0040a492,
    VerificationFlag: 0x0040a493,
    ArchiveRequested: 0x0040a494,
    PreliminaryFlag: 0x0040a496,
    ContentTemplateSequence: 0x0040a504,
    IdenticalDocumentsSequence: 0x0040a525,
    ObservationSubjectContextFlagTrial: 0x0040a600, // retired
    ObserverContextFlagTrial: 0x0040a601, // retired
    ProcedureContextFlagTrial: 0x0040a603, // retired
    ContentSequence: 0x0040a730,
    RelationshipSequenceTrial: 0x0040a731, // retired
    RelationshipTypeCodeSequenceTrial: 0x0040a732, // retired
    LanguageCodeSequenceTrial: 0x0040a744, // retired
    UniformResourceLocatorTrial: 0x0040a992, // retired
    WaveformAnnotationSequence: 0x0040b020,
    TemplateIdentifier: 0x0040db00,
    TemplateVersion: 0x0040db06, // retired
    TemplateLocalVersion: 0x0040db07, // retired
    TemplateExtensionFlag: 0x0040db0b, // retired
    TemplateExtensionOrganizationUID: 0x0040db0c, // retired
    TemplateExtensionCreatorUID: 0x0040db0d, // retired
    ReferencedContentItemIdentifier: 0x0040db73,
    HL7InstanceIdentifier: 0x0040e001,
    HL7DocumentEffectiveTime: 0x0040e004,
    HL7DocumentTypeCodeSequence: 0x0040e006,
    DocumentClassCodeSequence: 0x0040e008,
    RetrieveURI: 0x0040e010,
    RetrieveLocationUID: 0x0040e011,
    TypeOfInstances: 0x0040e020,
    DICOMRetrievalSequence: 0x0040e021,
    DICOMMediaRetrievalSequence: 0x0040e022,
    WADORetrievalSequence: 0x0040e023,
    XDSRetrievalSequence: 0x0040e024,
    WADORSRetrievalSequence: 0x0040e025,
    RepositoryUniqueID: 0x0040e030,
    HomeCommunityID: 0x0040e031,
    DocumentTitle: 0x00420010,
    EncapsulatedDocument: 0x00420011,
    MIMETypeOfEncapsulatedDocument: 0x00420012,
    SourceInstanceSequence: 0x00420013,
    ListOfMIMETypes: 0x00420014,
    ProductPackageIdentifier: 0x00440001,
    SubstanceAdministrationApproval: 0x00440002,
    ApprovalStatusFurtherDescription: 0x00440003,
    ApprovalStatusDateTime: 0x00440004,
    ProductTypeCodeSequence: 0x00440007,
    ProductName: 0x00440008,
    ProductDescription: 0x00440009,
    ProductLotIdentifier: 0x0044000a,
    ProductExpirationDateTime: 0x0044000b,
    SubstanceAdministrationDateTime: 0x00440010,
    SubstanceAdministrationNotes: 0x00440011,
    SubstanceAdministrationDeviceID: 0x00440012,
    ProductParameterSequence: 0x00440013,
    SubstanceAdministrationParameterSequence: 0x00440019,
    ApprovalSequence: 0x00440100,
    AssertionCodeSequence: 0x00440101,
    AssertionUID: 0x00440102,
    AsserterIdentificationSequence: 0x00440103,
    AssertionDateTime: 0x00440104,
    AssertionExpirationDateTime: 0x00440105,
    AssertionComments: 0x00440106,
    RelatedAssertionSequence: 0x00440107,
    ReferencedAssertionUID: 0x00440108,
    ApprovalSubjectSequence: 0x00440109,
    OrganizationalRoleCodeSequence: 0x0044010a,
    LensDescription: 0x00460012,
    RightLensSequence: 0x00460014,
    LeftLensSequence: 0x00460015,
    UnspecifiedLateralityLensSequence: 0x00460016,
    CylinderSequence: 0x00460018,
    PrismSequence: 0x00460028,
    HorizontalPrismPower: 0x00460030,
    HorizontalPrismBase: 0x00460032,
    VerticalPrismPower: 0x00460034,
    VerticalPrismBase: 0x00460036,
    LensSegmentType: 0x00460038,
    OpticalTransmittance: 0x00460040,
    ChannelWidth: 0x00460042,
    PupilSize: 0x00460044,
    CornealSize: 0x00460046,
    AutorefractionRightEyeSequence: 0x00460050,
    AutorefractionLeftEyeSequence: 0x00460052,
    DistancePupillaryDistance: 0x00460060,
    NearPupillaryDistance: 0x00460062,
    IntermediatePupillaryDistance: 0x00460063,
    OtherPupillaryDistance: 0x00460064,
    KeratometryRightEyeSequence: 0x00460070,
    KeratometryLeftEyeSequence: 0x00460071,
    SteepKeratometricAxisSequence: 0x00460074,
    RadiusOfCurvature: 0x00460075,
    KeratometricPower: 0x00460076,
    KeratometricAxis: 0x00460077,
    FlatKeratometricAxisSequence: 0x00460080,
    BackgroundColor: 0x00460092,
    Optotype: 0x00460094,
    OptotypePresentation: 0x00460095,
    SubjectiveRefractionRightEyeSequence: 0x00460097,
    SubjectiveRefractionLeftEyeSequence: 0x00460098,
    AddNearSequence: 0x00460100,
    AddIntermediateSequence: 0x00460101,
    AddOtherSequence: 0x00460102,
    AddPower: 0x00460104,
    ViewingDistance: 0x00460106,
    VisualAcuityTypeCodeSequence: 0x00460121,
    VisualAcuityRightEyeSequence: 0x00460122,
    VisualAcuityLeftEyeSequence: 0x00460123,
    VisualAcuityBothEyesOpenSequence: 0x00460124,
    ViewingDistanceType: 0x00460125,
    VisualAcuityModifiers: 0x00460135,
    DecimalVisualAcuity: 0x00460137,
    OptotypeDetailedDefinition: 0x00460139,
    ReferencedRefractiveMeasurementsSequence: 0x00460145,
    SpherePower: 0x00460146,
    CylinderPower: 0x00460147,
    CornealTopographySurface: 0x00460201,
    CornealVertexLocation: 0x00460202,
    PupilCentroidXCoordinate: 0x00460203,
    PupilCentroidYCoordinate: 0x00460204,
    EquivalentPupilRadius: 0x00460205,
    CornealTopographyMapTypeCodeSequence: 0x00460207,
    VerticesOfTheOutlineOfPupil: 0x00460208,
    CornealTopographyMappingNormalsSequence: 0x00460210,
    MaximumCornealCurvatureSequence: 0x00460211,
    MaximumCornealCurvature: 0x00460212,
    MaximumCornealCurvatureLocation: 0x00460213,
    MinimumKeratometricSequence: 0x00460215,
    SimulatedKeratometricCylinderSequence: 0x00460218,
    AverageCornealPower: 0x00460220,
    CornealISValue: 0x00460224,
    AnalyzedArea: 0x00460227,
    SurfaceRegularityIndex: 0x00460230,
    SurfaceAsymmetryIndex: 0x00460232,
    CornealEccentricityIndex: 0x00460234,
    KeratoconusPredictionIndex: 0x00460236,
    DecimalPotentialVisualAcuity: 0x00460238,
    CornealTopographyMapQualityEvaluation: 0x00460242,
    SourceImageCornealProcessedDataSequence: 0x00460244,
    CornealPointLocation: 0x00460247,
    CornealPointEstimated: 0x00460248,
    AxialPower: 0x00460249,
    TangentialPower: 0x00460250,
    RefractivePower: 0x00460251,
    RelativeElevation: 0x00460252,
    CornealWavefront: 0x00460253,
    ImagedVolumeWidth: 0x00480001,
    ImagedVolumeHeight: 0x00480002,
    ImagedVolumeDepth: 0x00480003,
    TotalPixelMatrixColumns: 0x00480006,
    TotalPixelMatrixRows: 0x00480007,
    TotalPixelMatrixOriginSequence: 0x00480008,
    SpecimenLabelInImage: 0x00480010,
    FocusMethod: 0x00480011,
    ExtendedDepthOfField: 0x00480012,
    NumberOfFocalPlanes: 0x00480013,
    DistanceBetweenFocalPlanes: 0x00480014,
    RecommendedAbsentPixelCIELabValue: 0x00480015,
    IlluminatorTypeCodeSequence: 0x00480100,
    ImageOrientationSlide: 0x00480102,
    OpticalPathSequence: 0x00480105,
    OpticalPathIdentifier: 0x00480106,
    OpticalPathDescription: 0x00480107,
    IlluminationColorCodeSequence: 0x00480108,
    SpecimenReferenceSequence: 0x00480110,
    CondenserLensPower: 0x00480111,
    ObjectiveLensPower: 0x00480112,
    ObjectiveLensNumericalAperture: 0x00480113,
    PaletteColorLookupTableSequence: 0x00480120,
    ReferencedImageNavigationSequence: 0x00480200,
    TopLeftHandCornerOfLocalizerArea: 0x00480201,
    BottomRightHandCornerOfLocalizerArea: 0x00480202,
    OpticalPathIdentificationSequence: 0x00480207,
    PlanePositionSlideSequence: 0x0048021a,
    ColumnPositionInTotalImagePixelMatrix: 0x0048021e,
    RowPositionInTotalImagePixelMatrix: 0x0048021f,
    PixelOriginInterpretation: 0x00480301,
    CalibrationImage: 0x00500004,
    DeviceSequence: 0x00500010,
    ContainerComponentTypeCodeSequence: 0x00500012,
    ContainerComponentThickness: 0x00500013,
    DeviceLength: 0x00500014,
    ContainerComponentWidth: 0x00500015,
    DeviceDiameter: 0x00500016,
    DeviceDiameterUnits: 0x00500017,
    DeviceVolume: 0x00500018,
    InterMarkerDistance: 0x00500019,
    ContainerComponentMaterial: 0x0050001a,
    ContainerComponentID: 0x0050001b,
    ContainerComponentLength: 0x0050001c,
    ContainerComponentDiameter: 0x0050001d,
    ContainerComponentDescription: 0x0050001e,
    DeviceDescription: 0x00500020,
    ContrastBolusIngredientPercentByVolume: 0x00520001,
    OCTFocalDistance: 0x00520002,
    BeamSpotSize: 0x00520003,
    EffectiveRefractiveIndex: 0x00520004,
    OCTAcquisitionDomain: 0x00520006,
    OCTOpticalCenterWavelength: 0x00520007,
    AxialResolution: 0x00520008,
    RangingDepth: 0x00520009,
    ALineRate: 0x00520011,
    ALinesPerFrame: 0x00520012,
    CatheterRotationalRate: 0x00520013,
    ALinePixelSpacing: 0x00520014,
    ModeOfPercutaneousAccessSequence: 0x00520016,
    IntravascularOCTFrameTypeSequence: 0x00520025,
    OCTZOffsetApplied: 0x00520026,
    IntravascularFrameContentSequence: 0x00520027,
    IntravascularLongitudinalDistance: 0x00520028,
    IntravascularOCTFrameContentSequence: 0x00520029,
    OCTZOffsetCorrection: 0x00520030,
    CatheterDirectionOfRotation: 0x00520031,
    SeamLineLocation: 0x00520033,
    FirstALineLocation: 0x00520034,
    SeamLineIndex: 0x00520036,
    NumberOfPaddedALines: 0x00520038,
    InterpolationType: 0x00520039,
    RefractiveIndexApplied: 0x0052003a,
    EnergyWindowVector: 0x00540010,
    NumberOfEnergyWindows: 0x00540011,
    EnergyWindowInformationSequence: 0x00540012,
    EnergyWindowRangeSequence: 0x00540013,
    EnergyWindowLowerLimit: 0x00540014,
    EnergyWindowUpperLimit: 0x00540015,
    RadiopharmaceuticalInformationSequence: 0x00540016,
    ResidualSyringeCounts: 0x00540017,
    EnergyWindowName: 0x00540018,
    DetectorVector: 0x00540020,
    NumberOfDetectors: 0x00540021,
    DetectorInformationSequence: 0x00540022,
    PhaseVector: 0x00540030,
    NumberOfPhases: 0x00540031,
    PhaseInformationSequence: 0x00540032,
    NumberOfFramesInPhase: 0x00540033,
    PhaseDelay: 0x00540036,
    PauseBetweenFrames: 0x00540038,
    PhaseDescription: 0x00540039,
    RotationVector: 0x00540050,
    NumberOfRotations: 0x00540051,
    RotationInformationSequence: 0x00540052,
    NumberOfFramesInRotation: 0x00540053,
    RRIntervalVector: 0x00540060,
    NumberOfRRIntervals: 0x00540061,
    GatedInformationSequence: 0x00540062,
    DataInformationSequence: 0x00540063,
    TimeSlotVector: 0x00540070,
    NumberOfTimeSlots: 0x00540071,
    TimeSlotInformationSequence: 0x00540072,
    TimeSlotTime: 0x00540073,
    SliceVector: 0x00540080,
    NumberOfSlices: 0x00540081,
    AngularViewVector: 0x00540090,
    TimeSliceVector: 0x00540100,
    NumberOfTimeSlices: 0x00540101,
    StartAngle: 0x00540200,
    TypeOfDetectorMotion: 0x00540202,
    TriggerVector: 0x00540210,
    NumberOfTriggersInPhase: 0x00540211,
    ViewCodeSequence: 0x00540220,
    ViewModifierCodeSequence: 0x00540222,
    RadionuclideCodeSequence: 0x00540300,
    AdministrationRouteCodeSequence: 0x00540302,
    RadiopharmaceuticalCodeSequence: 0x00540304,
    CalibrationDataSequence: 0x00540306,
    EnergyWindowNumber: 0x00540308,
    ImageID: 0x00540400,
    PatientOrientationCodeSequence: 0x00540410,
    PatientOrientationModifierCodeSequence: 0x00540412,
    PatientGantryRelationshipCodeSequence: 0x00540414,
    SliceProgressionDirection: 0x00540500,
    ScanProgressionDirection: 0x00540501,
    SeriesType: 0x00541000,
    Units: 0x00541001,
    CountsSource: 0x00541002,
    ReprojectionMethod: 0x00541004,
    SUVType: 0x00541006,
    RandomsCorrectionMethod: 0x00541100,
    AttenuationCorrectionMethod: 0x00541101,
    DecayCorrection: 0x00541102,
    ReconstructionMethod: 0x00541103,
    DetectorLinesOfResponseUsed: 0x00541104,
    ScatterCorrectionMethod: 0x00541105,
    AxialAcceptance: 0x00541200,
    AxialMash: 0x00541201,
    TransverseMash: 0x00541202,
    DetectorElementSize: 0x00541203,
    CoincidenceWindowWidth: 0x00541210,
    SecondaryCountsType: 0x00541220,
    FrameReferenceTime: 0x00541300,
    PrimaryPromptsCountsAccumulated: 0x00541310,
    SecondaryCountsAccumulated: 0x00541311,
    SliceSensitivityFactor: 0x00541320,
    DecayFactor: 0x00541321,
    DoseCalibrationFactor: 0x00541322,
    ScatterFractionFactor: 0x00541323,
    DeadTimeFactor: 0x00541324,
    ImageIndex: 0x00541330,
    CountsIncluded: 0x00541400, // retired
    DeadTimeCorrectionFlag: 0x00541401, // retired
    HistogramSequence: 0x00603000,
    HistogramNumberOfBins: 0x00603002,
    HistogramFirstBinValue: 0x00603004,
    HistogramLastBinValue: 0x00603006,
    HistogramBinWidth: 0x00603008,
    HistogramExplanation: 0x00603010,
    HistogramData: 0x00603020,
    SegmentationType: 0x00620001,
    SegmentSequence: 0x00620002,
    SegmentedPropertyCategoryCodeSequence: 0x00620003,
    SegmentNumber: 0x00620004,
    SegmentLabel: 0x00620005,
    SegmentDescription: 0x00620006,
    SegmentationAlgorithmIdentificationSequence: 0x00620007,
    SegmentAlgorithmType: 0x00620008,
    SegmentAlgorithmName: 0x00620009,
    SegmentIdentificationSequence: 0x0062000a,
    ReferencedSegmentNumber: 0x0062000b,
    RecommendedDisplayGrayscaleValue: 0x0062000c,
    RecommendedDisplayCIELabValue: 0x0062000d,
    MaximumFractionalValue: 0x0062000e,
    SegmentedPropertyTypeCodeSequence: 0x0062000f,
    SegmentationFractionalType: 0x00620010,
    SegmentedPropertyTypeModifierCodeSequence: 0x00620011,
    UsedSegmentsSequence: 0x00620012,
    TrackingID: 0x00620020,
    TrackingUID: 0x00620021,
    DeformableRegistrationSequence: 0x00640002,
    SourceFrameOfReferenceUID: 0x00640003,
    DeformableRegistrationGridSequence: 0x00640005,
    GridDimensions: 0x00640007,
    GridResolution: 0x00640008,
    VectorGridData: 0x00640009,
    PreDeformationMatrixRegistrationSequence: 0x0064000f,
    PostDeformationMatrixRegistrationSequence: 0x00640010,
    NumberOfSurfaces: 0x00660001,
    SurfaceSequence: 0x00660002,
    SurfaceNumber: 0x00660003,
    SurfaceComments: 0x00660004,
    SurfaceProcessing: 0x00660009,
    SurfaceProcessingRatio: 0x0066000a,
    SurfaceProcessingDescription: 0x0066000b,
    RecommendedPresentationOpacity: 0x0066000c,
    RecommendedPresentationType: 0x0066000d,
    FiniteVolume: 0x0066000e,
    Manifold: 0x00660010,
    SurfacePointsSequence: 0x00660011,
    SurfacePointsNormalsSequence: 0x00660012,
    SurfaceMeshPrimitivesSequence: 0x00660013,
    NumberOfSurfacePoints: 0x00660015,
    PointCoordinatesData: 0x00660016,
    PointPositionAccuracy: 0x00660017,
    MeanPointDistance: 0x00660018,
    MaximumPointDistance: 0x00660019,
    PointsBoundingBoxCoordinates: 0x0066001a,
    AxisOfRotation: 0x0066001b,
    CenterOfRotation: 0x0066001c,
    NumberOfVectors: 0x0066001e,
    VectorDimensionality: 0x0066001f,
    VectorAccuracy: 0x00660020,
    VectorCoordinateData: 0x00660021,
    TrianglePointIndexList: 0x00660023, // retired
    EdgePointIndexList: 0x00660024, // retired
    VertexPointIndexList: 0x00660025, // retired
    TriangleStripSequence: 0x00660026,
    TriangleFanSequence: 0x00660027,
    LineSequence: 0x00660028,
    PrimitivePointIndexList: 0x00660029, // retired
    SurfaceCount: 0x0066002a,
    ReferencedSurfaceSequence: 0x0066002b,
    ReferencedSurfaceNumber: 0x0066002c,
    SegmentSurfaceGenerationAlgorithmIdentificationSequence: 0x0066002d,
    SegmentSurfaceSourceInstanceSequence: 0x0066002e,
    AlgorithmFamilyCodeSequence: 0x0066002f,
    AlgorithmNameCodeSequence: 0x00660030,
    AlgorithmVersion: 0x00660031,
    AlgorithmParameters: 0x00660032,
    FacetSequence: 0x00660034,
    SurfaceProcessingAlgorithmIdentificationSequence: 0x00660035,
    AlgorithmName: 0x00660036,
    RecommendedPointRadius: 0x00660037,
    RecommendedLineThickness: 0x00660038,
    LongPrimitivePointIndexList: 0x00660040,
    LongTrianglePointIndexList: 0x00660041,
    LongEdgePointIndexList: 0x00660042,
    LongVertexPointIndexList: 0x00660043,
    TrackSetSequence: 0x00660101,
    TrackSequence: 0x00660102,
    RecommendedDisplayCIELabValueList: 0x00660103,
    TrackingAlgorithmIdentificationSequence: 0x00660104,
    TrackSetNumber: 0x00660105,
    TrackSetLabel: 0x00660106,
    TrackSetDescription: 0x00660107,
    TrackSetAnatomicalTypeCodeSequence: 0x00660108,
    MeasurementsSequence: 0x00660121,
    TrackSetStatisticsSequence: 0x00660124,
    FloatingPointValues: 0x00660125,
    TrackPointIndexList: 0x00660129,
    TrackStatisticsSequence: 0x00660130,
    MeasurementValuesSequence: 0x00660132,
    DiffusionAcquisitionCodeSequence: 0x00660133,
    DiffusionModelCodeSequence: 0x00660134,
    ImplantSize: 0x00686210,
    ImplantTemplateVersion: 0x00686221,
    ReplacedImplantTemplateSequence: 0x00686222,
    ImplantType: 0x00686223,
    DerivationImplantTemplateSequence: 0x00686224,
    OriginalImplantTemplateSequence: 0x00686225,
    EffectiveDateTime: 0x00686226,
    ImplantTargetAnatomySequence: 0x00686230,
    InformationFromManufacturerSequence: 0x00686260,
    NotificationFromManufacturerSequence: 0x00686265,
    InformationIssueDateTime: 0x00686270,
    InformationSummary: 0x00686280,
    ImplantRegulatoryDisapprovalCodeSequence: 0x006862a0,
    OverallTemplateSpatialTolerance: 0x006862a5,
    HPGLDocumentSequence: 0x006862c0,
    HPGLDocumentID: 0x006862d0,
    HPGLDocumentLabel: 0x006862d5,
    ViewOrientationCodeSequence: 0x006862e0,
    ViewOrientationModifierCodeSequence: 0x006862f0,
    HPGLDocumentScaling: 0x006862f2,
    HPGLDocument: 0x00686300,
    HPGLContourPenNumber: 0x00686310,
    HPGLPenSequence: 0x00686320,
    HPGLPenNumber: 0x00686330,
    HPGLPenLabel: 0x00686340,
    HPGLPenDescription: 0x00686345,
    RecommendedRotationPoint: 0x00686346,
    BoundingRectangle: 0x00686347,
    ImplantTemplate3DModelSurfaceNumber: 0x00686350,
    SurfaceModelDescriptionSequence: 0x00686360,
    SurfaceModelLabel: 0x00686380,
    SurfaceModelScalingFactor: 0x00686390,
    MaterialsCodeSequence: 0x006863a0,
    CoatingMaterialsCodeSequence: 0x006863a4,
    ImplantTypeCodeSequence: 0x006863a8,
    FixationMethodCodeSequence: 0x006863ac,
    MatingFeatureSetsSequence: 0x006863b0,
    MatingFeatureSetID: 0x006863c0,
    MatingFeatureSetLabel: 0x006863d0,
    MatingFeatureSequence: 0x006863e0,
    MatingFeatureID: 0x006863f0,
    MatingFeatureDegreeOfFreedomSequence: 0x00686400,
    DegreeOfFreedomID: 0x00686410,
    DegreeOfFreedomType: 0x00686420,
    TwoDMatingFeatureCoordinatesSequence: 0x00686430,
    ReferencedHPGLDocumentID: 0x00686440,
    TwoDMatingPoint: 0x00686450,
    TwoDMatingAxes: 0x00686460,
    TwoDDegreeOfFreedomSequence: 0x00686470,
    ThreeDDegreeOfFreedomAxis: 0x00686490,
    RangeOfFreedom: 0x006864a0,
    ThreeDMatingPoint: 0x006864c0,
    ThreeDMatingAxes: 0x006864d0,
    TwoDDegreeOfFreedomAxis: 0x006864f0,
    PlanningLandmarkPointSequence: 0x00686500,
    PlanningLandmarkLineSequence: 0x00686510,
    PlanningLandmarkPlaneSequence: 0x00686520,
    PlanningLandmarkID: 0x00686530,
    PlanningLandmarkDescription: 0x00686540,
    PlanningLandmarkIdentificationCodeSequence: 0x00686545,
    TwoDPointCoordinatesSequence: 0x00686550,
    TwoDPointCoordinates: 0x00686560,
    ThreeDPointCoordinates: 0x00686590,
    TwoDLineCoordinatesSequence: 0x006865a0,
    TwoDLineCoordinates: 0x006865b0,
    ThreeDLineCoordinates: 0x006865d0,
    TwoDPlaneCoordinatesSequence: 0x006865e0,
    TwoDPlaneIntersection: 0x006865f0,
    ThreeDPlaneOrigin: 0x00686610,
    ThreeDPlaneNormal: 0x00686620,
    GraphicAnnotationSequence: 0x00700001,
    GraphicLayer: 0x00700002,
    BoundingBoxAnnotationUnits: 0x00700003,
    AnchorPointAnnotationUnits: 0x00700004,
    GraphicAnnotationUnits: 0x00700005,
    UnformattedTextValue: 0x00700006,
    TextObjectSequence: 0x00700008,
    GraphicObjectSequence: 0x00700009,
    BoundingBoxTopLeftHandCorner: 0x00700010,
    BoundingBoxBottomRightHandCorner: 0x00700011,
    BoundingBoxTextHorizontalJustification: 0x00700012,
    AnchorPoint: 0x00700014,
    AnchorPointVisibility: 0x00700015,
    GraphicDimensions: 0x00700020,
    NumberOfGraphicPoints: 0x00700021,
    GraphicData: 0x00700022,
    GraphicType: 0x00700023,
    GraphicFilled: 0x00700024,
    ImageRotationRetired: 0x00700040, // retired
    ImageHorizontalFlip: 0x00700041,
    ImageRotation: 0x00700042,
    DisplayedAreaTopLeftHandCornerTrial: 0x00700050, // retired
    DisplayedAreaBottomRightHandCornerTrial: 0x00700051, // retired
    DisplayedAreaTopLeftHandCorner: 0x00700052,
    DisplayedAreaBottomRightHandCorner: 0x00700053,
    DisplayedAreaSelectionSequence: 0x0070005a,
    GraphicLayerSequence: 0x00700060,
    GraphicLayerOrder: 0x00700062,
    GraphicLayerRecommendedDisplayGrayscaleValue: 0x00700066,
    GraphicLayerRecommendedDisplayRGBValue: 0x00700067, // retired
    GraphicLayerDescription: 0x00700068,
    ContentLabel: 0x00700080,
    ContentDescription: 0x00700081,
    PresentationCreationDate: 0x00700082,
    PresentationCreationTime: 0x00700083,
    ContentCreatorName: 0x00700084,
    ContentCreatorIdentificationCodeSequence: 0x00700086,
    AlternateContentDescriptionSequence: 0x00700087,
    PresentationSizeMode: 0x00700100,
    PresentationPixelSpacing: 0x00700101,
    PresentationPixelAspectRatio: 0x00700102,
    PresentationPixelMagnificationRatio: 0x00700103,
    GraphicGroupLabel: 0x00700207,
    GraphicGroupDescription: 0x00700208,
    CompoundGraphicSequence: 0x00700209,
    CompoundGraphicInstanceID: 0x00700226,
    FontName: 0x00700227,
    FontNameType: 0x00700228,
    CSSFontName: 0x00700229,
    RotationAngle: 0x00700230,
    TextStyleSequence: 0x00700231,
    LineStyleSequence: 0x00700232,
    FillStyleSequence: 0x00700233,
    GraphicGroupSequence: 0x00700234,
    TextColorCIELabValue: 0x00700241,
    HorizontalAlignment: 0x00700242,
    VerticalAlignment: 0x00700243,
    ShadowStyle: 0x00700244,
    ShadowOffsetX: 0x00700245,
    ShadowOffsetY: 0x00700246,
    ShadowColorCIELabValue: 0x00700247,
    Underlined: 0x00700248,
    Bold: 0x00700249,
    Italic: 0x00700250,
    PatternOnColorCIELabValue: 0x00700251,
    PatternOffColorCIELabValue: 0x00700252,
    LineThickness: 0x00700253,
    LineDashingStyle: 0x00700254,
    LinePattern: 0x00700255,
    FillPattern: 0x00700256,
    FillMode: 0x00700257,
    ShadowOpacity: 0x00700258,
    GapLength: 0x00700261,
    DiameterOfVisibility: 0x00700262,
    RotationPoint: 0x00700273,
    TickAlignment: 0x00700274,
    ShowTickLabel: 0x00700278,
    TickLabelAlignment: 0x00700279,
    CompoundGraphicUnits: 0x00700282,
    PatternOnOpacity: 0x00700284,
    PatternOffOpacity: 0x00700285,
    MajorTicksSequence: 0x00700287,
    TickPosition: 0x00700288,
    TickLabel: 0x00700289,
    CompoundGraphicType: 0x00700294,
    GraphicGroupID: 0x00700295,
    ShapeType: 0x00700306,
    RegistrationSequence: 0x00700308,
    MatrixRegistrationSequence: 0x00700309,
    MatrixSequence: 0x0070030a,
    FrameOfReferenceToDisplayedCoordinateSystemTransformationMatrix: 0x0070030b,
    FrameOfReferenceTransformationMatrixType: 0x0070030c,
    RegistrationTypeCodeSequence: 0x0070030d,
    FiducialDescription: 0x0070030f,
    FiducialIdentifier: 0x00700310,
    FiducialIdentifierCodeSequence: 0x00700311,
    ContourUncertaintyRadius: 0x00700312,
    UsedFiducialsSequence: 0x00700314,
    GraphicCoordinatesDataSequence: 0x00700318,
    FiducialUID: 0x0070031a,
    ReferencedFiducialUID: 0x0070031b,
    FiducialSetSequence: 0x0070031c,
    FiducialSequence: 0x0070031e,
    FiducialsPropertyCategoryCodeSequence: 0x0070031f,
    GraphicLayerRecommendedDisplayCIELabValue: 0x00700401,
    BlendingSequence: 0x00700402,
    RelativeOpacity: 0x00700403,
    ReferencedSpatialRegistrationSequence: 0x00700404,
    BlendingPosition: 0x00700405,
    PresentationDisplayCollectionUID: 0x00701101,
    PresentationSequenceCollectionUID: 0x00701102,
    PresentationSequencePositionIndex: 0x00701103,
    RenderedImageReferenceSequence: 0x00701104,
    VolumetricPresentationStateInputSequence: 0x00701201,
    PresentationInputType: 0x00701202,
    InputSequencePositionIndex: 0x00701203,
    Crop: 0x00701204,
    CroppingSpecificationIndex: 0x00701205,
    CompositingMethod: 0x00701206, // retired
    VolumetricPresentationInputNumber: 0x00701207,
    ImageVolumeGeometry: 0x00701208,
    VolumetricPresentationInputSetUID: 0x00701209,
    VolumetricPresentationInputSetSequence: 0x0070120a,
    GlobalCrop: 0x0070120b,
    GlobalCroppingSpecificationIndex: 0x0070120c,
    RenderingMethod: 0x0070120d,
    VolumeCroppingSequence: 0x00701301,
    VolumeCroppingMethod: 0x00701302,
    BoundingBoxCrop: 0x00701303,
    ObliqueCroppingPlaneSequence: 0x00701304,
    Plane: 0x00701305,
    PlaneNormal: 0x00701306,
    CroppingSpecificationNumber: 0x00701309,
    MultiPlanarReconstructionStyle: 0x00701501,
    MPRThicknessType: 0x00701502,
    MPRSlabThickness: 0x00701503,
    MPRTopLeftHandCorner: 0x00701505,
    MPRViewWidthDirection: 0x00701507,
    MPRViewWidth: 0x00701508,
    NumberOfVolumetricCurvePoints: 0x0070150c,
    VolumetricCurvePoints: 0x0070150d,
    MPRViewHeightDirection: 0x00701511,
    MPRViewHeight: 0x00701512,
    RenderProjection: 0x00701602,
    ViewpointPosition: 0x00701603,
    ViewpointLookAtPoint: 0x00701604,
    ViewpointUpDirection: 0x00701605,
    RenderFieldOfView: 0x00701606,
    SamplingStepSize: 0x00701607,
    ShadingStyle: 0x00701701,
    AmbientReflectionIntensity: 0x00701702,
    LightDirection: 0x00701703,
    DiffuseReflectionIntensity: 0x00701704,
    SpecularReflectionIntensity: 0x00701705,
    Shininess: 0x00701706,
    PresentationStateClassificationComponentSequence: 0x00701801,
    ComponentType: 0x00701802,
    ComponentInputSequence: 0x00701803,
    VolumetricPresentationInputIndex: 0x00701804,
    PresentationStateCompositorComponentSequence: 0x00701805,
    WeightingTransferFunctionSequence: 0x00701806,
    WeightingLookupTableDescriptor: 0x00701807,
    WeightingLookupTableData: 0x00701808,
    VolumetricAnnotationSequence: 0x00701901,
    ReferencedStructuredContextSequence: 0x00701903,
    ReferencedContentItem: 0x00701904,
    VolumetricPresentationInputAnnotationSequence: 0x00701905,
    AnnotationClipping: 0x00701907,
    PresentationAnimationStyle: 0x00701a01,
    RecommendedAnimationRate: 0x00701a03,
    AnimationCurveSequence: 0x00701a04,
    AnimationStepSize: 0x00701a05,
    SwivelRange: 0x00701a06,
    VolumetricCurveUpDirections: 0x00701a07,
    VolumeStreamSequence: 0x00701a08,
    RGBATransferFunctionDescription: 0x00701a09,
    AdvancedBlendingSequence: 0x00701b01,
    BlendingInputNumber: 0x00701b02,
    BlendingDisplayInputSequence: 0x00701b03,
    BlendingDisplaySequence: 0x00701b04,
    BlendingMode: 0x00701b06,
    TimeSeriesBlending: 0x00701b07,
    GeometryForDisplay: 0x00701b08,
    ThresholdSequence: 0x00701b11,
    ThresholdValueSequence: 0x00701b12,
    ThresholdType: 0x00701b13,
    ThresholdValue: 0x00701b14,
    HangingProtocolName: 0x00720002,
    HangingProtocolDescription: 0x00720004,
    HangingProtocolLevel: 0x00720006,
    HangingProtocolCreator: 0x00720008,
    HangingProtocolCreationDateTime: 0x0072000a,
    HangingProtocolDefinitionSequence: 0x0072000c,
    HangingProtocolUserIdentificationCodeSequence: 0x0072000e,
    HangingProtocolUserGroupName: 0x00720010,
    SourceHangingProtocolSequence: 0x00720012,
    NumberOfPriorsReferenced: 0x00720014,
    ImageSetsSequence: 0x00720020,
    ImageSetSelectorSequence: 0x00720022,
    ImageSetSelectorUsageFlag: 0x00720024,
    SelectorAttribute: 0x00720026,
    SelectorValueNumber: 0x00720028,
    TimeBasedImageSetsSequence: 0x00720030,
    ImageSetNumber: 0x00720032,
    ImageSetSelectorCategory: 0x00720034,
    RelativeTime: 0x00720038,
    RelativeTimeUnits: 0x0072003a,
    AbstractPriorValue: 0x0072003c,
    AbstractPriorCodeSequence: 0x0072003e,
    ImageSetLabel: 0x00720040,
    SelectorAttributeVR: 0x00720050,
    SelectorSequencePointer: 0x00720052,
    SelectorSequencePointerPrivateCreator: 0x00720054,
    SelectorAttributePrivateCreator: 0x00720056,
    SelectorAEValue: 0x0072005e,
    SelectorASValue: 0x0072005f,
    SelectorATValue: 0x00720060,
    SelectorDAValue: 0x00720061,
    SelectorCSValue: 0x00720062,
    SelectorDTValue: 0x00720063,
    SelectorISValue: 0x00720064,
    SelectorOBValue: 0x00720065,
    SelectorLOValue: 0x00720066,
    SelectorOFValue: 0x00720067,
    SelectorLTValue: 0x00720068,
    SelectorOWValue: 0x00720069,
    SelectorPNValue: 0x0072006a,
    SelectorTMValue: 0x0072006b,
    SelectorSHValue: 0x0072006c,
    SelectorUNValue: 0x0072006d,
    SelectorSTValue: 0x0072006e,
    SelectorUCValue: 0x0072006f,
    SelectorUTValue: 0x00720070,
    SelectorURValue: 0x00720071,
    SelectorDSValue: 0x00720072,
    SelectorODValue: 0x00720073,
    SelectorFDValue: 0x00720074,
    SelectorOLValue: 0x00720075,
    SelectorFLValue: 0x00720076,
    SelectorULValue: 0x00720078,
    SelectorUSValue: 0x0072007a,
    SelectorSLValue: 0x0072007c,
    SelectorSSValue: 0x0072007e,
    SelectorUIValue: 0x0072007f,
    SelectorCodeSequenceValue: 0x00720080,
    NumberOfScreens: 0x00720100,
    NominalScreenDefinitionSequence: 0x00720102,
    NumberOfVerticalPixels: 0x00720104,
    NumberOfHorizontalPixels: 0x00720106,
    DisplayEnvironmentSpatialPosition: 0x00720108,
    ScreenMinimumGrayscaleBitDepth: 0x0072010a,
    ScreenMinimumColorBitDepth: 0x0072010c,
    ApplicationMaximumRepaintTime: 0x0072010e,
    DisplaySetsSequence: 0x00720200,
    DisplaySetNumber: 0x00720202,
    DisplaySetLabel: 0x00720203,
    DisplaySetPresentationGroup: 0x00720204,
    DisplaySetPresentationGroupDescription: 0x00720206,
    PartialDataDisplayHandling: 0x00720208,
    SynchronizedScrollingSequence: 0x00720210,
    DisplaySetScrollingGroup: 0x00720212,
    NavigationIndicatorSequence: 0x00720214,
    NavigationDisplaySet: 0x00720216,
    ReferenceDisplaySets: 0x00720218,
    ImageBoxesSequence: 0x00720300,
    ImageBoxNumber: 0x00720302,
    ImageBoxLayoutType: 0x00720304,
    ImageBoxTileHorizontalDimension: 0x00720306,
    ImageBoxTileVerticalDimension: 0x00720308,
    ImageBoxScrollDirection: 0x00720310,
    ImageBoxSmallScrollType: 0x00720312,
    ImageBoxSmallScrollAmount: 0x00720314,
    ImageBoxLargeScrollType: 0x00720316,
    ImageBoxLargeScrollAmount: 0x00720318,
    ImageBoxOverlapPriority: 0x00720320,
    CineRelativeToRealTime: 0x00720330,
    FilterOperationsSequence: 0x00720400,
    FilterByCategory: 0x00720402,
    FilterByAttributePresence: 0x00720404,
    FilterByOperator: 0x00720406,
    StructuredDisplayBackgroundCIELabValue: 0x00720420,
    EmptyImageBoxCIELabValue: 0x00720421,
    StructuredDisplayImageBoxSequence: 0x00720422,
    StructuredDisplayTextBoxSequence: 0x00720424,
    ReferencedFirstFrameSequence: 0x00720427,
    ImageBoxSynchronizationSequence: 0x00720430,
    SynchronizedImageBoxList: 0x00720432,
    TypeOfSynchronization: 0x00720434,
    BlendingOperationType: 0x00720500,
    ReformattingOperationType: 0x00720510,
    ReformattingThickness: 0x00720512,
    ReformattingInterval: 0x00720514,
    ReformattingOperationInitialViewDirection: 0x00720516,
    ThreeDRenderingType: 0x00720520,
    SortingOperationsSequence: 0x00720600,
    SortByCategory: 0x00720602,
    SortingDirection: 0x00720604,
    DisplaySetPatientOrientation: 0x00720700,
    VOIType: 0x00720702,
    PseudoColorType: 0x00720704,
    PseudoColorPaletteInstanceReferenceSequence: 0x00720705,
    ShowGrayscaleInverted: 0x00720706,
    ShowImageTrueSizeFlag: 0x00720710,
    ShowGraphicAnnotationFlag: 0x00720712,
    ShowPatientDemographicsFlag: 0x00720714,
    ShowAcquisitionTechniquesFlag: 0x00720716,
    DisplaySetHorizontalJustification: 0x00720717,
    DisplaySetVerticalJustification: 0x00720718,
    ContinuationStartMeterset: 0x00740120,
    ContinuationEndMeterset: 0x00740121,
    ProcedureStepState: 0x00741000,
    ProcedureStepProgressInformationSequence: 0x00741002,
    ProcedureStepProgress: 0x00741004,
    ProcedureStepProgressDescription: 0x00741006,
    ProcedureStepProgressParametersSequence: 0x00741007,
    ProcedureStepCommunicationsURISequence: 0x00741008,
    ContactURI: 0x0074100a,
    ContactDisplayName: 0x0074100c,
    ProcedureStepDiscontinuationReasonCodeSequence: 0x0074100e,
    BeamTaskSequence: 0x00741020,
    BeamTaskType: 0x00741022,
    BeamOrderIndexTrial: 0x00741024, // retired
    AutosequenceFlag: 0x00741025,
    TableTopVerticalAdjustedPosition: 0x00741026,
    TableTopLongitudinalAdjustedPosition: 0x00741027,
    TableTopLateralAdjustedPosition: 0x00741028,
    PatientSupportAdjustedAngle: 0x0074102a,
    TableTopEccentricAdjustedAngle: 0x0074102b,
    TableTopPitchAdjustedAngle: 0x0074102c,
    TableTopRollAdjustedAngle: 0x0074102d,
    DeliveryVerificationImageSequence: 0x00741030,
    VerificationImageTiming: 0x00741032,
    DoubleExposureFlag: 0x00741034,
    DoubleExposureOrdering: 0x00741036,
    DoubleExposureMetersetTrial: 0x00741038, // retired
    DoubleExposureFieldDeltaTrial: 0x0074103a, // retired
    RelatedReferenceRTImageSequence: 0x00741040,
    GeneralMachineVerificationSequence: 0x00741042,
    ConventionalMachineVerificationSequence: 0x00741044,
    IonMachineVerificationSequence: 0x00741046,
    FailedAttributesSequence: 0x00741048,
    OverriddenAttributesSequence: 0x0074104a,
    ConventionalControlPointVerificationSequence: 0x0074104c,
    IonControlPointVerificationSequence: 0x0074104e,
    AttributeOccurrenceSequence: 0x00741050,
    AttributeOccurrencePointer: 0x00741052,
    AttributeItemSelector: 0x00741054,
    AttributeOccurrencePrivateCreator: 0x00741056,
    SelectorSequencePointerItems: 0x00741057,
    ScheduledProcedureStepPriority: 0x00741200,
    WorklistLabel: 0x00741202,
    ProcedureStepLabel: 0x00741204,
    ScheduledProcessingParametersSequence: 0x00741210,
    PerformedProcessingParametersSequence: 0x00741212,
    UnifiedProcedureStepPerformedProcedureSequence: 0x00741216,
    RelatedProcedureStepSequence: 0x00741220, // retired
    ProcedureStepRelationshipType: 0x00741222, // retired
    ReplacedProcedureStepSequence: 0x00741224,
    DeletionLock: 0x00741230,
    ReceivingAE: 0x00741234,
    RequestingAE: 0x00741236,
    ReasonForCancellation: 0x00741238,
    SCPStatus: 0x00741242,
    SubscriptionListStatus: 0x00741244,
    UnifiedProcedureStepListStatus: 0x00741246,
    BeamOrderIndex: 0x00741324,
    DoubleExposureMeterset: 0x00741338,
    DoubleExposureFieldDelta: 0x0074133a,
    BrachyTaskSequence: 0x00741401,
    ContinuationStartTotalReferenceAirKerma: 0x00741402,
    ContinuationEndTotalReferenceAirKerma: 0x00741403,
    ContinuationPulseNumber: 0x00741404,
    ChannelDeliveryOrderSequence: 0x00741405,
    ReferencedChannelNumber: 0x00741406,
    StartCumulativeTimeWeight: 0x00741407,
    EndCumulativeTimeWeight: 0x00741408,
    OmittedChannelSequence: 0x00741409,
    ReasonForChannelOmission: 0x0074140a,
    ReasonForChannelOmissionDescription: 0x0074140b,
    ChannelDeliveryOrderIndex: 0x0074140c,
    ChannelDeliveryContinuationSequence: 0x0074140d,
    OmittedApplicationSetupSequence: 0x0074140e,
    ImplantAssemblyTemplateName: 0x00760001,
    ImplantAssemblyTemplateIssuer: 0x00760003,
    ImplantAssemblyTemplateVersion: 0x00760006,
    ReplacedImplantAssemblyTemplateSequence: 0x00760008,
    ImplantAssemblyTemplateType: 0x0076000a,
    OriginalImplantAssemblyTemplateSequence: 0x0076000c,
    DerivationImplantAssemblyTemplateSequence: 0x0076000e,
    ImplantAssemblyTemplateTargetAnatomySequence: 0x00760010,
    ProcedureTypeCodeSequence: 0x00760020,
    SurgicalTechnique: 0x00760030,
    ComponentTypesSequence: 0x00760032,
    ComponentTypeCodeSequence: 0x00760034,
    ExclusiveComponentType: 0x00760036,
    MandatoryComponentType: 0x00760038,
    ComponentSequence: 0x00760040,
    ComponentID: 0x00760055,
    ComponentAssemblySequence: 0x00760060,
    Component1ReferencedID: 0x00760070,
    Component1ReferencedMatingFeatureSetID: 0x00760080,
    Component1ReferencedMatingFeatureID: 0x00760090,
    Component2ReferencedID: 0x007600a0,
    Component2ReferencedMatingFeatureSetID: 0x007600b0,
    Component2ReferencedMatingFeatureID: 0x007600c0,
    ImplantTemplateGroupName: 0x00780001,
    ImplantTemplateGroupDescription: 0x00780010,
    ImplantTemplateGroupIssuer: 0x00780020,
    ImplantTemplateGroupVersion: 0x00780024,
    ReplacedImplantTemplateGroupSequence: 0x00780026,
    ImplantTemplateGroupTargetAnatomySequence: 0x00780028,
    ImplantTemplateGroupMembersSequence: 0x0078002a,
    ImplantTemplateGroupMemberID: 0x0078002e,
    ThreeDImplantTemplateGroupMemberMatchingPoint: 0x00780050,
    ThreeDImplantTemplateGroupMemberMatchingAxes: 0x00780060,
    ImplantTemplateGroupMemberMatching2DCoordinatesSequence: 0x00780070,
    TwoDImplantTemplateGroupMemberMatchingPoint: 0x00780090,
    TwoDImplantTemplateGroupMemberMatchingAxes: 0x007800a0,
    ImplantTemplateGroupVariationDimensionSequence: 0x007800b0,
    ImplantTemplateGroupVariationDimensionName: 0x007800b2,
    ImplantTemplateGroupVariationDimensionRankSequence: 0x007800b4,
    ReferencedImplantTemplateGroupMemberID: 0x007800b6,
    ImplantTemplateGroupVariationDimensionRank: 0x007800b8,
    SurfaceScanAcquisitionTypeCodeSequence: 0x00800001,
    SurfaceScanModeCodeSequence: 0x00800002,
    RegistrationMethodCodeSequence: 0x00800003,
    ShotDurationTime: 0x00800004,
    ShotOffsetTime: 0x00800005,
    SurfacePointPresentationValueData: 0x00800006,
    SurfacePointColorCIELabValueData: 0x00800007,
    UVMappingSequence: 0x00800008,
    TextureLabel: 0x00800009,
    UValueData: 0x00800010,
    VValueData: 0x00800011,
    ReferencedTextureSequence: 0x00800012,
    ReferencedSurfaceDataSequence: 0x00800013,
    AssessmentSummary: 0x00820001,
    AssessmentSummaryDescription: 0x00820003,
    AssessedSOPInstanceSequence: 0x00820004,
    ReferencedComparisonSOPInstanceSequence: 0x00820005,
    NumberOfAssessmentObservations: 0x00820006,
    AssessmentObservationsSequence: 0x00820007,
    ObservationSignificance: 0x00820008,
    ObservationDescription: 0x0082000a,
    StructuredConstraintObservationSequence: 0x0082000c,
    AssessedAttributeValueSequence: 0x00820010,
    AssessmentSetID: 0x00820016,
    AssessmentRequesterSequence: 0x00820017,
    SelectorAttributeName: 0x00820018,
    SelectorAttributeKeyword: 0x00820019,
    AssessmentTypeCodeSequence: 0x00820021,
    ObservationBasisCodeSequence: 0x00820022,
    AssessmentLabel: 0x00820023,
    ConstraintType: 0x00820032,
    SpecificationSelectionGuidance: 0x00820033,
    ConstraintValueSequence: 0x00820034,
    RecommendedDefaultValueSequence: 0x00820035,
    ConstraintViolationSignificance: 0x00820036,
    ConstraintViolationCondition: 0x00820037,
    ModifiableConstraintFlag: 0x00820038,
    StorageMediaFileSetID: 0x00880130,
    StorageMediaFileSetUID: 0x00880140,
    IconImageSequence: 0x00880200,
    TopicTitle: 0x00880904, // retired
    TopicSubject: 0x00880906, // retired
    TopicAuthor: 0x00880910, // retired
    TopicKeywords: 0x00880912, // retired
    SOPInstanceStatus: 0x01000410,
    SOPAuthorizationDateTime: 0x01000420,
    SOPAuthorizationComment: 0x01000424,
    AuthorizationEquipmentCertificationNumber: 0x01000426,
    MACIDNumber: 0x04000005,
    MACCalculationTransferSyntaxUID: 0x04000010,
    MACAlgorithm: 0x04000015,
    DataElementsSigned: 0x04000020,
    DigitalSignatureUID: 0x04000100,
    DigitalSignatureDateTime: 0x04000105,
    CertificateType: 0x04000110,
    CertificateOfSigner: 0x04000115,
    Signature: 0x04000120,
    CertifiedTimestampType: 0x04000305,
    CertifiedTimestamp: 0x04000310,
    DigitalSignaturePurposeCodeSequence: 0x04000401,
    ReferencedDigitalSignatureSequence: 0x04000402,
    ReferencedSOPInstanceMACSequence: 0x04000403,
    MAC: 0x04000404,
    EncryptedAttributesSequence: 0x04000500,
    EncryptedContentTransferSyntaxUID: 0x04000510,
    EncryptedContent: 0x04000520,
    ModifiedAttributesSequence: 0x04000550,
    OriginalAttributesSequence: 0x04000561,
    AttributeModificationDateTime: 0x04000562,
    ModifyingSystem: 0x04000563,
    SourceOfPreviousValues: 0x04000564,
    ReasonForTheAttributeModification: 0x04000565,
    EscapeTriplet: 0x10000000, // retired
    RunLengthTriplet: 0x10000001, // retired
    HuffmanTableSize: 0x10000002, // retired
    HuffmanTableTriplet: 0x10000003, // retired
    ShiftTableSize: 0x10000004, // retired
    ShiftTableTriplet: 0x10000005, // retired
    ZonalMap: 0x10100000, // retired
    NumberOfCopies: 0x20000010,
    PrinterConfigurationSequence: 0x2000001e,
    PrintPriority: 0x20000020,
    MediumType: 0x20000030,
    FilmDestination: 0x20000040,
    FilmSessionLabel: 0x20000050,
    MemoryAllocation: 0x20000060,
    MaximumMemoryAllocation: 0x20000061,
    ColorImagePrintingFlag: 0x20000062, // retired
    CollationFlag: 0x20000063, // retired
    AnnotationFlag: 0x20000065, // retired
    ImageOverlayFlag: 0x20000067, // retired
    PresentationLUTFlag: 0x20000069, // retired
    ImageBoxPresentationLUTFlag: 0x2000006a, // retired
    MemoryBitDepth: 0x200000a0,
    PrintingBitDepth: 0x200000a1,
    MediaInstalledSequence: 0x200000a2,
    OtherMediaAvailableSequence: 0x200000a4,
    SupportedImageDisplayFormatsSequence: 0x200000a8,
    ReferencedFilmBoxSequence: 0x20000500,
    ReferencedStoredPrintSequence: 0x20000510, // retired
    ImageDisplayFormat: 0x20100010,
    AnnotationDisplayFormatID: 0x20100030,
    FilmOrientation: 0x20100040,
    FilmSizeID: 0x20100050,
    PrinterResolutionID: 0x20100052,
    DefaultPrinterResolutionID: 0x20100054,
    MagnificationType: 0x20100060,
    SmoothingType: 0x20100080,
    DefaultMagnificationType: 0x201000a6,
    OtherMagnificationTypesAvailable: 0x201000a7,
    DefaultSmoothingType: 0x201000a8,
    OtherSmoothingTypesAvailable: 0x201000a9,
    BorderDensity: 0x20100100,
    EmptyImageDensity: 0x20100110,
    MinDensity: 0x20100120,
    MaxDensity: 0x20100130,
    Trim: 0x20100140,
    ConfigurationInformation: 0x20100150,
    ConfigurationInformationDescription: 0x20100152,
    MaximumCollatedFilms: 0x20100154,
    Illumination: 0x2010015e,
    ReflectedAmbientLight: 0x20100160,
    PrinterPixelSpacing: 0x20100376,
    ReferencedFilmSessionSequence: 0x20100500,
    ReferencedImageBoxSequence: 0x20100510,
    ReferencedBasicAnnotationBoxSequence: 0x20100520,
    ImageBoxPosition: 0x20200010,
    Polarity: 0x20200020,
    RequestedImageSize: 0x20200030,
    RequestedDecimateCropBehavior: 0x20200040,
    RequestedResolutionID: 0x20200050,
    RequestedImageSizeFlag: 0x202000a0,
    DecimateCropResult: 0x202000a2,
    BasicGrayscaleImageSequence: 0x20200110,
    BasicColorImageSequence: 0x20200111,
    ReferencedImageOverlayBoxSequence: 0x20200130, // retired
    ReferencedVOILUTBoxSequence: 0x20200140, // retired
    AnnotationPosition: 0x20300010,
    TextString: 0x20300020,
    ReferencedOverlayPlaneSequence: 0x20400010, // retired
    ReferencedOverlayPlaneGroups: 0x20400011, // retired
    OverlayPixelDataSequence: 0x20400020, // retired
    OverlayMagnificationType: 0x20400060, // retired
    OverlaySmoothingType: 0x20400070, // retired
    OverlayOrImageMagnification: 0x20400072, // retired
    MagnifyToNumberOfColumns: 0x20400074, // retired
    OverlayForegroundDensity: 0x20400080, // retired
    OverlayBackgroundDensity: 0x20400082, // retired
    OverlayMode: 0x20400090, // retired
    ThresholdDensity: 0x20400100, // retired
    ReferencedImageBoxSequenceRetired: 0x20400500, // retired
    PresentationLUTSequence: 0x20500010,
    PresentationLUTShape: 0x20500020,
    ReferencedPresentationLUTSequence: 0x20500500,
    PrintJobID: 0x21000010, // retired
    ExecutionStatus: 0x21000020,
    ExecutionStatusInfo: 0x21000030,
    CreationDate: 0x21000040,
    CreationTime: 0x21000050,
    Originator: 0x21000070,
    DestinationAE: 0x21000140,
    OwnerID: 0x21000160,
    NumberOfFilms: 0x21000170,
    ReferencedPrintJobSequencePullStoredPrint: 0x21000500, // retired
    PrinterStatus: 0x21100010,
    PrinterStatusInfo: 0x21100020,
    PrinterName: 0x21100030,
    PrintQueueID: 0x21100099, // retired
    QueueStatus: 0x21200010, // retired
    PrintJobDescriptionSequence: 0x21200050, // retired
    ReferencedPrintJobSequence: 0x21200070, // retired
    PrintManagementCapabilitiesSequence: 0x21300010, // retired
    PrinterCharacteristicsSequence: 0x21300015, // retired
    FilmBoxContentSequence: 0x21300030, // retired
    ImageBoxContentSequence: 0x21300040, // retired
    AnnotationContentSequence: 0x21300050, // retired
    ImageOverlayBoxContentSequence: 0x21300060, // retired
    PresentationLUTContentSequence: 0x21300080, // retired
    ProposedStudySequence: 0x213000a0, // retired
    OriginalImageSequence: 0x213000c0, // retired
    LabelUsingInformationExtractedFromInstances: 0x22000001,
    LabelText: 0x22000002,
    LabelStyleSelection: 0x22000003,
    MediaDisposition: 0x22000004,
    BarcodeValue: 0x22000005,
    BarcodeSymbology: 0x22000006,
    AllowMediaSplitting: 0x22000007,
    IncludeNonDICOMObjects: 0x22000008,
    IncludeDisplayApplication: 0x22000009,
    PreserveCompositeInstancesAfterMediaCreation: 0x2200000a,
    TotalNumberOfPiecesOfMediaCreated: 0x2200000b,
    RequestedMediaApplicationProfile: 0x2200000c,
    ReferencedStorageMediaSequence: 0x2200000d,
    FailureAttributes: 0x2200000e,
    AllowLossyCompression: 0x2200000f,
    RequestPriority: 0x22000020,
    RTImageLabel: 0x30020002,
    RTImageName: 0x30020003,
    RTImageDescription: 0x30020004,
    ReportedValuesOrigin: 0x3002000a,
    RTImagePlane: 0x3002000c,
    XRayImageReceptorTranslation: 0x3002000d,
    XRayImageReceptorAngle: 0x3002000e,
    RTImageOrientation: 0x30020010,
    ImagePlanePixelSpacing: 0x30020011,
    RTImagePosition: 0x30020012,
    RadiationMachineName: 0x30020020,
    RadiationMachineSAD: 0x30020022,
    RadiationMachineSSD: 0x30020024,
    RTImageSID: 0x30020026,
    SourceToReferenceObjectDistance: 0x30020028,
    FractionNumber: 0x30020029,
    ExposureSequence: 0x30020030,
    MetersetExposure: 0x30020032,
    DiaphragmPosition: 0x30020034,
    FluenceMapSequence: 0x30020040,
    FluenceDataSource: 0x30020041,
    FluenceDataScale: 0x30020042,
    PrimaryFluenceModeSequence: 0x30020050,
    FluenceMode: 0x30020051,
    FluenceModeID: 0x30020052,
    DVHType: 0x30040001,
    DoseUnits: 0x30040002,
    DoseType: 0x30040004,
    SpatialTransformOfDose: 0x30040005,
    DoseComment: 0x30040006,
    NormalizationPoint: 0x30040008,
    DoseSummationType: 0x3004000a,
    GridFrameOffsetVector: 0x3004000c,
    DoseGridScaling: 0x3004000e,
    RTDoseROISequence: 0x30040010,
    DoseValue: 0x30040012,
    TissueHeterogeneityCorrection: 0x30040014,
    DVHNormalizationPoint: 0x30040040,
    DVHNormalizationDoseValue: 0x30040042,
    DVHSequence: 0x30040050,
    DVHDoseScaling: 0x30040052,
    DVHVolumeUnits: 0x30040054,
    DVHNumberOfBins: 0x30040056,
    DVHData: 0x30040058,
    DVHReferencedROISequence: 0x30040060,
    DVHROIContributionType: 0x30040062,
    DVHMinimumDose: 0x30040070,
    DVHMaximumDose: 0x30040072,
    DVHMeanDose: 0x30040074,
    StructureSetLabel: 0x30060002,
    StructureSetName: 0x30060004,
    StructureSetDescription: 0x30060006,
    StructureSetDate: 0x30060008,
    StructureSetTime: 0x30060009,
    ReferencedFrameOfReferenceSequence: 0x30060010,
    RTReferencedStudySequence: 0x30060012,
    RTReferencedSeriesSequence: 0x30060014,
    ContourImageSequence: 0x30060016,
    PredecessorStructureSetSequence: 0x30060018,
    StructureSetROISequence: 0x30060020,
    ROINumber: 0x30060022,
    ReferencedFrameOfReferenceUID: 0x30060024,
    ROIName: 0x30060026,
    ROIDescription: 0x30060028,
    ROIDisplayColor: 0x3006002a,
    ROIVolume: 0x3006002c,
    RTRelatedROISequence: 0x30060030,
    RTROIRelationship: 0x30060033,
    ROIGenerationAlgorithm: 0x30060036,
    ROIGenerationDescription: 0x30060038,
    ROIContourSequence: 0x30060039,
    ContourSequence: 0x30060040,
    ContourGeometricType: 0x30060042,
    ContourSlabThickness: 0x30060044,
    ContourOffsetVector: 0x30060045,
    NumberOfContourPoints: 0x30060046,
    ContourNumber: 0x30060048,
    AttachedContours: 0x30060049,
    ContourData: 0x30060050,
    RTROIObservationsSequence: 0x30060080,
    ObservationNumber: 0x30060082,
    ReferencedROINumber: 0x30060084,
    ROIObservationLabel: 0x30060085,
    RTROIIdentificationCodeSequence: 0x30060086,
    ROIObservationDescription: 0x30060088,
    RelatedRTROIObservationsSequence: 0x300600a0,
    RTROIInterpretedType: 0x300600a4,
    ROIInterpreter: 0x300600a6,
    ROIPhysicalPropertiesSequence: 0x300600b0,
    ROIPhysicalProperty: 0x300600b2,
    ROIPhysicalPropertyValue: 0x300600b4,
    ROIElementalCompositionSequence: 0x300600b6,
    ROIElementalCompositionAtomicNumber: 0x300600b7,
    ROIElementalCompositionAtomicMassFraction: 0x300600b8,
    AdditionalRTROIIdentificationCodeSequence: 0x300600b9, // retired
    FrameOfReferenceRelationshipSequence: 0x300600c0, // retired
    RelatedFrameOfReferenceUID: 0x300600c2, // retired
    FrameOfReferenceTransformationType: 0x300600c4, // retired
    FrameOfReferenceTransformationMatrix: 0x300600c6,
    FrameOfReferenceTransformationComment: 0x300600c8,
    MeasuredDoseReferenceSequence: 0x30080010,
    MeasuredDoseDescription: 0x30080012,
    MeasuredDoseType: 0x30080014,
    MeasuredDoseValue: 0x30080016,
    TreatmentSessionBeamSequence: 0x30080020,
    TreatmentSessionIonBeamSequence: 0x30080021,
    CurrentFractionNumber: 0x30080022,
    TreatmentControlPointDate: 0x30080024,
    TreatmentControlPointTime: 0x30080025,
    TreatmentTerminationStatus: 0x3008002a,
    TreatmentTerminationCode: 0x3008002b,
    TreatmentVerificationStatus: 0x3008002c,
    ReferencedTreatmentRecordSequence: 0x30080030,
    SpecifiedPrimaryMeterset: 0x30080032,
    SpecifiedSecondaryMeterset: 0x30080033,
    DeliveredPrimaryMeterset: 0x30080036,
    DeliveredSecondaryMeterset: 0x30080037,
    SpecifiedTreatmentTime: 0x3008003a,
    DeliveredTreatmentTime: 0x3008003b,
    ControlPointDeliverySequence: 0x30080040,
    IonControlPointDeliverySequence: 0x30080041,
    SpecifiedMeterset: 0x30080042,
    DeliveredMeterset: 0x30080044,
    MetersetRateSet: 0x30080045,
    MetersetRateDelivered: 0x30080046,
    ScanSpotMetersetsDelivered: 0x30080047,
    DoseRateDelivered: 0x30080048,
    TreatmentSummaryCalculatedDoseReferenceSequence: 0x30080050,
    CumulativeDoseToDoseReference: 0x30080052,
    FirstTreatmentDate: 0x30080054,
    MostRecentTreatmentDate: 0x30080056,
    NumberOfFractionsDelivered: 0x3008005a,
    OverrideSequence: 0x30080060,
    ParameterSequencePointer: 0x30080061,
    OverrideParameterPointer: 0x30080062,
    ParameterItemIndex: 0x30080063,
    MeasuredDoseReferenceNumber: 0x30080064,
    ParameterPointer: 0x30080065,
    OverrideReason: 0x30080066,
    ParameterValueNumber: 0x30080067,
    CorrectedParameterSequence: 0x30080068,
    CorrectionValue: 0x3008006a,
    CalculatedDoseReferenceSequence: 0x30080070,
    CalculatedDoseReferenceNumber: 0x30080072,
    CalculatedDoseReferenceDescription: 0x30080074,
    CalculatedDoseReferenceDoseValue: 0x30080076,
    StartMeterset: 0x30080078,
    EndMeterset: 0x3008007a,
    ReferencedMeasuredDoseReferenceSequence: 0x30080080,
    ReferencedMeasuredDoseReferenceNumber: 0x30080082,
    ReferencedCalculatedDoseReferenceSequence: 0x30080090,
    ReferencedCalculatedDoseReferenceNumber: 0x30080092,
    BeamLimitingDeviceLeafPairsSequence: 0x300800a0,
    RecordedWedgeSequence: 0x300800b0,
    RecordedCompensatorSequence: 0x300800c0,
    RecordedBlockSequence: 0x300800d0,
    TreatmentSummaryMeasuredDoseReferenceSequence: 0x300800e0,
    RecordedSnoutSequence: 0x300800f0,
    RecordedRangeShifterSequence: 0x300800f2,
    RecordedLateralSpreadingDeviceSequence: 0x300800f4,
    RecordedRangeModulatorSequence: 0x300800f6,
    RecordedSourceSequence: 0x30080100,
    SourceSerialNumber: 0x30080105,
    TreatmentSessionApplicationSetupSequence: 0x30080110,
    ApplicationSetupCheck: 0x30080116,
    RecordedBrachyAccessoryDeviceSequence: 0x30080120,
    ReferencedBrachyAccessoryDeviceNumber: 0x30080122,
    RecordedChannelSequence: 0x30080130,
    SpecifiedChannelTotalTime: 0x30080132,
    DeliveredChannelTotalTime: 0x30080134,
    SpecifiedNumberOfPulses: 0x30080136,
    DeliveredNumberOfPulses: 0x30080138,
    SpecifiedPulseRepetitionInterval: 0x3008013a,
    DeliveredPulseRepetitionInterval: 0x3008013c,
    RecordedSourceApplicatorSequence: 0x30080140,
    ReferencedSourceApplicatorNumber: 0x30080142,
    RecordedChannelShieldSequence: 0x30080150,
    ReferencedChannelShieldNumber: 0x30080152,
    BrachyControlPointDeliveredSequence: 0x30080160,
    SafePositionExitDate: 0x30080162,
    SafePositionExitTime: 0x30080164,
    SafePositionReturnDate: 0x30080166,
    SafePositionReturnTime: 0x30080168,
    PulseSpecificBrachyControlPointDeliveredSequence: 0x30080171,
    PulseNumber: 0x30080172,
    BrachyPulseControlPointDeliveredSequence: 0x30080173,
    CurrentTreatmentStatus: 0x30080200,
    TreatmentStatusComment: 0x30080202,
    FractionGroupSummarySequence: 0x30080220,
    ReferencedFractionNumber: 0x30080223,
    FractionGroupType: 0x30080224,
    BeamStopperPosition: 0x30080230,
    FractionStatusSummarySequence: 0x30080240,
    TreatmentDate: 0x30080250,
    TreatmentTime: 0x30080251,
    RTPlanLabel: 0x300a0002,
    RTPlanName: 0x300a0003,
    RTPlanDescription: 0x300a0004,
    RTPlanDate: 0x300a0006,
    RTPlanTime: 0x300a0007,
    TreatmentProtocols: 0x300a0009,
    PlanIntent: 0x300a000a,
    TreatmentSites: 0x300a000b,
    RTPlanGeometry: 0x300a000c,
    PrescriptionDescription: 0x300a000e,
    DoseReferenceSequence: 0x300a0010,
    DoseReferenceNumber: 0x300a0012,
    DoseReferenceUID: 0x300a0013,
    DoseReferenceStructureType: 0x300a0014,
    NominalBeamEnergyUnit: 0x300a0015,
    DoseReferenceDescription: 0x300a0016,
    DoseReferencePointCoordinates: 0x300a0018,
    NominalPriorDose: 0x300a001a,
    DoseReferenceType: 0x300a0020,
    ConstraintWeight: 0x300a0021,
    DeliveryWarningDose: 0x300a0022,
    DeliveryMaximumDose: 0x300a0023,
    TargetMinimumDose: 0x300a0025,
    TargetPrescriptionDose: 0x300a0026,
    TargetMaximumDose: 0x300a0027,
    TargetUnderdoseVolumeFraction: 0x300a0028,
    OrganAtRiskFullVolumeDose: 0x300a002a,
    OrganAtRiskLimitDose: 0x300a002b,
    OrganAtRiskMaximumDose: 0x300a002c,
    OrganAtRiskOverdoseVolumeFraction: 0x300a002d,
    ToleranceTableSequence: 0x300a0040,
    ToleranceTableNumber: 0x300a0042,
    ToleranceTableLabel: 0x300a0043,
    GantryAngleTolerance: 0x300a0044,
    BeamLimitingDeviceAngleTolerance: 0x300a0046,
    BeamLimitingDeviceToleranceSequence: 0x300a0048,
    BeamLimitingDevicePositionTolerance: 0x300a004a,
    SnoutPositionTolerance: 0x300a004b,
    PatientSupportAngleTolerance: 0x300a004c,
    TableTopEccentricAngleTolerance: 0x300a004e,
    TableTopPitchAngleTolerance: 0x300a004f,
    TableTopRollAngleTolerance: 0x300a0050,
    TableTopVerticalPositionTolerance: 0x300a0051,
    TableTopLongitudinalPositionTolerance: 0x300a0052,
    TableTopLateralPositionTolerance: 0x300a0053,
    RTPlanRelationship: 0x300a0055,
    FractionGroupSequence: 0x300a0070,
    FractionGroupNumber: 0x300a0071,
    FractionGroupDescription: 0x300a0072,
    NumberOfFractionsPlanned: 0x300a0078,
    NumberOfFractionPatternDigitsPerDay: 0x300a0079,
    RepeatFractionCycleLength: 0x300a007a,
    FractionPattern: 0x300a007b,
    NumberOfBeams: 0x300a0080,
    BeamDoseSpecificationPoint: 0x300a0082,
    ReferencedDoseReferenceUID: 0x300a0083,
    BeamDose: 0x300a0084,
    BeamMeterset: 0x300a0086,
    BeamDosePointDepth: 0x300a0088,
    BeamDosePointEquivalentDepth: 0x300a0089,
    BeamDosePointSSD: 0x300a008a,
    BeamDoseMeaning: 0x300a008b,
    BeamDoseVerificationControlPointSequence: 0x300a008c,
    AverageBeamDosePointDepth: 0x300a008d, // retired
    AverageBeamDosePointEquivalentDepth: 0x300a008e, // retired
    AverageBeamDosePointSSD: 0x300a008f, // retired
    BeamDoseType: 0x300a0090,
    AlternateBeamDose: 0x300a0091,
    AlternateBeamDoseType: 0x300a0092,
    DepthValueAveragingFlag: 0x300a0093,
    NumberOfBrachyApplicationSetups: 0x300a00a0,
    BrachyApplicationSetupDoseSpecificationPoint: 0x300a00a2,
    BrachyApplicationSetupDose: 0x300a00a4,
    BeamSequence: 0x300a00b0,
    TreatmentMachineName: 0x300a00b2,
    PrimaryDosimeterUnit: 0x300a00b3,
    SourceAxisDistance: 0x300a00b4,
    BeamLimitingDeviceSequence: 0x300a00b6,
    RTBeamLimitingDeviceType: 0x300a00b8,
    SourceToBeamLimitingDeviceDistance: 0x300a00ba,
    IsocenterToBeamLimitingDeviceDistance: 0x300a00bb,
    NumberOfLeafJawPairs: 0x300a00bc,
    LeafPositionBoundaries: 0x300a00be,
    BeamNumber: 0x300a00c0,
    BeamName: 0x300a00c2,
    BeamDescription: 0x300a00c3,
    BeamType: 0x300a00c4,
    BeamDeliveryDurationLimit: 0x300a00c5,
    RadiationType: 0x300a00c6,
    HighDoseTechniqueType: 0x300a00c7,
    ReferenceImageNumber: 0x300a00c8,
    PlannedVerificationImageSequence: 0x300a00ca,
    ImagingDeviceSpecificAcquisitionParameters: 0x300a00cc,
    TreatmentDeliveryType: 0x300a00ce,
    NumberOfWedges: 0x300a00d0,
    WedgeSequence: 0x300a00d1,
    WedgeNumber: 0x300a00d2,
    WedgeType: 0x300a00d3,
    WedgeID: 0x300a00d4,
    WedgeAngle: 0x300a00d5,
    WedgeFactor: 0x300a00d6,
    TotalWedgeTrayWaterEquivalentThickness: 0x300a00d7,
    WedgeOrientation: 0x300a00d8,
    IsocenterToWedgeTrayDistance: 0x300a00d9,
    SourceToWedgeTrayDistance: 0x300a00da,
    WedgeThinEdgePosition: 0x300a00db,
    BolusID: 0x300a00dc,
    BolusDescription: 0x300a00dd,
    EffectiveWedgeAngle: 0x300a00de,
    NumberOfCompensators: 0x300a00e0,
    MaterialID: 0x300a00e1,
    TotalCompensatorTrayFactor: 0x300a00e2,
    CompensatorSequence: 0x300a00e3,
    CompensatorNumber: 0x300a00e4,
    CompensatorID: 0x300a00e5,
    SourceToCompensatorTrayDistance: 0x300a00e6,
    CompensatorRows: 0x300a00e7,
    CompensatorColumns: 0x300a00e8,
    CompensatorPixelSpacing: 0x300a00e9,
    CompensatorPosition: 0x300a00ea,
    CompensatorTransmissionData: 0x300a00eb,
    CompensatorThicknessData: 0x300a00ec,
    NumberOfBoli: 0x300a00ed,
    CompensatorType: 0x300a00ee,
    CompensatorTrayID: 0x300a00ef,
    NumberOfBlocks: 0x300a00f0,
    TotalBlockTrayFactor: 0x300a00f2,
    TotalBlockTrayWaterEquivalentThickness: 0x300a00f3,
    BlockSequence: 0x300a00f4,
    BlockTrayID: 0x300a00f5,
    SourceToBlockTrayDistance: 0x300a00f6,
    IsocenterToBlockTrayDistance: 0x300a00f7,
    BlockType: 0x300a00f8,
    AccessoryCode: 0x300a00f9,
    BlockDivergence: 0x300a00fa,
    BlockMountingPosition: 0x300a00fb,
    BlockNumber: 0x300a00fc,
    BlockName: 0x300a00fe,
    BlockThickness: 0x300a0100,
    BlockTransmission: 0x300a0102,
    BlockNumberOfPoints: 0x300a0104,
    BlockData: 0x300a0106,
    ApplicatorSequence: 0x300a0107,
    ApplicatorID: 0x300a0108,
    ApplicatorType: 0x300a0109,
    ApplicatorDescription: 0x300a010a,
    CumulativeDoseReferenceCoefficient: 0x300a010c,
    FinalCumulativeMetersetWeight: 0x300a010e,
    NumberOfControlPoints: 0x300a0110,
    ControlPointSequence: 0x300a0111,
    ControlPointIndex: 0x300a0112,
    NominalBeamEnergy: 0x300a0114,
    DoseRateSet: 0x300a0115,
    WedgePositionSequence: 0x300a0116,
    WedgePosition: 0x300a0118,
    BeamLimitingDevicePositionSequence: 0x300a011a,
    LeafJawPositions: 0x300a011c,
    GantryAngle: 0x300a011e,
    GantryRotationDirection: 0x300a011f,
    BeamLimitingDeviceAngle: 0x300a0120,
    BeamLimitingDeviceRotationDirection: 0x300a0121,
    PatientSupportAngle: 0x300a0122,
    PatientSupportRotationDirection: 0x300a0123,
    TableTopEccentricAxisDistance: 0x300a0124,
    TableTopEccentricAngle: 0x300a0125,
    TableTopEccentricRotationDirection: 0x300a0126,
    TableTopVerticalPosition: 0x300a0128,
    TableTopLongitudinalPosition: 0x300a0129,
    TableTopLateralPosition: 0x300a012a,
    IsocenterPosition: 0x300a012c,
    SurfaceEntryPoint: 0x300a012e,
    SourceToSurfaceDistance: 0x300a0130,
    AverageBeamDosePointSourceToExternalContourDistance: 0x300a0131,
    SourceToExternalContourDistance: 0x300a0132,
    ExternalContourEntryPoint: 0x300a0133,
    CumulativeMetersetWeight: 0x300a0134,
    TableTopPitchAngle: 0x300a0140,
    TableTopPitchRotationDirection: 0x300a0142,
    TableTopRollAngle: 0x300a0144,
    TableTopRollRotationDirection: 0x300a0146,
    HeadFixationAngle: 0x300a0148,
    GantryPitchAngle: 0x300a014a,
    GantryPitchRotationDirection: 0x300a014c,
    GantryPitchAngleTolerance: 0x300a014e,
    FixationEye: 0x300a0150,
    ChairHeadFramePosition: 0x300a0151,
    HeadFixationAngleTolerance: 0x300a0152,
    ChairHeadFramePositionTolerance: 0x300a0153,
    FixationLightAzimuthalAngleTolerance: 0x300a0154,
    FixationLightPolarAngleTolerance: 0x300a0155,
    PatientSetupSequence: 0x300a0180,
    PatientSetupNumber: 0x300a0182,
    PatientSetupLabel: 0x300a0183,
    PatientAdditionalPosition: 0x300a0184,
    FixationDeviceSequence: 0x300a0190,
    FixationDeviceType: 0x300a0192,
    FixationDeviceLabel: 0x300a0194,
    FixationDeviceDescription: 0x300a0196,
    FixationDevicePosition: 0x300a0198,
    FixationDevicePitchAngle: 0x300a0199,
    FixationDeviceRollAngle: 0x300a019a,
    ShieldingDeviceSequence: 0x300a01a0,
    ShieldingDeviceType: 0x300a01a2,
    ShieldingDeviceLabel: 0x300a01a4,
    ShieldingDeviceDescription: 0x300a01a6,
    ShieldingDevicePosition: 0x300a01a8,
    SetupTechnique: 0x300a01b0,
    SetupTechniqueDescription: 0x300a01b2,
    SetupDeviceSequence: 0x300a01b4,
    SetupDeviceType: 0x300a01b6,
    SetupDeviceLabel: 0x300a01b8,
    SetupDeviceDescription: 0x300a01ba,
    SetupDeviceParameter: 0x300a01bc,
    SetupReferenceDescription: 0x300a01d0,
    TableTopVerticalSetupDisplacement: 0x300a01d2,
    TableTopLongitudinalSetupDisplacement: 0x300a01d4,
    TableTopLateralSetupDisplacement: 0x300a01d6,
    BrachyTreatmentTechnique: 0x300a0200,
    BrachyTreatmentType: 0x300a0202,
    TreatmentMachineSequence: 0x300a0206,
    SourceSequence: 0x300a0210,
    SourceNumber: 0x300a0212,
    SourceType: 0x300a0214,
    SourceManufacturer: 0x300a0216,
    ActiveSourceDiameter: 0x300a0218,
    ActiveSourceLength: 0x300a021a,
    SourceModelID: 0x300a021b,
    SourceDescription: 0x300a021c,
    SourceEncapsulationNominalThickness: 0x300a0222,
    SourceEncapsulationNominalTransmission: 0x300a0224,
    SourceIsotopeName: 0x300a0226,
    SourceIsotopeHalfLife: 0x300a0228,
    SourceStrengthUnits: 0x300a0229,
    ReferenceAirKermaRate: 0x300a022a,
    SourceStrength: 0x300a022b,
    SourceStrengthReferenceDate: 0x300a022c,
    SourceStrengthReferenceTime: 0x300a022e,
    ApplicationSetupSequence: 0x300a0230,
    ApplicationSetupType: 0x300a0232,
    ApplicationSetupNumber: 0x300a0234,
    ApplicationSetupName: 0x300a0236,
    ApplicationSetupManufacturer: 0x300a0238,
    TemplateNumber: 0x300a0240,
    TemplateType: 0x300a0242,
    TemplateName: 0x300a0244,
    TotalReferenceAirKerma: 0x300a0250,
    BrachyAccessoryDeviceSequence: 0x300a0260,
    BrachyAccessoryDeviceNumber: 0x300a0262,
    BrachyAccessoryDeviceID: 0x300a0263,
    BrachyAccessoryDeviceType: 0x300a0264,
    BrachyAccessoryDeviceName: 0x300a0266,
    BrachyAccessoryDeviceNominalThickness: 0x300a026a,
    BrachyAccessoryDeviceNominalTransmission: 0x300a026c,
    ChannelEffectiveLength: 0x300a0271,
    ChannelInnerLength: 0x300a0272,
    AfterloaderChannelID: 0x300a0273,
    SourceApplicatorTipLength: 0x300a0274,
    ChannelSequence: 0x300a0280,
    ChannelNumber: 0x300a0282,
    ChannelLength: 0x300a0284,
    ChannelTotalTime: 0x300a0286,
    SourceMovementType: 0x300a0288,
    NumberOfPulses: 0x300a028a,
    PulseRepetitionInterval: 0x300a028c,
    SourceApplicatorNumber: 0x300a0290,
    SourceApplicatorID: 0x300a0291,
    SourceApplicatorType: 0x300a0292,
    SourceApplicatorName: 0x300a0294,
    SourceApplicatorLength: 0x300a0296,
    SourceApplicatorManufacturer: 0x300a0298,
    SourceApplicatorWallNominalThickness: 0x300a029c,
    SourceApplicatorWallNominalTransmission: 0x300a029e,
    SourceApplicatorStepSize: 0x300a02a0,
    TransferTubeNumber: 0x300a02a2,
    TransferTubeLength: 0x300a02a4,
    ChannelShieldSequence: 0x300a02b0,
    ChannelShieldNumber: 0x300a02b2,
    ChannelShieldID: 0x300a02b3,
    ChannelShieldName: 0x300a02b4,
    ChannelShieldNominalThickness: 0x300a02b8,
    ChannelShieldNominalTransmission: 0x300a02ba,
    FinalCumulativeTimeWeight: 0x300a02c8,
    BrachyControlPointSequence: 0x300a02d0,
    ControlPointRelativePosition: 0x300a02d2,
    ControlPoint3DPosition: 0x300a02d4,
    CumulativeTimeWeight: 0x300a02d6,
    CompensatorDivergence: 0x300a02e0,
    CompensatorMountingPosition: 0x300a02e1,
    SourceToCompensatorDistance: 0x300a02e2,
    TotalCompensatorTrayWaterEquivalentThickness: 0x300a02e3,
    IsocenterToCompensatorTrayDistance: 0x300a02e4,
    CompensatorColumnOffset: 0x300a02e5,
    IsocenterToCompensatorDistances: 0x300a02e6,
    CompensatorRelativeStoppingPowerRatio: 0x300a02e7,
    CompensatorMillingToolDiameter: 0x300a02e8,
    IonRangeCompensatorSequence: 0x300a02ea,
    CompensatorDescription: 0x300a02eb,
    RadiationMassNumber: 0x300a0302,
    RadiationAtomicNumber: 0x300a0304,
    RadiationChargeState: 0x300a0306,
    ScanMode: 0x300a0308,
    ModulatedScanModeType: 0x300a0309,
    VirtualSourceAxisDistances: 0x300a030a,
    SnoutSequence: 0x300a030c,
    SnoutPosition: 0x300a030d,
    SnoutID: 0x300a030f,
    NumberOfRangeShifters: 0x300a0312,
    RangeShifterSequence: 0x300a0314,
    RangeShifterNumber: 0x300a0316,
    RangeShifterID: 0x300a0318,
    RangeShifterType: 0x300a0320,
    RangeShifterDescription: 0x300a0322,
    NumberOfLateralSpreadingDevices: 0x300a0330,
    LateralSpreadingDeviceSequence: 0x300a0332,
    LateralSpreadingDeviceNumber: 0x300a0334,
    LateralSpreadingDeviceID: 0x300a0336,
    LateralSpreadingDeviceType: 0x300a0338,
    LateralSpreadingDeviceDescription: 0x300a033a,
    LateralSpreadingDeviceWaterEquivalentThickness: 0x300a033c,
    NumberOfRangeModulators: 0x300a0340,
    RangeModulatorSequence: 0x300a0342,
    RangeModulatorNumber: 0x300a0344,
    RangeModulatorID: 0x300a0346,
    RangeModulatorType: 0x300a0348,
    RangeModulatorDescription: 0x300a034a,
    BeamCurrentModulationID: 0x300a034c,
    PatientSupportType: 0x300a0350,
    PatientSupportID: 0x300a0352,
    PatientSupportAccessoryCode: 0x300a0354,
    TrayAccessoryCode: 0x300a0355,
    FixationLightAzimuthalAngle: 0x300a0356,
    FixationLightPolarAngle: 0x300a0358,
    MetersetRate: 0x300a035a,
    RangeShifterSettingsSequence: 0x300a0360,
    RangeShifterSetting: 0x300a0362,
    IsocenterToRangeShifterDistance: 0x300a0364,
    RangeShifterWaterEquivalentThickness: 0x300a0366,
    LateralSpreadingDeviceSettingsSequence: 0x300a0370,
    LateralSpreadingDeviceSetting: 0x300a0372,
    IsocenterToLateralSpreadingDeviceDistance: 0x300a0374,
    RangeModulatorSettingsSequence: 0x300a0380,
    RangeModulatorGatingStartValue: 0x300a0382,
    RangeModulatorGatingStopValue: 0x300a0384,
    RangeModulatorGatingStartWaterEquivalentThickness: 0x300a0386,
    RangeModulatorGatingStopWaterEquivalentThickness: 0x300a0388,
    IsocenterToRangeModulatorDistance: 0x300a038a,
    ScanSpotTimeOffset: 0x300a038f,
    ScanSpotTuneID: 0x300a0390,
    ScanSpotPrescribedIndices: 0x300a0391,
    NumberOfScanSpotPositions: 0x300a0392,
    ScanSpotReordered: 0x300a0393,
    ScanSpotPositionMap: 0x300a0394,
    ScanSpotReorderingAllowed: 0x300a0395,
    ScanSpotMetersetWeights: 0x300a0396,
    ScanningSpotSize: 0x300a0398,
    NumberOfPaintings: 0x300a039a,
    IonToleranceTableSequence: 0x300a03a0,
    IonBeamSequence: 0x300a03a2,
    IonBeamLimitingDeviceSequence: 0x300a03a4,
    IonBlockSequence: 0x300a03a6,
    IonControlPointSequence: 0x300a03a8,
    IonWedgeSequence: 0x300a03aa,
    IonWedgePositionSequence: 0x300a03ac,
    ReferencedSetupImageSequence: 0x300a0401,
    SetupImageComment: 0x300a0402,
    MotionSynchronizationSequence: 0x300a0410,
    ControlPointOrientation: 0x300a0412,
    GeneralAccessorySequence: 0x300a0420,
    GeneralAccessoryID: 0x300a0421,
    GeneralAccessoryDescription: 0x300a0422,
    GeneralAccessoryType: 0x300a0423,
    GeneralAccessoryNumber: 0x300a0424,
    SourceToGeneralAccessoryDistance: 0x300a0425,
    ApplicatorGeometrySequence: 0x300a0431,
    ApplicatorApertureShape: 0x300a0432,
    ApplicatorOpening: 0x300a0433,
    ApplicatorOpeningX: 0x300a0434,
    ApplicatorOpeningY: 0x300a0435,
    SourceToApplicatorMountingPositionDistance: 0x300a0436,
    NumberOfBlockSlabItems: 0x300a0440,
    BlockSlabSequence: 0x300a0441,
    BlockSlabThickness: 0x300a0442,
    BlockSlabNumber: 0x300a0443,
    DeviceMotionControlSequence: 0x300a0450,
    DeviceMotionExecutionMode: 0x300a0451,
    DeviceMotionObservationMode: 0x300a0452,
    DeviceMotionParameterCodeSequence: 0x300a0453,
    DistalDepthFraction: 0x300a0501,
    DistalDepth: 0x300a0502,
    NominalRangeModulationFractions: 0x300a0503,
    NominalRangeModulatedRegionDepths: 0x300a0504,
    DepthDoseParametersSequence: 0x300a0505,
    DeliveredDepthDoseParametersSequence: 0x300a0506,
    DeliveredDistalDepthFraction: 0x300a0507,
    DeliveredDistalDepth: 0x300a0508,
    DeliveredNominalRangeModulationFractions: 0x300a0509,
    DeliveredNominalRangeModulatedRegionDepths: 0x300a0510,
    DeliveredReferenceDoseDefinition: 0x300a0511,
    ReferenceDoseDefinition: 0x300a0512,
    ReferencedRTPlanSequence: 0x300c0002,
    ReferencedBeamSequence: 0x300c0004,
    ReferencedBeamNumber: 0x300c0006,
    ReferencedReferenceImageNumber: 0x300c0007,
    StartCumulativeMetersetWeight: 0x300c0008,
    EndCumulativeMetersetWeight: 0x300c0009,
    ReferencedBrachyApplicationSetupSequence: 0x300c000a,
    ReferencedBrachyApplicationSetupNumber: 0x300c000c,
    ReferencedSourceNumber: 0x300c000e,
    ReferencedFractionGroupSequence: 0x300c0020,
    ReferencedFractionGroupNumber: 0x300c0022,
    ReferencedVerificationImageSequence: 0x300c0040,
    ReferencedReferenceImageSequence: 0x300c0042,
    ReferencedDoseReferenceSequence: 0x300c0050,
    ReferencedDoseReferenceNumber: 0x300c0051,
    BrachyReferencedDoseReferenceSequence: 0x300c0055,
    ReferencedStructureSetSequence: 0x300c0060,
    ReferencedPatientSetupNumber: 0x300c006a,
    ReferencedDoseSequence: 0x300c0080,
    ReferencedToleranceTableNumber: 0x300c00a0,
    ReferencedBolusSequence: 0x300c00b0,
    ReferencedWedgeNumber: 0x300c00c0,
    ReferencedCompensatorNumber: 0x300c00d0,
    ReferencedBlockNumber: 0x300c00e0,
    ReferencedControlPointIndex: 0x300c00f0,
    ReferencedControlPointSequence: 0x300c00f2,
    ReferencedStartControlPointIndex: 0x300c00f4,
    ReferencedStopControlPointIndex: 0x300c00f6,
    ReferencedRangeShifterNumber: 0x300c0100,
    ReferencedLateralSpreadingDeviceNumber: 0x300c0102,
    ReferencedRangeModulatorNumber: 0x300c0104,
    OmittedBeamTaskSequence: 0x300c0111,
    ReasonForOmission: 0x300c0112,
    ReasonForOmissionDescription: 0x300c0113,
    ApprovalStatus: 0x300e0002,
    ReviewDate: 0x300e0004,
    ReviewTime: 0x300e0005,
    ReviewerName: 0x300e0008,
    Arbitrary: 0x40000010, // retired
    TextComments: 0x40004000, // retired
    ResultsID: 0x40080040, // retired
    ResultsIDIssuer: 0x40080042, // retired
    ReferencedInterpretationSequence: 0x40080050, // retired
    ReportProductionStatusTrial: 0x400800ff, // retired
    InterpretationRecordedDate: 0x40080100, // retired
    InterpretationRecordedTime: 0x40080101, // retired
    InterpretationRecorder: 0x40080102, // retired
    ReferenceToRecordedSound: 0x40080103, // retired
    InterpretationTranscriptionDate: 0x40080108, // retired
    InterpretationTranscriptionTime: 0x40080109, // retired
    InterpretationTranscriber: 0x4008010a, // retired
    InterpretationText: 0x4008010b, // retired
    InterpretationAuthor: 0x4008010c, // retired
    InterpretationApproverSequence: 0x40080111, // retired
    InterpretationApprovalDate: 0x40080112, // retired
    InterpretationApprovalTime: 0x40080113, // retired
    PhysicianApprovingInterpretation: 0x40080114, // retired
    InterpretationDiagnosisDescription: 0x40080115, // retired
    InterpretationDiagnosisCodeSequence: 0x40080117, // retired
    ResultsDistributionListSequence: 0x40080118, // retired
    DistributionName: 0x40080119, // retired
    DistributionAddress: 0x4008011a, // retired
    InterpretationID: 0x40080200, // retired
    InterpretationIDIssuer: 0x40080202, // retired
    InterpretationTypeID: 0x40080210, // retired
    InterpretationStatusID: 0x40080212, // retired
    Impressions: 0x40080300, // retired
    ResultsComments: 0x40084000, // retired
    LowEnergyDetectors: 0x40100001,
    HighEnergyDetectors: 0x40100002,
    DetectorGeometrySequence: 0x40100004,
    ThreatROIVoxelSequence: 0x40101001,
    ThreatROIBase: 0x40101004,
    ThreatROIExtents: 0x40101005,
    ThreatROIBitmap: 0x40101006,
    RouteSegmentID: 0x40101007,
    GantryType: 0x40101008,
    OOIOwnerType: 0x40101009,
    RouteSegmentSequence: 0x4010100a,
    PotentialThreatObjectID: 0x40101010,
    ThreatSequence: 0x40101011,
    ThreatCategory: 0x40101012,
    ThreatCategoryDescription: 0x40101013,
    ATDAbilityAssessment: 0x40101014,
    ATDAssessmentFlag: 0x40101015,
    ATDAssessmentProbability: 0x40101016,
    Mass: 0x40101017,
    Density: 0x40101018,
    ZEffective: 0x40101019,
    BoardingPassID: 0x4010101a,
    CenterOfMass: 0x4010101b,
    CenterOfPTO: 0x4010101c,
    BoundingPolygon: 0x4010101d,
    RouteSegmentStartLocationID: 0x4010101e,
    RouteSegmentEndLocationID: 0x4010101f,
    RouteSegmentLocationIDType: 0x40101020,
    AbortReason: 0x40101021,
    VolumeOfPTO: 0x40101023,
    AbortFlag: 0x40101024,
    RouteSegmentStartTime: 0x40101025,
    RouteSegmentEndTime: 0x40101026,
    TDRType: 0x40101027,
    InternationalRouteSegment: 0x40101028,
    ThreatDetectionAlgorithmandVersion: 0x40101029,
    AssignedLocation: 0x4010102a,
    AlarmDecisionTime: 0x4010102b,
    AlarmDecision: 0x40101031,
    NumberOfTotalObjects: 0x40101033,
    NumberOfAlarmObjects: 0x40101034,
    PTORepresentationSequence: 0x40101037,
    ATDAssessmentSequence: 0x40101038,
    TIPType: 0x40101039,
    DICOSVersion: 0x4010103a,
    OOIOwnerCreationTime: 0x40101041,
    OOIType: 0x40101042,
    OOISize: 0x40101043,
    AcquisitionStatus: 0x40101044,
    BasisMaterialsCodeSequence: 0x40101045,
    PhantomType: 0x40101046,
    OOIOwnerSequence: 0x40101047,
    ScanType: 0x40101048,
    ItineraryID: 0x40101051,
    ItineraryIDType: 0x40101052,
    ItineraryIDAssigningAuthority: 0x40101053,
    RouteID: 0x40101054,
    RouteIDAssigningAuthority: 0x40101055,
    InboundArrivalType: 0x40101056,
    CarrierID: 0x40101058,
    CarrierIDAssigningAuthority: 0x40101059,
    SourceOrientation: 0x40101060,
    SourcePosition: 0x40101061,
    BeltHeight: 0x40101062,
    AlgorithmRoutingCodeSequence: 0x40101064,
    TransportClassification: 0x40101067,
    OOITypeDescriptor: 0x40101068,
    TotalProcessingTime: 0x40101069,
    DetectorCalibrationData: 0x4010106c,
    AdditionalScreeningPerformed: 0x4010106d,
    AdditionalInspectionSelectionCriteria: 0x4010106e,
    AdditionalInspectionMethodSequence: 0x4010106f,
    AITDeviceType: 0x40101070,
    QRMeasurementsSequence: 0x40101071,
    TargetMaterialSequence: 0x40101072,
    SNRThreshold: 0x40101073,
    ImageScaleRepresentation: 0x40101075,
    ReferencedPTOSequence: 0x40101076,
    ReferencedTDRInstanceSequence: 0x40101077,
    PTOLocationDescription: 0x40101078,
    AnomalyLocatorIndicatorSequence: 0x40101079,
    AnomalyLocatorIndicator: 0x4010107a,
    PTORegionSequence: 0x4010107b,
    InspectionSelectionCriteria: 0x4010107c,
    SecondaryInspectionMethodSequence: 0x4010107d,
    PRCSToRCSOrientation: 0x4010107e,
    MACParametersSequence: 0x4ffe0001,
    CurveDimensions: 0x50000005, // retired
    NumberOfPoints: 0x50000010, // retired
    TypeOfData: 0x50000020, // retired
    CurveDescription: 0x50000022, // retired
    AxisUnits: 0x50000030, // retired
    AxisLabels: 0x50000040, // retired
    DataValueRepresentation: 0x50000103, // retired
    MinimumCoordinateValue: 0x50000104, // retired
    MaximumCoordinateValue: 0x50000105, // retired
    CurveRange: 0x50000106, // retired
    CurveDataDescriptor: 0x50000110, // retired
    CoordinateStartValue: 0x50000112, // retired
    CoordinateStepValue: 0x50000114, // retired
    CurveActivationLayer: 0x50001001, // retired
    AudioType: 0x50002000, // retired
    AudioSampleFormat: 0x50002002, // retired
    NumberOfChannels: 0x50002004, // retired
    NumberOfSamples: 0x50002006, // retired
    SampleRate: 0x50002008, // retired
    TotalTime: 0x5000200a, // retired
    AudioSampleData: 0x5000200c, // retired
    AudioComments: 0x5000200e, // retired
    CurveLabel: 0x50002500, // retired
    CurveReferencedOverlaySequence: 0x50002600, // retired
    CurveReferencedOverlayGroup: 0x50002610, // retired
    CurveData: 0x50003000, // retired
    SharedFunctionalGroupsSequence: 0x52009229,
    PerFrameFunctionalGroupsSequence: 0x52009230,
    WaveformSequence: 0x54000100,
    ChannelMinimumValue: 0x54000110,
    ChannelMaximumValue: 0x54000112,
    WaveformBitsAllocated: 0x54001004,
    WaveformSampleInterpretation: 0x54001006,
    WaveformPaddingValue: 0x5400100a,
    WaveformData: 0x54001010,
    FirstOrderPhaseCorrectionAngle: 0x56000010,
    SpectroscopyData: 0x56000020,
    OverlayRows: 0x60000010,
    OverlayColumns: 0x60000011,
    OverlayPlanes: 0x60000012, // retired
    NumberOfFramesInOverlay: 0x60000015,
    OverlayDescription: 0x60000022,
    OverlayType: 0x60000040,
    OverlaySubtype: 0x60000045,
    OverlayOrigin: 0x60000050,
    ImageFrameOrigin: 0x60000051,
    OverlayPlaneOrigin: 0x60000052, // retired
    OverlayCompressionCode: 0x60000060, // retired
    OverlayCompressionOriginator: 0x60000061, // retired
    OverlayCompressionLabel: 0x60000062, // retired
    OverlayCompressionDescription: 0x60000063, // retired
    OverlayCompressionStepPointers: 0x60000066, // retired
    OverlayRepeatInterval: 0x60000068, // retired
    OverlayBitsGrouped: 0x60000069, // retired
    OverlayBitsAllocated: 0x60000100,
    OverlayBitPosition: 0x60000102,
    OverlayFormat: 0x60000110, // retired
    OverlayLocation: 0x60000200, // retired
    OverlayCodeLabel: 0x60000800, // retired
    OverlayNumberOfTables: 0x60000802, // retired
    OverlayCodeTableLocation: 0x60000803, // retired
    OverlayBitsForCodeWord: 0x60000804, // retired
    OverlayActivationLayer: 0x60001001,
    OverlayDescriptorGray: 0x60001100, // retired
    OverlayDescriptorRed: 0x60001101, // retired
    OverlayDescriptorGreen: 0x60001102, // retired
    OverlayDescriptorBlue: 0x60001103, // retired
    OverlaysGray: 0x60001200, // retired
    OverlaysRed: 0x60001201, // retired
    OverlaysGreen: 0x60001202, // retired
    OverlaysBlue: 0x60001203, // retired
    ROIArea: 0x60001301,
    ROIMean: 0x60001302,
    ROIStandardDeviation: 0x60001303,
    OverlayLabel: 0x60001500,
    OverlayData: 0x60003000,
    OverlayComments: 0x60004000, // retired
    FloatPixelData: 0x7fe00008,
    DoubleFloatPixelData: 0x7fe00009,
    PixelData: 0x7fe00010,
    CoefficientsSDVN: 0x7fe00020, // retired
    CoefficientsSDHN: 0x7fe00030, // retired
    CoefficientsSDDN: 0x7fe00040, // retired
    VariablePixelData: 0x7f000010, // retired
    VariableNextDataGroup: 0x7f000011, // retired
    VariableCoefficientsSDVN: 0x7f000020, // retired
    VariableCoefficientsSDHN: 0x7f000030, // retired
    VariableCoefficientsSDDN: 0x7f000040, // retired
    DigitalSignaturesSequence: 0xfffafffa,
    DataSetTrailingPadding: 0xfffcfffc,
    Item: 0xfffee000,
    ItemDelimitationItem: 0xfffee00d,
    SequenceDelimitationItem: 0xfffee0dd,

    // private tags
    PhilipsSUVScaleFactor: 0x70531000,
    PhilipsActivityConcentrationFactor: 0x70531009,
    PhilipsCreatorDataElements: 0x70530010,
};
